var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path0, _g5, _path1, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g0, _path14, _g1, _path15, _g10, _path16, _g11, _path17, _g12, _path18, _g13, _path19, _g14, _path20, _g15, _path21, _g16, _path22, _g17, _path23, _g18, _path24, _g19, _path25, _g20, _path26, _g21, _path27, _g22, _path28, _g23, _path29, _g24, _path30, _g25, _path31, _g26, _path32, _g27, _path33, _g28, _path34, _g29, _path35, _path36, _g30, _path37, _g31, _path38, _g32, _path39, _g33, _path40, _g34, _path41, _g35, _path42, _g36, _path43, _g37, _path44, _g38, _path45, _g39, _path46, _g40, _path47, _g41, _path48, _g42, _path49, _g43, _path50, _g44, _path51, _g45, _path52, _g46, _path53, _g47, _path54, _g48, _path55, _g49, _path56, _g50, _path57, _g51, _path58, _g52, _path59, _g53, _path60, _g54, _path61, _g55, _path62, _g56, _path63, _g57, _path64, _g58, _path65, _g59, _path66, _g60, _path67, _path68, _g61, _path69, _g62, _path70, _g63, _path71, _g64, _path72, _g65, _path73, _g66, _path74, _g67, _path75, _g68, _path76, _g69, _path77, _g70, _path78, _g71, _path79, _g72, _path80, _g73, _path81, _g74, _path82, _g75, _path83, _g76, _path84, _g77, _path85, _g78, _path86, _g79, _path87, _g80, _path88, _g81, _path89, _g82, _path90, _g83, _path91, _g84, _path92, _g85, _path93, _g86, _path94, _g87, _path95, _g88, _path96, _g89, _path97, _g90, _path98, _g91, _path99, _path100, _g92, _path101, _g93, _path102, _g94, _path103, _g95, _path104, _g96, _path105, _g97, _path106, _g98, _path107, _g99, _path108, _g100, _path109, _g101, _path110, _g102, _path111, _g103, _path112, _g104, _path113, _g105, _path114, _g106, _path115, _g107, _path116, _g108, _path117, _g109, _path118, _g110, _path119, _g111, _path120, _g112, _path121, _g113, _path122, _g114, _path123, _g115, _path124, _g116, _path125, _g117, _path126, _g118, _path127, _g119, _path128, _g120, _path129, _g121, _path130, _g122, _path131, _path132, _g123, _path133, _g124, _path134, _g125, _path135, _g126, _path136, _g127, _path137, _g128, _path138, _g129, _path139, _g130, _path140, _g131, _path141, _g132, _path142, _g133, _path143, _g134, _path144, _g135, _path145, _g136, _path146, _g137, _path147, _g138, _path148, _g139, _path149, _g140, _path150, _g141, _path151, _g142, _path152, _g143, _path153, _g144, _path154, _g145, _path155, _g146, _path156, _g147, _path157, _g148, _path158, _g149, _path159, _g150, _path160, _g151, _path161, _g152, _path162, _g153, _path163, _path164, _path165, _g154, _path166, _g155, _path167, _path168, _g156, _path169, _g157, _path170, _g158, _path171, _g159, _path172, _g160, _path173, _g161, _path174, _g162, _path175, _g163, _path176, _g164, _path177, _g165, _path178, _g166, _path179, _g167, _path180, _g168, _path181, _g169, _path182, _g170, _path183, _g171, _path184, _g172, _path185, _g173, _path186, _g174, _path187, _g175, _path188, _g176, _path189, _g177, _path190, _g178, _path191, _g179, _path192, _g180, _path193, _g181, _path194, _g182, _path195, _g183, _path196, _g184, _path197, _g185, _path198, _g186, _path199, _path200, _g187, _path201, _g188, _path202, _g189, _path203, _g190, _path204, _g191, _path205, _g192, _path206, _g193, _path207, _g194, _path208, _g195, _path209, _g196, _path210, _g197, _path211, _g198, _path212, _g199, _path213, _g200, _path214, _g201, _path215, _g202, _path216, _g203, _path217, _g204, _path218, _g205, _path219, _g206, _path220, _g207, _path221, _g208, _path222, _g209, _path223, _g210, _path224, _g211, _path225, _g212, _path226, _g213, _path227, _g214, _path228, _g215, _path229, _g216, _path230, _g217, _path231, _g218, _path232, _g219, _path233, _g220, _path234, _g221, _path235, _g222, _path236, _g223, _path237, _g224, _path238, _g225, _path239, _g226, _path240, _g227, _path241, _g228, _path242, _g229, _path243, _g230, _path244, _g231, _path245, _g232, _path246, _g233, _path247, _g234, _path248, _g235, _path249, _g236, _path250, _g237, _path251, _g238, _path252, _g239, _path253, _g240, _path254, _g241, _path255, _g242, _path256, _g243, _path257, _g244, _path258, _g245, _path259, _g246, _path260, _g247, _path261, _g248, _path262, _g249, _path263, _g250, _path264, _g251, _path265, _g252, _path266, _g253, _path267, _g254, _path268, _g255, _path269, _g256, _path270, _g257, _path271, _g258, _path272, _g259, _path273, _g260, _path274, _g261, _path275, _g262, _path276, _g263, _path277, _g264, _path278, _g265, _path279, _g266, _path280, _g267, _path281, _g268, _path282, _g269, _path283, _g270, _path284, _g271, _path285, _g272, _path286, _g273, _path287, _g274, _path288, _g275, _path289, _g276, _path290, _g277, _path291, _g278, _path292, _g279, _path293, _g280, _path294, _g281, _path295, _g282, _path296, _g283, _path297, _g284, _path298, _g285, _path299, _g286, _path300, _g287, _path301, _g288, _path302, _g289, _path303, _g290, _path304, _g291, _path305, _g292, _path306, _g293, _path307, _g294, _path308, _g295, _path309, _g296, _path310, _g297, _path311, _g298, _path312, _g299, _path313, _g300, _path314, _g301, _path315, _g302, _path316, _g303, _path317, _g304, _path318, _g305, _path319, _g306, _path320, _g307, _path321, _g308, _path322, _g309, _path323, _g310, _path324, _path325, _g311, _path326, _g312, _path327, _g313, _path328, _g314, _path329, _g315, _path330, _g316, _path331, _g317, _path332, _g318, _path333, _g319, _path334, _g320, _path335, _g321, _path336, _g322, _path337, _g323, _path338, _g324, _path339, _g325, _path340, _g326, _path341, _g327, _path342, _g328, _path343, _g329, _path344, _g330, _path345, _g331, _path346, _g332, _path347, _g333, _path348, _g334, _path349, _g335, _path350, _g336, _path351, _g337, _path352, _g338, _path353, _g339, _path354, _g340, _path355, _g341, _path356, _path357, _g342, _path358, _g343, _path359, _g344, _path360, _g345, _path361, _g346, _path362, _g347, _path363, _g348, _path364, _g349, _path365, _g350, _path366, _g351, _path367, _g352, _path368, _g353, _path369, _g354, _path370, _g355, _path371, _g356, _path372, _g357, _path373, _g358, _path374, _g359, _path375, _g360, _path376, _g361, _path377, _g362, _path378, _g363, _path379, _g364, _path380, _g365, _path381, _g366, _path382, _g367, _path383, _g368, _path384, _g369, _path385, _g370, _path386, _g371, _path387, _g372, _path388, _path389, _g373, _path390, _g374, _path391, _g375, _path392, _g376, _path393, _g377, _path394, _g378, _path395, _g379, _path396, _g380, _path397, _g381, _path398, _g382, _path399, _g383, _path400, _g384, _path401, _g385, _path402, _g386, _path403, _g387, _path404, _g388, _path405, _g389, _path406, _g390, _path407, _g391, _path408, _g392, _path409, _g393, _path410, _g394, _path411, _g395, _path412, _g396, _path413, _g397, _path414, _g398, _path415, _g399, _path416, _g400, _path417, _g401, _path418, _g402, _path419, _g403, _path420, _path421, _g404, _path422, _g405, _path423, _g406, _path424, _g407, _path425, _g408, _path426, _g409, _path427, _g410, _path428, _g411, _path429, _g412, _path430, _g413, _path431, _g414, _path432, _g415, _path433, _g416, _path434, _g417, _path435, _g418, _path436, _g419, _path437, _g420, _path438, _g421, _path439, _g422, _path440, _g423, _path441, _g424, _path442, _g425, _path443, _g426, _path444, _g427, _path445, _g428, _path446, _g429, _path447, _g430, _path448, _g431, _path449, _g432, _path450, _g433, _path451, _g434, _path452, _path453, _g435, _path454, _g436, _path455, _g437, _path456, _g438, _path457, _g439, _path458, _g440, _path459, _g441, _path460, _g442, _path461, _g443, _path462, _g444, _path463, _g445, _path464, _g446, _path465, _g447, _path466, _g448, _path467, _g449, _path468, _g450, _path469, _g451, _path470, _g452, _path471, _g453, _path472, _g454, _path473, _g455, _path474, _g456, _path475, _g457, _path476, _g458, _path477, _g459, _path478, _g460, _path479, _g461, _path480, _g462, _path481, _g463, _path482, _g464, _path483, _g465, _path484, _path485, _g466, _path486, _g467, _path487, _g468, _path488, _g469, _path489, _g470, _path490, _g471, _path491, _g472, _path492, _g473, _path493, _g474, _path494, _g475, _path495, _g476, _path496, _g477, _path497, _g478, _path498, _g479, _path499, _g480, _path500, _g481, _path501, _g482, _path502, _g483, _path503, _g484, _path504, _g485, _path505, _g486, _path506, _g487, _path507, _g488, _path508, _g489, _path509, _g490, _path510, _g491, _path511, _g492, _path512, _g493, _path513, _g494, _path514, _g495, _path515, _g496, _path516, _path517, _path518, _path519, _path520, _path521, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankSh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2134 7.23046L18.0733 5.50754C18.0733 5.50754 18.1971 5.34297 17.2134 4.97409C16.2282 4.6049 12.9056 3.90785 10.732 5.87646C8.5577 7.84475 9.74684 10.1428 10.732 10.9217C11.7097 11.6963 13.7459 12.7707 13.7459 14.2831C13.7459 15.4882 12.87 16.1425 12.87 16.1425C14.0594 15.4457 16.258 14.2027 15.4494 11.7837C14.8293 9.9301 12.7827 9.52729 12.2502 8.29772C11.7164 7.06658 13.4529 5.18326 15.9825 5.91754C17.2538 6.28576 17.2133 7.23041 17.2133 7.23041",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7305 10.9198C11.7078 11.6945 13.7444 12.7688 13.7444 14.2813C13.7444 15.4862 12.8685 16.1406 12.8685 16.1406C14.058 15.4439 16.2562 14.2011 15.4476 11.7818C14.8275 9.92789 12.7812 9.52538 12.2487 8.2955L10.7305 10.9198Z",
    fill: "url(#paint0_linear_10834_56546)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2056 16.7056C12.2056 16.7056 10.9292 16.8382 9.90785 16.4544C8.04946 15.7515 7.49111 13.7645 7.5936 12.3167L6 15.801C6 15.801 7.54122 18.241 10.1545 18.4282C12.3627 18.5854 13.9043 17.9995 15.1532 16.6507C15.9851 15.7509 17.58 12.9724 16.924 12.3978C16.0207 14.4492 14.6259 16.2624 12.2056 16.7056Z",
    fill: "#0071BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4702 8.86701C22.8957 8.76872 21.1643 9.72217 20.1356 10.4098C20.1356 10.4098 21.7398 6.61483 22.0599 5.94331C22.379 5.2718 22.2617 4.78392 21.3289 4.78392H19.3874C20.0444 5.24302 19.6057 6.22492 19.6057 6.22492C15.2116 16.2155 15.6946 15.1153 14.9419 16.8489C14.272 18.3937 16.0211 18.3436 16.0211 18.3436H17.6609C17.6609 18.3436 16.9943 18.0031 17.25 17.277C17.3037 17.1273 17.8148 15.7949 17.8148 15.7949C20.2878 10.7878 22.9736 10.4043 23.2807 11.0823C23.8401 12.3222 22.12 15.6805 21.7081 16.8486H21.7075C21.0373 18.394 22.7864 18.3436 22.7864 18.3436H24.4246C24.4246 18.3436 23.8038 18.0031 24.0602 17.277C24.1585 16.9966 25.1886 14.0245 25.2904 13.7079C25.9881 11.533 26.7537 9.01088 24.4702 8.86701Z",
    fill: "#0071BC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53125 4.54819H17.314V10.3594H9.53125V4.54819Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54297 4.55311H17.2937V10.3203H9.54297V4.55311Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1293 5.35824C17.1367 5.35985 17.4862 5.0692 17.1429 4.96445C16.8005 4.86002 14.6256 4.13483 12.4184 4.89913C10.1503 5.68316 9.30649 7.59037 9.59876 8.99031C9.86937 10.2897 11.5425 11.15 10.8852 9.06532C10.6718 8.38636 11.098 6.12675 13.2851 5.51019C15.1865 4.97253 17.1222 5.35662 17.1293 5.35824Z",
    fill: "url(#paint1_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55078 4.5655H17.2698V10.2891H9.55078V4.5655Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1087 5.35185C17.1235 5.35508 17.4585 5.07088 17.1158 4.96742C16.7737 4.86428 14.5998 4.1446 12.3961 4.92378C10.1339 5.72236 9.31657 7.63151 9.60723 9.00137C9.87719 10.2733 11.4905 11.0864 10.8536 9.06312C10.6454 8.39871 11.0547 6.15236 13.239 5.51576C15.1436 4.9574 17.0938 5.34829 17.1087 5.35185Z",
    fill: "url(#paint2_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 4.57041H17.2499V10.25H9.5625V4.57041Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0922 5.33722C17.1145 5.34207 17.4352 5.06434 17.0928 4.9625C16.7511 4.86066 14.5781 4.14679 12.3783 4.94084C10.1219 5.75332 9.33079 7.66505 9.61951 9.0042C9.8885 10.2493 11.443 11.0149 10.8258 9.0527C10.6231 8.40317 11.0159 6.16974 13.1966 5.51342C15.1051 4.93405 17.0699 5.33238 17.0922 5.33722Z",
    fill: "url(#paint3_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57031 4.5828H17.2266V10.2188H9.57031V4.5828Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0755 5.33116C17.1053 5.33763 17.4121 5.06573 17.0697 4.96518C16.7283 4.86495 14.5563 4.15657 12.3604 4.96549C10.1095 5.79252 9.34484 7.70653 9.63194 9.01496C9.89996 10.2329 11.3946 10.9509 10.7981 9.05052C10.6009 8.41522 10.9766 6.19472 13.1544 5.519C15.0661 4.91894 17.0458 5.32437 17.0755 5.33116Z",
    fill: "url(#paint4_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 4.58674H17.207V10.1797H9.58203V4.58674Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.055 5.31635C17.0921 5.32476 17.3844 5.05931 17.0427 4.96006C16.7019 4.8608 14.5306 4.15825 12.3382 4.98237C10.0934 5.82362 9.355 7.73989 9.64048 9.01793C9.90754 10.2087 11.3427 10.8792 10.7666 9.03992C10.5745 8.41948 10.9334 6.21224 13.108 5.51648C15.0236 4.8954 17.0178 5.30827 17.055 5.31635Z",
    fill: "url(#paint5_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 4.58971H17.1873V10.1406H9.59375V4.58971Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0384 5.30132C17.0827 5.31102 17.361 5.05206 17.0199 4.95409C16.6792 4.85645 14.5088 4.15939 12.32 4.99838C10.081 5.85419 9.36912 7.77239 9.65298 9.02004C9.91907 10.1836 11.2902 10.8083 10.7387 9.0291C10.5508 8.42354 10.8958 6.23375 13.0658 5.51341C14.9863 4.87585 16.9937 5.29162 17.0384 5.30132Z",
    fill: "url(#paint6_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60156 4.60081H17.1644V10.1094H9.60156V4.60081Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0179 5.29447C17.0696 5.30611 17.3338 5.05296 16.9927 4.95661C16.6525 4.86027 14.4831 4.16902 12.2982 5.02289C10.0651 5.89292 9.37935 7.81338 9.6616 9.03064C9.92671 10.1671 11.2381 10.7442 10.7072 9.02611C10.5245 8.43542 10.8533 6.2589 13.0195 5.51852C14.9438 4.86058 16.9658 5.28283 17.0179 5.29447Z",
    fill: "url(#paint7_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61328 4.61191H17.1454V10.0781H9.61328V4.61191Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0016 5.28747C17.0607 5.3004 17.3106 5.05403 16.9702 4.95898C16.6301 4.86361 14.4613 4.17819 12.2806 5.04692C10.053 5.93118 9.39375 7.8539 9.67406 9.04077C9.93853 10.1504 11.1897 10.68 10.6796 9.02332C10.5021 8.44718 10.8144 6.28455 12.9776 5.52348C14.9055 4.84518 16.9421 5.27422 17.0016 5.28747Z",
    fill: "url(#paint8_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62109 4.61488H17.1225V10.0391H9.62109V4.61488Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.981 5.27248C17.0476 5.28703 17.2833 5.04681 16.9431 4.95305C16.6033 4.85929 14.4355 4.17937 12.2584 5.0633C10.0369 5.96178 9.40386 7.88677 9.68288 9.04325C9.94605 10.1254 11.1374 10.6081 10.648 9.01254C10.4756 8.45095 10.7718 6.30157 12.9312 5.52046C14.863 4.82146 16.914 5.2576 16.981 5.27248Z",
    fill: "url(#paint9_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 4.62566H17.1042V10.0078H9.63281V4.62566Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9647 5.26495C17.0388 5.28144 17.2602 5.04769 16.9204 4.95523C16.5813 4.86276 14.4141 4.18833 12.2408 5.08713C10.0249 5.99984 9.41834 7.92742 9.69542 9.05318C9.95795 10.1085 11.0892 10.5436 10.6207 9.00922C10.4533 8.4625 10.7329 6.32639 12.8891 5.52522C14.8247 4.80553 16.8904 5.24846 16.9647 5.26495Z",
    fill: "url(#paint10_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 6
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64062 4.63547H17.0819V9.97656H9.64062V4.63547Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9441 5.25763C17.0256 5.27541 17.2331 5.04813 16.894 4.95695C16.5548 4.8661 14.3886 4.19717 12.2189 5.11117C10.0091 6.0381 9.42875 7.96794 9.70421 9.06332C9.96576 10.0911 11.0372 10.4791 10.5891 9.00609C10.4271 8.4736 10.6903 6.35107 12.8432 5.52954C14.7824 4.7898 16.8626 5.23953 16.9441 5.25763Z",
    fill: "url(#paint11_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65234 4.63811H17.0636V9.9375H9.65234V4.63811Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9278 5.24224C17.0167 5.26229 17.21 5.0405 16.8712 4.95094C16.5324 4.86106 14.3671 4.19794 12.2013 5.12681C9.99696 6.06829 9.44312 8.00007 9.71697 9.06506C9.97756 10.066 10.9892 10.4065 10.5618 8.99491C10.405 8.47696 10.6517 6.36768 12.801 5.52611C14.7441 4.76568 16.8388 5.22252 16.9278 5.24224Z",
    fill: "url(#paint12_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66016 4.64761H17.0417V9.90625H9.66016V4.64761Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9076 5.23463C17.0039 5.25596 17.183 5.04065 16.8445 4.95271C16.506 4.86412 14.3418 4.20683 12.1798 5.15057C9.98127 6.10628 9.45363 8.04032 9.72586 9.07459C9.98548 10.0484 10.9373 10.3416 10.5306 8.99117C10.3786 8.4881 10.6088 6.39176 12.755 5.53046C14.7019 4.74934 16.8112 5.21329 16.9076 5.23463Z",
    fill: "url(#paint13_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 6
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67188 4.64864H17.0243V9.86719H9.67188V4.64864Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8915 5.2188C16.9953 5.24175 17.1602 5.03289 16.822 4.94592C16.4838 4.85895 14.3206 4.20716 12.1621 5.16577C9.96944 6.1357 9.46831 8.07233 9.7386 9.07621C9.99757 10.0229 10.8896 10.2686 10.5032 8.97954C10.3568 8.49102 10.5705 6.40793 12.7134 5.52659C14.6639 4.72478 16.7877 5.19584 16.8915 5.2188Z",
    fill: "url(#paint14_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 9,
    height: 6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67969 4.65716H17.0036V9.83594H9.67969V4.65716Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8721 5.21057C16.9833 5.23514 17.1337 5.03243 16.7961 4.94707C16.4586 4.86107 14.296 4.21509 12.1414 5.18858C9.95454 6.17306 9.47766 8.11227 9.74827 9.08511C10.0043 10.0053 10.8385 10.2028 10.4728 8.97552C10.3315 8.50154 10.5287 6.43138 12.6681 5.53032C14.6222 4.70749 16.7609 5.186 16.8721 5.21057Z",
    fill: "url(#paint15_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69141 4.66599H16.9863V9.80469H9.69141V4.66599Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.856 5.20205C16.9743 5.22823 17.1108 5.03166 16.7736 4.9476C16.436 4.86322 14.2747 4.22275 12.1237 5.21143C9.94265 6.21013 9.49228 8.1516 9.76128 9.09405C10.0164 9.98671 10.7904 10.1374 10.4454 8.97088C10.3096 8.51145 10.49 6.45455 12.6265 5.53376C14.5841 4.68992 16.7373 5.17586 16.856 5.20205Z",
    fill: "url(#paint16_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69922 4.67387H16.9653V9.77344H9.69922V4.67387Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8361 5.19301C16.9618 5.22081 17.0841 5.03071 16.7475 4.94826C16.4103 4.86517 14.2496 4.23019 12.1022 5.23375C9.92693 6.247 9.50307 8.19042 9.77045 9.10248C10.0242 9.9683 10.7391 10.0711 10.4145 8.96636C10.2835 8.52148 10.4475 6.47719 12.5807 5.53701C14.5422 4.67247 16.7097 5.16488 16.8361 5.19301Z",
    fill: "url(#paint17_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71094 4.68141H16.9486V9.74219H9.71094V4.68141Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8202 5.18376C16.9534 5.21318 17.0614 5.02954 16.7252 4.94806C16.3883 4.86659 14.2286 4.23743 12.085 5.25585C9.91559 6.28333 9.5176 8.22902 9.78369 9.11069C10.0365 9.94935 10.6915 10.0046 10.3873 8.96131C10.2619 8.53099 10.409 6.49963 12.5393 5.53972C14.5043 4.65417 16.6864 5.15401 16.8202 5.18376Z",
    fill: "url(#paint18_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71875 4.6805H16.9286V9.70312H9.71875V4.6805Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8003 5.16635C16.941 5.19706 17.0347 5.01989 16.6988 4.94004C16.3622 4.85953 14.2032 4.23618 12.0638 5.26948C9.89991 6.31119 9.52875 8.25946 9.79289 9.11041C10.0447 9.92224 10.6403 9.93001 10.3564 8.94779C10.2361 8.53234 10.3668 6.51391 12.4935 5.53428C14.4621 4.62771 16.659 5.13499 16.8003 5.16635Z",
    fill: "url(#paint19_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72656 4.68675H16.9083V9.67188H9.72656V4.68675Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7845 5.15647C16.9323 5.18945 17.0121 5.0181 16.6765 4.93921C16.3403 4.86032 14.1825 4.24248 12.0464 5.29097C9.88862 6.34691 9.54365 8.29744 9.80618 9.11768C10.0571 9.90235 10.5934 9.86258 10.3296 8.94212C10.2145 8.54089 10.328 6.53507 12.4518 5.53637C14.424 4.60847 16.6358 5.12382 16.7845 5.15647Z",
    fill: "url(#paint20_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73828 4.69268H16.8922V9.64062H9.73828V4.69268Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7648 5.14575C16.9203 5.18035 16.9859 5.01513 16.6506 4.93786C16.3147 4.86027 14.1576 4.24792 12.0257 5.31129C9.87339 6.38177 9.55493 8.33424 9.81552 9.12441C10.0658 9.88193 10.5426 9.79463 10.2989 8.93559C10.1893 8.54891 10.2863 6.55571 12.4069 5.53761C14.3826 4.58869 16.6089 5.11148 16.7648 5.14575Z",
    fill: "url(#paint21_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74609 4.697H16.8728V9.60938H9.74609V4.697Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7452 5.13456C16.9082 5.17077 16.9596 5.01203 16.6249 4.93606C16.2894 4.85943 14.1332 4.2529 12.0045 5.33146C9.85838 6.41585 9.56611 8.37123 9.82508 9.13036C10.074 9.86104 10.4921 9.7259 10.2683 8.92829C10.1639 8.55616 10.2438 6.57621 12.3614 5.53806C14.3408 4.56813 16.5816 5.09835 16.7452 5.13456Z",
    fill: "url(#paint22_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75391 4.70163H16.8532V9.57812H9.75391V4.70163Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7258 5.13039C16.8958 5.16789 16.9333 5.01561 16.599 4.94093C16.2638 4.86592 14.1083 4.26489 11.9838 5.35833C9.84347 6.45726 9.57738 8.41457 9.83473 9.14364C10.083 9.84684 10.4416 9.6645 10.2379 8.92832C10.139 8.57074 10.2017 6.60307 12.3161 5.54584C14.299 4.55457 16.5547 5.09256 16.7258 5.13039Z",
    fill: "url(#paint23_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 4.70433H16.838V9.54688H9.76562V4.70433Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7104 5.10975C16.8879 5.14888 16.9112 5.00274 16.5772 4.92967C16.2422 4.85595 14.0877 4.26074 11.9671 5.36905C9.83227 6.48221 9.59269 8.44179 9.84843 9.14014C10.0958 9.81651 10.3952 9.5863 10.2112 8.91188C10.1178 8.56885 10.1637 6.61379 12.2752 5.53717C14.2613 4.52456 16.5322 5.07031 16.7104 5.10975Z",
    fill: "url(#paint24_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77344 4.71387H16.819V9.52344H9.77344V4.71387Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6911 5.10353C16.8761 5.14459 16.8848 5.00459 16.5515 4.93282C16.2169 4.8604 14.0633 4.271 11.9462 5.39418C9.81757 6.52189 9.60419 8.48374 9.85831 9.1517C10.1047 9.80058 10.3455 9.52285 10.181 8.90986C10.093 8.5817 10.1215 6.63925 12.2301 5.54323C14.2198 4.50928 16.5056 5.06247 16.6911 5.10353Z",
    fill: "url(#paint25_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78516 4.72245H16.8042V9.5H9.78516V4.72245Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6759 5.09641C16.8682 5.13844 16.8627 5.00556 16.5297 4.93508C16.1954 4.86395 14.0428 4.28005 11.9293 5.41843C9.80649 6.56004 9.61994 8.52415 9.87212 9.16172C10.1178 9.78377 10.2992 9.45819 10.1544 8.90695C10.0719 8.59302 10.0816 6.65929 12.1893 5.54808C14.1799 4.48923 16.4828 5.05341 16.6759 5.09641Z",
    fill: "url(#paint26_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79297 4.72158H16.7855V9.46875H9.79297V4.72158Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6531 5.08037C16.8529 5.12402 16.8332 4.99728 16.5009 4.92842C16.1669 4.85858 14.0149 4.28018 11.9053 5.43343C9.78828 6.58959 9.62793 8.55563 9.87817 9.16313C10.1232 9.7577 10.2461 9.38428 10.1207 8.89512C10.044 8.59541 10.0363 6.67526 12.1407 5.544C14.1352 4.46414 16.4527 5.03576 16.6531 5.08037Z",
    fill: "url(#paint27_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80078 4.72757H16.7675V9.44531H9.80078V4.72757Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.638 5.07061C16.8449 5.11652 16.8113 4.99527 16.4792 4.9277C16.1456 4.85948 13.9946 4.28658 11.8885 5.45502C9.77733 6.62541 9.64413 8.59372 9.89211 9.17051C10.1365 9.73824 10.2009 9.31696 10.0945 8.88922C10.0234 8.60406 9.99847 6.69685 12.1 5.54619C14.0977 4.44564 16.4298 5.0247 16.638 5.07061Z",
    fill: "url(#paint28_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80859 4.73162H16.7494V9.42188H9.80859V4.73162Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6193 5.05944C16.8336 5.10664 16.7858 4.99187 16.4541 4.92591C16.1207 4.85866 13.9707 4.2919 11.8685 5.47489C9.76315 6.65983 9.65614 8.63008 9.9025 9.17648C10.146 9.71705 10.1521 9.24825 10.0645 8.88226C9.99982 8.61165 9.95746 6.71737 12.0554 5.54699C14.057 4.42543 16.4036 5.01191 16.6193 5.05944Z",
    fill: "url(#paint29_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 4.73404H16.7349V9.39844H9.82031V4.73404Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6041 5.04673C16.8259 5.09587 16.7638 4.98724 16.4325 4.92258C16.0994 4.85662 13.9504 4.29535 11.8521 5.49354C9.75221 6.69238 9.673 8.6649 9.91646 9.18122C10.1602 9.69399 10.1075 9.17767 10.0383 8.87376C9.97983 8.61705 9.91969 6.73667 12.0147 5.54624C14.0196 4.40398 16.381 4.99726 16.6041 5.04673Z",
    fill: "url(#paint30_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 8,
    height: 6
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82422 4.74201H16.7136V9.38281H9.82422V4.74201Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.404 4.92494C16.071 4.8606 13.9229 4.30483 11.8282 5.51789C9.73444 6.73128 9.68142 8.70573 9.92325 9.19166C10.1661 9.67727 10.0558 9.11311 10.005 8.87095C9.95332 8.62879 9.87476 6.76167 11.9666 5.55152C13.9753 4.38825 16.3513 4.98831 16.5815 5.04004C16.8111 5.09016 16.7348 4.98831 16.404 4.92494Z",
    fill: "url(#paint31_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 5.15827H17.4178V9.5H10.7773V5.15827Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 5.1671H17.4089V9.46875H10.8047V5.1671Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4049 6.19371C17.3807 6.31819 17.3095 6.77115 17.2856 6.81544C17.1876 6.99488 17.0444 6.42456 16.6704 6.20341C15.9077 5.75142 14.6154 5.39675 13.2872 6.15976C12.693 6.50118 12.4337 6.8455 12.2685 7.19791C12.1168 7.52025 12.0732 8.06212 12.3377 8.47757C12.4566 8.66445 12.9604 9.22281 12.9642 9.22733C13.0561 9.33596 12.5365 9.72362 11.7631 9.20535C11.4405 8.98808 10.9875 8.8455 10.8262 8.02332C10.5802 6.75886 12.4793 5.21311 14.7948 5.16881C16.5578 5.12872 17.479 5.81091 17.4049 6.19371Z",
    fill: "url(#paint32_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.832 5.17885H17.4004V9.4375H10.832V5.17885Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3967 6.19261C17.3735 6.31288 17.3065 6.75324 17.2833 6.79785C17.1908 6.97503 17.0476 6.43089 16.6848 6.21136C15.9292 5.75355 14.6502 5.40341 13.3175 6.14217C12.7049 6.48197 12.4258 6.83891 12.2584 7.20587C12.1129 7.52465 12.0696 8.05327 12.3259 8.46161C12.4427 8.64751 12.9312 9.19325 12.9393 9.20231C13.0285 9.30706 12.5238 9.68921 11.7653 9.17579C11.4491 8.96144 11.0078 8.81466 10.8523 8.00509C10.6156 6.75323 12.4853 5.24111 14.7669 5.18098C16.5435 5.1341 17.4685 5.82242 17.3967 6.19261Z",
    fill: "url(#paint33_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8633 5.19713H17.3958V9.41406H10.8633V5.19713Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3922 6.19913C17.3695 6.3152 17.3068 6.74294 17.2842 6.78788C17.1969 6.96247 17.0543 6.44485 16.7032 6.22726C15.9544 5.76331 14.6883 5.41704 13.3518 6.1322C12.72 6.47039 12.4213 6.83993 12.2518 7.22112C12.1119 7.53635 12.0695 8.05203 12.3175 8.45325C12.4319 8.63819 12.9059 9.171 12.9179 9.18522C13.0035 9.2861 12.5144 9.66244 11.7708 9.15419C11.4617 8.94242 11.0317 8.79111 10.8823 7.99415C10.655 6.75458 12.495 5.2722 14.743 5.20043C16.5325 5.14353 17.4613 5.84155 17.3922 6.19913Z",
    fill: "url(#paint34_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8906 5.2079H17.3879V9.38281H10.8906V5.2079Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3845 6.1976C17.3628 6.30947 17.304 6.72492 17.2823 6.77019C17.1996 6.94186 17.0583 6.45076 16.7182 6.23511C15.9765 5.76534 14.7227 5.42231 13.3829 6.11452C12.7321 6.45076 12.4139 6.83323 12.2426 7.22897C12.1078 7.54031 12.066 8.04338 12.3059 8.43718C12.4185 8.62114 12.8772 9.14134 12.8931 9.1601C12.9762 9.25741 12.5022 9.62793 11.7734 9.12454C11.4708 8.91535 11.0505 8.76017 10.9089 7.9755C10.6878 6.74918 12.5019 5.29525 14.7156 5.21248C16.5184 5.14491 17.4511 5.85296 17.3845 6.1976Z",
    fill: "url(#paint35_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.918 5.21836H17.3797V9.35156H10.918V5.21836Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3765 6.196C17.3554 6.30399 17.3011 6.70683 17.2801 6.75241C17.2025 6.9215 17.0619 6.45659 16.7328 6.24321C15.9982 5.76665 14.756 5.42684 13.4137 6.09642C12.7434 6.43105 12.4059 6.82645 12.2329 7.23641C12.1029 7.54388 12.0622 8.03467 12.2943 8.42102C12.4043 8.60434 12.8485 9.11162 12.8682 9.13489C12.9481 9.22865 12.4896 9.59334 11.7758 9.09512C11.4799 8.88853 11.0703 8.72914 10.9352 7.95675C10.7227 6.74304 12.5084 5.31757 14.6878 5.22413C16.5042 5.14621 17.4408 5.86429 17.3765 6.196Z",
    fill: "url(#paint36_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9492 5.23631H17.375V9.32812H10.9492V5.23631Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.372 6.20235C17.3517 6.30613 17.3016 6.69603 17.2815 6.74227C17.2088 6.90845 17.0691 6.46972 16.751 6.2586C16.0232 5.77589 14.793 5.43836 13.448 6.0866C12.7584 6.41864 12.4015 6.82698 12.2266 7.25181C12.1014 7.55508 12.0623 8.03325 12.286 8.41217C12.3937 8.59484 12.8231 9.08951 12.847 9.11763C12.9236 9.20784 12.4807 9.56671 11.7814 9.07302C11.4923 8.86933 11.0937 8.70574 10.9653 7.94596C10.7616 6.74486 12.5182 5.34719 14.6637 5.24373C16.4936 5.15514 17.4338 5.88324 17.372 6.20235Z",
    fill: "url(#paint37_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 8,
    height: 5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9766 5.24612H17.3665V9.29688H10.9766V5.24612Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.364 6.20105C17.3446 6.3003 17.2984 6.67793 17.279 6.72448C17.2107 6.88808 17.073 6.47522 16.7655 6.26668C16.0449 5.77719 14.8257 5.44191 13.4788 6.06849C12.7694 6.39859 12.3934 6.81986 12.2169 7.25956C12.0963 7.55862 12.0585 8.0242 12.2744 8.396C12.3798 8.5777 12.794 9.05943 12.8221 9.09241C12.8955 9.17906 12.4678 9.53211 11.7837 9.04359C11.5014 8.84249 11.1138 8.67437 10.9915 7.9272C10.7969 6.73839 12.5247 5.36916 14.6362 5.25536C16.4794 5.1561 17.4235 5.89455 17.364 6.20105Z",
    fill: "url(#paint38_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 5.26374H17.3582V9.27344H11.0039V5.26374Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.356 6.2073C17.3376 6.30268 17.2952 6.66769 17.2768 6.71457C17.2134 6.87526 17.0767 6.48825 16.7805 6.2823C16.0667 5.7857 14.8584 5.45302 13.5096 6.05858C12.7809 6.38609 12.3854 6.8203 12.207 7.27487C12.0912 7.57005 12.0544 8.02333 12.2626 8.3877C12.3657 8.56843 12.7653 9.03756 12.797 9.07506C12.8675 9.15815 12.455 9.50539 11.7857 9.02172C11.5102 8.82353 11.1339 8.6512 11.0178 7.91632C10.8319 6.74044 12.5309 5.39838 14.6085 5.27487C16.4653 5.16495 17.4129 5.91406 17.356 6.2073Z",
    fill: "url(#paint39_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0352 5.27388H17.3539V9.24219H11.0352V5.27388Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3519 6.20599C17.3342 6.29716 17.2963 6.64925 17.2785 6.69677C17.2197 6.85422 17.0842 6.49374 16.7987 6.29038C16.092 5.78666 14.8944 5.45526 13.5443 6.04078C12.7955 6.36538 12.381 6.81317 12.2013 7.28262C12.0897 7.57327 12.0545 8.01458 12.2549 8.37152C12.3558 8.5516 12.7402 9.00747 12.7761 9.04982C12.8434 9.12936 12.4463 9.47078 11.792 8.99228C11.5233 8.79635 11.1579 8.61982 11.048 7.89787C10.8712 6.73395 12.5414 5.41938 14.585 5.28682C16.4551 5.16558 17.4062 5.92503 17.3519 6.20599Z",
    fill: "url(#paint40_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 5.28336H17.3457V9.21094H11.0625V5.28336Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.344 6.20427C17.3271 6.29156 17.2932 6.63104 17.2764 6.67889C17.2221 6.83344 17.0882 6.49848 16.8137 6.29803C16.1141 5.7872 14.9262 5.45711 13.5751 6.0229C12.8063 6.34492 12.3724 6.80563 12.1914 7.28995C12.0843 7.5764 12.0507 8.00576 12.2431 8.35526C12.3417 8.53437 12.7112 8.97763 12.751 9.02451C12.8157 9.10049 12.4335 9.43641 11.7943 8.96243C11.5321 8.76942 11.1781 8.58869 11.0743 7.87902C10.9065 6.72804 12.5476 5.43997 14.5573 5.29836C16.4406 5.16581 17.396 5.93624 17.344 6.20427Z",
    fill: "url(#paint41_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0898 5.30035H17.3378V9.1875H11.0898V5.30035Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3357 6.21043C17.3196 6.29352 17.2898 6.62039 17.274 6.66888C17.2239 6.82019 17.092 6.51144 16.8281 6.31389C16.1356 5.7953 14.9578 5.46649 13.6054 6.01288C12.8165 6.33166 12.3639 6.80629 12.1815 7.30548C12.0784 7.58741 12.0464 8.0048 12.231 8.34687C12.3277 8.52533 12.6823 8.95566 12.726 9.00706C12.7874 9.07949 12.4208 9.40959 11.7965 8.94079C11.541 8.75036 11.198 8.56509 11.1007 7.86804C10.9416 6.72966 12.554 5.46843 14.5297 5.31809C16.4263 5.17357 17.3852 5.95534 17.3357 6.21043Z",
    fill: "url(#paint42_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 5.3095H17.3332V9.15625H11.1211V5.3095Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3317 6.20914C17.3165 6.28803 17.2907 6.60229 17.2755 6.65111C17.2295 6.79919 17.1002 6.51596 16.8467 6.32198C16.161 5.79595 14.9935 5.46746 13.6402 5.99511C12.8312 6.31033 12.3592 6.79886 12.1756 7.31325C12.0766 7.59065 12.0462 7.9964 12.2234 8.3307C12.3175 8.50852 12.6573 8.92592 12.7051 8.98217C12.7633 9.05072 12.4122 9.375 11.8025 8.91105C11.5542 8.7232 11.2221 8.53407 11.1309 7.84962C10.9809 6.72353 12.5645 5.48848 14.506 5.32974C16.4161 5.17358 17.3786 5.96666 17.3317 6.20914Z",
    fill: "url(#paint43_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1484 5.31866H17.325V9.125H11.1484V5.31866Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3238 6.20779C17.3093 6.28248 17.2876 6.58381 17.2734 6.63327C17.2317 6.77779 17.1043 6.52075 16.8615 6.32968C16.1829 5.79557 15.0248 5.46806 13.6714 5.97695C12.8421 6.28895 12.3503 6.79104 12.1661 7.32095C12.071 7.59382 12.0422 7.98762 12.2116 8.31448C12.3035 8.49133 12.6287 8.89579 12.6804 8.9569C12.7354 9.02189 12.3995 9.34035 11.8049 8.88157C11.5631 8.69631 11.2424 8.50265 11.1573 7.83081C11.0164 6.71733 12.5708 5.50815 14.4787 5.34164C16.4021 5.17352 17.3684 5.97792 17.3238 6.20779Z",
    fill: "url(#paint44_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1758 5.33532H17.3171V9.10156H11.1758V5.33532Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3156 6.21399C17.3017 6.28447 17.2843 6.57318 17.271 6.6233C17.2332 6.76458 17.1084 6.5331 16.8763 6.34525C16.2047 5.80306 15.056 5.47619 13.7017 5.9673C12.852 6.27509 12.3412 6.79142 12.1559 7.3362C12.0648 7.60487 12.0379 7.98702 12.1999 8.30581C12.2891 8.48233 12.5995 8.87386 12.6551 8.93949C12.7075 9.00092 12.3868 9.31357 11.8068 8.85964C11.572 8.67729 11.2626 8.47943 11.1837 7.8202C11.0518 6.719 12.5772 5.53568 14.4508 5.36109C16.3877 5.18069 17.3577 5.99705 17.3156 6.21399Z",
    fill: "url(#paint45_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.207 5.34416H17.3127V9.07031H11.207V5.34416Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3117 6.21303C17.2988 6.27931 17.2852 6.55542 17.2726 6.60585C17.2386 6.74391 17.1167 6.53763 16.8949 6.35367C16.2309 5.80307 15.0909 5.47653 13.7365 5.94953C12.8662 6.25377 12.3359 6.784 12.1504 7.34429C12.0627 7.60811 12.0375 7.97863 12.1921 8.28998C12.279 8.46554 12.5749 8.84446 12.6344 8.91462C12.6835 8.97249 12.3789 9.27834 11.8132 8.83056C11.5855 8.65015 11.2871 8.4484 11.2141 7.80178C11.0915 6.71287 12.5878 5.5551 14.4274 5.37307C16.3776 5.18038 17.3511 6.0087 17.3117 6.21303Z",
    fill: "url(#paint46_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2344 5.35301H17.3049V9.03906H11.2344V5.35301Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3036 6.21183C17.2916 6.27359 17.2823 6.53709 17.2706 6.58849C17.2409 6.72299 17.1212 6.54194 16.9098 6.36153C16.2532 5.8022 15.1219 5.4763 13.7675 5.93185C12.8768 6.23188 12.3269 6.77666 12.1406 7.35183C12.0569 7.61112 12.0336 7.97033 12.1807 8.27392C12.2651 8.44883 12.5461 8.81481 12.6098 8.88982C12.6557 8.94381 12.3666 9.24351 11.8157 8.8009C11.5946 8.62341 11.3075 8.41714 11.2405 7.78313C11.1271 6.70683 12.5942 5.57427 14.3999 5.38514C16.3637 5.17951 17.3411 6.02011 17.3036 6.21183Z",
    fill: "url(#paint47_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2617 5.36901H17.2966V9.01562H11.2617V5.36901Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2958 6.218C17.2848 6.27587 17.279 6.52643 17.2686 6.57849C17.2421 6.70943 17.1261 6.55391 16.9246 6.37738C16.2758 5.80868 15.1532 5.48311 13.7986 5.92184C12.8871 6.21702 12.3175 6.77668 12.1312 7.36736C12.0507 7.62213 12.0294 7.96936 12.1691 8.26552C12.2512 8.43978 12.5173 8.79252 12.5852 8.87237C12.6279 8.92281 12.3543 9.2167 11.8183 8.77894C11.6039 8.60403 11.3278 8.39355 11.267 7.77214C11.1629 6.70845 12.6007 5.60079 14.3724 5.40487C16.3495 5.18599 17.3307 6.03921 17.2958 6.218Z",
    fill: "url(#paint48_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2891 5.3772H17.2887V8.98438H11.2891V5.3772Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2878 6.21603C17.2774 6.27002 17.2758 6.50766 17.2664 6.56036C17.2435 6.68774 17.1307 6.55745 16.9393 6.38513C16.2985 5.80705 15.184 5.48147 13.8293 5.90371C12.8972 6.19437 12.3078 6.76824 12.1213 7.37477C12.0443 7.62469 12.0249 7.96094 12.1572 8.24901C12.237 8.42262 12.4886 8.76242 12.56 8.84681C12.6001 8.89401 12.3418 9.18208 11.8203 8.74917C11.613 8.57684 11.3486 8.36217 11.2936 7.75337C11.1986 6.70164 12.6069 5.61888 14.3447 5.41616C16.3353 5.18402 17.3201 6.05017 17.2878 6.21603Z",
    fill: "url(#paint49_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 5.38475H17.2847V8.95312H11.3203V5.38475Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.284 6.21477C17.2746 6.26456 17.2765 6.48926 17.2685 6.54261C17.2491 6.66644 17.1395 6.56136 16.9581 6.39291C16.3257 5.80513 15.2187 5.48021 13.8643 5.88596C12.9115 6.17145 12.3021 6.76052 12.1159 7.38257C12.0425 7.62764 12.0247 7.95256 12.1498 8.23287C12.2271 8.40585 12.4637 8.73271 12.5394 8.82162C12.5763 8.86494 12.3331 9.14752 11.8268 8.71946C11.626 8.55004 11.3729 8.33083 11.3241 7.73465C11.2387 6.69585 12.6173 5.63733 14.3215 5.42815C16.3254 5.18211 17.314 6.06152 17.284 6.21477Z",
    fill: "url(#paint50_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3438 5.40011H17.2729V8.92969H11.3438V5.40011Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2724 6.22114C17.2637 6.26641 17.2698 6.47883 17.2624 6.5325C17.2462 6.65277 17.1405 6.57259 16.9692 6.40867C16.3452 5.81087 15.2459 5.48626 13.8916 5.87585C12.9178 6.15584 12.2879 6.76011 12.1024 7.39767C12.0322 7.63854 12.0167 7.95183 12.1344 8.22438C12.2091 8.3967 12.4315 8.71032 12.511 8.80408C12.5446 8.84384 12.3167 9.12059 11.8253 8.6977C11.6316 8.53087 11.3901 8.30714 11.3468 7.72357C11.2711 6.69706 12.62 5.66279 14.2902 5.44746C16.3073 5.18752 17.2999 6.0805 17.2724 6.22114Z",
    fill: "url(#paint51_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 5.40733H17.2693V8.89844H11.375V5.40733Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2684 6.21927C17.2607 6.26065 17.27 6.45982 17.2642 6.51446C17.2513 6.63118 17.1495 6.57589 16.9881 6.4165C16.3725 5.80803 15.2807 5.48374 13.9264 5.85749C12.9315 6.1323 12.2817 6.75209 12.0968 7.40517C12.0298 7.64119 12.0159 7.94349 12.1268 8.20795C12.1986 8.37995 12.4065 8.68032 12.4902 8.77893C12.5206 8.81481 12.3082 9.08606 11.8316 8.6677C11.6444 8.50378 11.4146 8.27553 11.3774 7.70457C11.3111 6.69067 12.6302 5.68032 14.2668 5.45917C16.2969 5.18468 17.2933 6.09156 17.2684 6.21927Z",
    fill: "url(#paint52_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4023 5.41456H17.2636V8.86719H11.4023V5.41456Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2609 6.2178C17.2538 6.25498 17.2674 6.44121 17.2625 6.49649C17.2528 6.60965 17.1549 6.57926 17.0032 6.42407C16.3977 5.80429 15.3117 5.48131 13.9577 5.83986C12.9421 6.10853 12.2709 6.74383 12.0873 7.41243C12.0236 7.64392 12.0117 7.93491 12.1154 8.19161C12.1846 8.36297 12.3783 8.65039 12.4656 8.75353C12.4934 8.78586 12.2962 9.0513 11.8345 8.63811C11.6541 8.47645 11.4355 8.24431 11.4042 7.68596C11.3473 6.68402 12.6369 5.6976 14.2396 5.47064C16.2829 5.18128 17.2832 6.1027 17.2609 6.2178Z",
    fill: "url(#paint53_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4297 5.42959H17.2612V8.84375H11.4297V5.42959Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2534 6.22374C17.247 6.25704 17.2641 6.43065 17.2606 6.48626C17.2541 6.59619 17.1606 6.59037 17.0184 6.43939C16.4225 5.80861 15.3427 5.48627 13.9887 5.8293C12.9524 6.09183 12.2609 6.74298 12.0782 7.42775C12.0178 7.65439 12.0074 7.93438 12.1044 8.183C12.171 8.35371 12.3498 8.62787 12.4413 8.73586C12.4659 8.76463 12.2838 9.02457 11.8373 8.61591C11.6634 8.45716 11.4568 8.22051 11.4309 7.67476C11.3844 6.68543 12.6437 5.72228 14.2127 5.48982C16.269 5.18559 17.2735 6.12157 17.2534 6.22374Z",
    fill: "url(#paint54_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4609 5.43585H17.2631V8.8125H11.4609V5.43585Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.22181C17.2445 6.25091 17.2652 6.41192 17.2632 6.46817C17.2593 6.57422 17.1704 6.59297 17.0376 6.44716C16.4527 5.80377 15.378 5.48337 14.024 5.81121C12.9668 6.06727 12.2539 6.73458 12.0728 7.43519C12.0156 7.65698 12.0068 7.92566 12.097 8.16653C12.1607 8.33659 12.3253 8.59814 12.4207 8.71033C12.4423 8.73587 12.2755 8.98967 11.8439 8.58618C11.6767 8.43002 11.4821 8.18883 11.4617 7.65569C11.4249 6.67897 12.6541 5.73879 14.1895 5.50148C16.2587 5.18172 17.2674 6.1329 17.25 6.22181Z",
    fill: "url(#paint55_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4883 5.44243H17.2613V8.78125H11.4883V5.44243Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2424 6.22031C17.2378 6.24521 17.2618 6.39328 17.2611 6.45018C17.2601 6.553 17.1761 6.596 17.0529 6.45471C16.4794 5.79872 15.4089 5.48026 14.0555 5.79322C12.9769 6.0425 12.2427 6.72629 12.0636 7.44275C12.0093 7.65969 12.0022 7.91737 12.0856 8.15015C12.1467 8.31956 12.297 8.56787 12.3963 8.68491C12.4147 8.70657 12.2634 8.9552 11.8466 8.55623C11.6863 8.40298 11.5033 8.15759 11.4887 7.63706C11.4616 6.67263 12.6607 5.75539 14.1625 5.51291C16.2443 5.17699 17.2572 6.14369 17.2424 6.22031Z",
    fill: "url(#paint56_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 5.45552H17.2596V8.75781H11.5156V5.45552Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2352 6.22605C17.2313 6.24674 17.2584 6.38188 17.2597 6.43943C17.2617 6.53869 17.1825 6.60626 17.068 6.46982C16.5071 5.80057 15.4405 5.48373 14.0868 5.78247C12.9875 6.02496 12.231 6.72492 12.0544 7.45722C12.003 7.66963 11.9982 7.91599 12.0748 8.14069C12.1327 8.31011 12.2688 8.54516 12.3723 8.66705C12.3874 8.68515 12.2507 8.9286 11.8495 8.53384C11.6959 8.3835 11.5245 8.13326 11.5158 7.62534C11.499 6.67319 12.6671 5.77891 14.1356 5.5319C16.2303 5.17917 17.2478 6.16203 17.2352 6.22605Z",
    fill: "url(#paint57_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11.543 5.46145H17.2585V8.72656H11.543V5.46145Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2284 6.22422C17.2252 6.24071 17.2556 6.36324 17.2585 6.42144C17.2627 6.51746 17.1893 6.60928 17.0839 6.47737C16.5365 5.79389 15.4722 5.47995 14.1185 5.76446C12.9982 5.99951 12.2197 6.71661 12.0457 7.46475C11.9972 7.67264 11.9937 7.90802 12.0639 8.12431C12.1188 8.2934 12.2407 8.5152 12.3484 8.64161C12.3603 8.65616 12.2388 8.89379 11.8527 8.50388C11.7056 8.35645 11.5466 8.10167 11.543 7.60669C11.5365 6.66682 12.6739 5.79486 14.1088 5.54332C16.2161 5.17378 17.2381 6.17314 17.2284 6.22422Z",
    fill: "url(#paint58_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5703 5.46706H17.2577V8.69531H11.5703V5.46706Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2215 6.22263C17.2189 6.23492 17.2528 6.34452 17.257 6.40336C17.2641 6.49615 17.1959 6.61189 17.0996 6.48516C16.5674 5.78681 15.5037 5.4761 14.1503 5.74639C13.0094 5.974 12.2079 6.70792 12.0369 7.4719C11.9916 7.67526 11.9893 7.89932 12.0534 8.10785C12.1048 8.2763 12.2127 8.48516 12.3246 8.6161C12.3337 8.62709 12.2273 8.8589 11.8561 8.47416C11.7158 8.329 11.5687 8.07002 11.5703 7.58765C11.5742 6.66039 12.6806 5.81106 14.0824 5.555C16.2021 5.16767 17.2286 6.18416 17.2215 6.22263Z",
    fill: "url(#paint59_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5977 5.47984H17.2569V8.67188H11.5977V5.47984Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2145 6.2284C17.2129 6.23681 17.2494 6.3338 17.2559 6.39297C17.2653 6.48252 17.2032 6.6222 17.1152 6.50063C16.5996 5.78676 15.5359 5.47993 14.1822 5.73599C13.0199 5.95585 12.1957 6.70658 12.0283 7.48705C11.9829 7.68915 11.9878 7.8993 12.0425 8.09908C12.0907 8.2672 12.1844 8.46312 12.3005 8.59859C12.3066 8.6057 12.2155 8.83201 11.8592 8.4518C11.7257 8.30954 11.5905 8.04638 11.5979 7.57628C11.6122 6.66164 12.6875 5.83428 14.0558 5.57401C16.1877 5.16891 17.2193 6.20286 17.2145 6.2284Z",
    fill: "url(#paint60_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 5.48479H17.2571V8.64062H11.625V5.48479Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2081 6.22675C17.2072 6.23096 17.2469 6.31534 17.2553 6.37483C17.2673 6.46116 17.211 6.62475 17.1315 6.50803C16.6349 5.77735 15.5683 5.47538 14.2146 5.71786C13.0316 5.92963 12.1829 6.69749 12.02 7.49445C11.9787 7.68883 11.983 7.89012 12.0326 8.08255C12.0772 8.25003 12.158 8.43205 12.2773 8.57301C12.2806 8.57657 12.2046 8.79707 11.8632 8.42203C11.7364 8.28236 11.6136 8.01466 11.6259 7.5575C11.6514 6.65514 12.6947 5.84945 14.0297 5.5853C16.1739 5.16112 17.2104 6.21382 17.2081 6.22675Z",
    fill: "url(#paint61_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 5,
    width: 7,
    height: 4
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6523 5.48976H17.2576V8.60938H11.6523V5.48976Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2023 6.2248C17.2023 6.2248 17.2443 6.29691 17.2553 6.35672C17.2692 6.44013 17.2197 6.62732 17.1486 6.51578C16.674 5.76667 15.6013 5.47052 14.2476 5.69942C13.0432 5.90279 12.1706 6.68876 12.0125 7.50188C11.9748 7.68845 11.9784 7.881 12.0229 8.06606C12.0667 8.24059 12.1456 8.40439 12.2547 8.54747C12.2547 8.54747 12.1939 8.76214 11.8677 8.39195C11.7474 8.25519 11.6362 7.98329 11.6543 7.53842C11.6895 6.64867 12.7025 5.86529 14.0044 5.59694C16.1606 5.15433 17.2023 6.2248 17.2023 6.2248Z",
    fill: "url(#paint62_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2383 5.50209H18.0372V7.09375H17.2383V5.50209Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 5.50856H18.0372V7.09375H17.2422V5.50856Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0371 5.50856L17.2498 7.09375C17.2505 7.09052 17.234 6.95732 17.2476 6.76721C17.2767 6.36695 17.4302 5.75072 18.0371 5.50856Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 5.51503H18.033V7.09375H17.2422V5.51503Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0331 5.51503L17.2487 7.09375C17.2497 7.08728 17.2335 6.95537 17.2487 6.76882C17.2814 6.35692 17.4466 5.74878 18.0331 5.51503Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2422 5.51336H18.0291V7.08594H17.2422V5.51336Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0292 5.51336L17.2474 7.08594C17.2491 7.07624 17.2335 6.94594 17.2494 6.76263C17.2866 6.33909 17.4631 5.73936 18.0292 5.51336Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 5.51982H18.0288V7.08594H17.2461V5.51982Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0293 5.5195L17.2501 7.08594C17.2523 7.07333 17.2371 6.94368 17.2546 6.76425C17.2957 6.32842 17.4832 5.73741 18.0293 5.5195Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.52596H18.0292V7.08594H17.25V5.52596Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0292 5.52629L17.2529 7.08594C17.2555 7.07042 17.2413 6.94206 17.2594 6.76618C17.3046 6.31839 17.5031 5.73579 18.0288 5.52596",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.52461H18.025V7.07812H17.25V5.52461Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0251 5.52461L17.2518 7.07812C17.255 7.05937 17.2414 6.93263 17.2602 6.75998C17.31 6.30024 17.5195 5.72636 18.0251 5.52461Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 5.53108H18.025V7.07812H17.2539V5.53108Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0252 5.53077L17.2544 7.07812C17.2583 7.05614 17.2457 6.9307 17.2651 6.76129C17.3191 6.2899 17.5399 5.72443 18.0252 5.53077Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 5.52942H18.0221V7.07031H17.2539V5.52942Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0218 5.52942L17.2539 7.07031C17.2581 7.04542 17.2465 6.92127 17.2665 6.75573C17.3254 6.27206 17.5565 5.71467 18.0218 5.52942Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 5.53588H18.0192V7.07031H17.2539V5.53588Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0192 5.53556L17.2539 7.07031C17.2588 7.04218 17.2481 6.91933 17.2688 6.75735C17.3321 6.26172 17.5743 5.71306 18.0189 5.53524",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 5.54203H18.0163V7.07031H17.2539V5.54203Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0163 5.54203L17.2539 7.07031C17.2594 7.03895 17.2494 6.91738 17.2707 6.75896C17.3389 6.25136 17.5918 5.71144 18.0163 5.54203Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2539 5.54849H18.0134V7.07031H17.2539V5.54849Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0137 5.54882L17.2539 7.07031C17.2604 7.03604 17.2513 6.91577 17.2733 6.7609C17.3464 6.24134 17.6095 5.71015 18.0137 5.54849",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2578 5.54714H18.015V7.0625H17.2578V5.54714Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0147 5.54649L17.2578 7.0625C17.2643 7.025 17.2568 6.90633 17.2792 6.7547C17.3567 6.22318 17.6303 5.70006 18.0147 5.54681",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2578 5.55329H18.0121V7.0625H17.2578V5.55329Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0121 5.55329L17.2578 7.0625C17.2649 7.02209 17.2585 6.90472 17.2811 6.75664C17.3639 6.21316 17.648 5.69845 18.0118 5.55329",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2578 5.55195H18.0092V7.05469H17.2578V5.55195Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0092 5.55195L17.2578 7.05469C17.2656 7.01136 17.2604 6.89498 17.2837 6.75078C17.3713 6.19534 17.6655 5.68903 18.0092 5.55195Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2578 5.55808H18.0066V7.05469H17.2578V5.55808Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0066 5.55776L17.2578 7.05469C17.2659 7.00748 17.2623 6.89304 17.2856 6.75175C17.3787 6.18434 17.683 5.68676 18.0066 5.55776Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2617 5.56422H18.0076V7.05469H17.2617V5.56422Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0073 5.56422L17.2617 7.05469C17.2704 7.00457 17.2679 6.89109 17.2915 6.75401C17.3901 6.17432 17.7043 5.68514 18.0076 5.56422",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2617 5.56288H18.005V7.04688H17.2617V5.56288Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0053 5.56288L17.2617 7.04688C17.2711 6.99353 17.2705 6.88167 17.2941 6.74749C17.3982 6.15648 17.7221 5.67572 18.0053 5.56288Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2617 5.56967H18.0021V7.04688H17.2617V5.56967Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0021 5.56934L17.2617 7.04688C17.2714 6.99094 17.2721 6.88037 17.2957 6.74943C17.4056 6.14677 17.7393 5.67442 18.0021 5.56934Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 2,
    height: 3
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.57548H18.0034V7.04688H17.2656V5.57548Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0034 5.57581L17.2656 7.04688C17.276 6.98771 17.2779 6.87843 17.3018 6.75137C17.4176 6.13643 17.7609 5.67248 18.0034 5.57581Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.58196H18.0008V7.04688H17.2656V5.58196Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 5.58228L17.2656 7.04688C17.2763 6.9848 17.2798 6.87681 17.3038 6.7533C17.4257 6.12673 17.7781 5.67087 18.0005 5.58228Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.58029H17.9979V7.03906H17.2656V5.58029Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9976 5.58061L17.2656 7.03906C17.2773 6.97375 17.2818 6.86706 17.306 6.74679C17.4347 6.1089 17.7955 5.66144 17.9979 5.58061",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.58675H17.995V7.03906H17.2656V5.58675Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.995 5.58675L17.2656 7.03906C17.2776 6.9702 17.2841 6.86545 17.3083 6.74841C17.4431 6.09856 17.8127 5.6595 17.995 5.58675Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.5854H17.9924V7.03125H17.2656V5.5854Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9924 5.5854L17.2656 7.03125C17.2782 6.95948 17.286 6.85601 17.3106 6.74253C17.4522 6.08104 17.8308 5.65006 17.9924 5.5854Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.59155H17.9895V7.03125H17.2656V5.59155Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9898 5.59155L17.2656 7.03125C17.2786 6.95624 17.2883 6.85407 17.3128 6.7435C17.4615 6.07101 17.8482 5.64813 17.9898 5.59155Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2656 5.59801H17.9869V7.03125H17.2656V5.59801Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9869 5.59801L17.2656 7.03125C17.2792 6.95333 17.2905 6.85246 17.3148 6.74577C17.4709 6.06164 17.8657 5.64651 17.9869 5.59801Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 5.60416H17.9883V7.03125H17.2695V5.60416Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9876 5.60416L17.2695 7.03125C17.2838 6.94978 17.2964 6.85051 17.3206 6.74738C17.4842 6.05161 17.8864 5.64489 17.9879 5.60416",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 5.61063H17.9853V7.03125H17.2695V5.61063Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9853 5.61063L17.2695 7.03125C17.2844 6.94719 17.2986 6.84923 17.3229 6.749C17.4949 6.04225 17.9045 5.64329 17.9853 5.61096",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 5.60928H17.9824V7.02344H17.2695V5.60928Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9824 5.60928L17.2695 7.02344C17.2847 6.93614 17.3006 6.8398 17.3245 6.74313C17.5049 6.02505 17.9216 5.63353 17.9824 5.60928Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 5.61542H17.9798V7.02344H17.2695V5.61542Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9798 5.61542L17.2695 7.02344C17.2857 6.93291 17.3028 6.83818 17.3271 6.74474C17.5165 6.01568 17.9394 5.63158 17.9802 5.61542",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 5.61408H17.9808V7.01562H17.2734V5.61408Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9808 5.61408L17.2734 7.01562C17.2896 6.92186 17.309 6.82876 17.3332 6.73888C17.5305 5.99849 17.9605 5.62216 17.9808 5.61375",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 5,
    width: 1,
    height: 3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 5.62021H17.9783V7.01562H17.2734V5.62021Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2734 7.01562L17.9783 5.62054C17.9783 5.62054 17.4374 6.07964 17.2734 7.01562Z",
    fill: "#0087BA"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M12.207 9.45479H15.6005V14.5078H12.207V9.45479Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask97_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2461 9.46536H15.5878V14.4922H12.2461V9.46536Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5209 9.66139C13.5209 9.66139 15.4488 10.7477 15.5797 12.5592C15.711 14.3772 14.1918 14.7354 14.3492 14.3565C14.7556 13.3824 14.4032 12.0219 13.5455 11.4894C11.6593 10.3187 11.9813 8.94914 13.5209 9.66139Z",
    fill: "url(#paint63_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2812 9.4756H15.5716V14.4766H12.2812V9.4756Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5209 9.67254C13.5209 9.67254 15.4327 10.7492 15.5636 12.5451C15.6952 14.3547 14.2025 14.7197 14.359 14.3427C14.7628 13.3728 14.4311 12.0101 13.5704 11.4679C11.7321 10.3091 11.9907 8.96352 13.5209 9.67254Z",
    fill: "url(#paint64_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3203 9.49365H15.5602V14.4688H12.3203V9.49365Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5253 9.69141C13.5253 9.69141 15.4212 10.758 15.5518 12.5391C15.684 14.3403 14.2178 14.7118 14.3733 14.3367C14.7749 13.371 14.4638 12.0066 13.5999 11.4541C11.8088 10.3083 12.0047 8.98563 13.5253 9.69141Z",
    fill: "url(#paint65_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3594 9.50389H15.5495V14.4531H12.3594V9.50389Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5305 9.7025C13.5305 9.7025 15.4102 10.7594 15.5409 12.5253C15.6734 14.3181 14.234 14.6963 14.3883 14.3226C14.7875 13.3614 14.4969 11.9951 13.6301 11.4325C11.8858 10.3003 12.019 8.99995 13.5305 9.7025Z",
    fill: "url(#paint66_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3945 9.51413H15.5352V14.4375H12.3945V9.51413Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5323 9.7137C13.5323 9.7137 15.3962 10.7609 15.5262 12.5113C15.6591 14.296 14.2465 14.6807 14.4001 14.3086C14.7968 13.3519 14.5268 11.984 13.6565 11.4108C11.9591 10.2927 12.0302 9.01405 13.5323 9.7137Z",
    fill: "url(#paint67_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4297 9.52437H15.5212V14.4219H12.4297V9.52437Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5346 9.72474C13.5346 9.72474 15.3823 10.7622 15.5123 12.4971C15.6455 14.2737 14.2594 14.6649 14.412 14.2947C14.8062 13.3426 14.5566 11.9727 13.6836 11.3891C12.0328 10.2854 12.0419 9.02833 13.5346 9.72474Z",
    fill: "url(#paint68_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4648 9.54241H15.5078V14.4141H12.4648V9.54241Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5371 9.74356C13.5371 9.74356 15.369 10.771 15.4987 12.4911C15.6325 14.2592 14.273 14.6569 14.4249 14.2887C14.8165 13.3407 14.5876 11.9696 13.7114 11.3753C12.1068 10.287 12.0541 9.05038 13.5371 9.74356Z",
    fill: "url(#paint69_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.55298H15.4955V14.3984H12.5V9.55298Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5406 9.75431C13.5406 9.75431 15.3563 10.7727 15.486 12.4769C15.6201 14.2367 14.2875 14.6415 14.4381 14.2745C14.8274 13.3311 14.6188 11.9586 13.7394 11.3534C12.1811 10.281 12.067 9.06469 13.5406 9.75431Z",
    fill: "url(#paint70_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5312 9.56322H15.4798V14.3828H12.5312V9.56322Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5409 9.76545C13.5409 9.76545 15.3404 10.7739 15.4698 12.4628C15.6046 14.2145 14.2984 14.6258 14.4481 14.2604C14.8348 13.3215 14.6466 11.9478 13.7646 11.3319C12.2515 10.2753 12.0766 9.07906 13.5409 9.76545Z",
    fill: "url(#paint71_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5664 9.57378H15.4684V14.3672H12.5664V9.57378Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5457 9.77644C13.5457 9.77644 15.3291 10.7751 15.4584 12.4489C15.5936 14.1922 14.3139 14.6099 14.4626 14.2465C14.8471 13.3118 14.6793 11.9371 13.7944 11.3102C12.3265 10.2705 12.0905 9.09328 13.5457 9.77644Z",
    fill: "url(#paint72_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5977 9.59151H15.4538V14.3594H12.5977V9.59151Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5472 9.79536C13.5472 9.79536 15.3145 10.7844 15.4435 12.4429C15.5793 14.1778 14.3261 14.602 14.4742 14.2402C14.856 13.3101 14.7083 11.9347 13.8204 11.2965C12.3979 10.2739 12.1014 9.11544 13.5472 9.79536Z",
    fill: "url(#paint73_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6328 9.60207H15.444V14.3438H12.6328V9.60207Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5528 9.80631C13.5528 9.80631 15.3042 10.7856 15.4332 12.4287C15.5693 14.1555 14.3426 14.5861 14.4898 14.2263C14.8693 13.3003 14.7416 11.924 13.8512 11.2748C12.4736 10.2696 12.117 9.1293 13.5528 9.80631Z",
    fill: "url(#paint74_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 9.61232H15.4306V14.3281H12.6641V9.61232Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5558 9.81731C13.5558 9.81731 15.291 10.7866 15.4197 12.4145C15.5564 14.1329 14.3566 14.5706 14.5024 14.2121C14.8794 13.2906 14.7717 11.914 13.8791 11.2528C12.5458 10.2657 12.129 9.14353 13.5558 9.81731Z",
    fill: "url(#paint75_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6914 9.63037H15.414V14.3203H12.6914V9.63037Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5553 9.83572C13.5553 9.83572 15.2747 10.7956 15.403 12.4083C15.5401 14.1183 14.3668 14.5625 14.5117 14.2059C14.8864 13.2887 14.7988 11.9117 13.9035 11.2389C12.6145 10.2702 12.1379 9.1655 13.5553 9.83572Z",
    fill: "url(#paint76_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7227 9.64094H15.4026V14.3047H12.7227V9.64094Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5596 9.84678C13.5596 9.84678 15.2628 10.797 15.3908 12.3941C15.5286 14.096 14.3818 14.5467 14.526 14.1918C14.8981 13.279 14.8302 11.9021 13.9324 11.2173C12.6873 10.2677 12.1516 9.17979 13.5596 9.84678Z",
    fill: "url(#paint77_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7539 9.6515H15.3915V14.2891H12.7539V9.6515Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5644 9.85767C13.5644 9.85767 15.2514 10.7979 15.3795 12.3801C15.5175 14.0736 14.3972 14.5308 14.5405 14.1777C14.91 13.2696 14.8622 11.8926 13.9621 11.1952C12.761 10.2647 12.1658 9.19392 13.5644 9.85767Z",
    fill: "url(#paint78_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7812 9.66987H15.3771V14.2812H12.7812V9.66987Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5661 9.87639C13.5661 9.87639 15.2373 10.8069 15.3653 12.3736C15.5037 14.0591 14.4103 14.523 14.5525 14.1713C14.9195 13.2676 14.891 11.8909 13.9887 11.1813C12.8309 10.2705 12.1768 9.21554 13.5661 9.87639Z",
    fill: "url(#paint79_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8086 9.68012H15.3637V14.2656H12.8086V9.68012Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5684 9.88726C13.5684 9.88726 15.2234 10.808 15.3511 12.3596C15.4902 14.0366 14.4232 14.507 14.5645 14.1572C14.9292 13.2578 14.9198 11.8821 14.0159 11.1595C12.9011 10.2688 12.1888 9.22964 13.5684 9.88726Z",
    fill: "url(#paint80_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8359 9.69035H15.3506V14.25H12.8359V9.69035Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5717 9.8983C13.5717 9.8983 15.2106 10.8094 15.3383 12.3454C15.4773 14.014 14.4372 14.4912 14.5775 14.143C14.9396 13.2481 14.9493 11.8731 14.0441 11.1379C12.972 10.2672 12.2012 9.24392 13.5717 9.8983Z",
    fill: "url(#paint81_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8594 9.70873H15.335V14.2422H12.8594V9.70873Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5716 9.91695C13.5716 9.91695 15.1943 10.818 15.3217 12.3392C15.4614 13.9994 14.4478 14.4831 14.5871 14.1368C14.947 13.2461 14.9754 11.8723 14.0689 11.1239C13.0395 10.2739 12.2105 9.2658 13.5716 9.91695Z",
    fill: "url(#paint82_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8867 9.71115H15.3238V14.2188H12.8867V9.71115Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5763 9.9198C13.5763 9.9198 15.1831 10.8115 15.3102 12.3171C15.4502 13.9693 14.4631 14.4594 14.6018 14.1147C14.9591 13.2286 15.0059 11.8568 14.0981 11.0944C13.111 10.2654 12.2245 9.27189 13.5763 9.9198Z",
    fill: "url(#paint83_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 9.72953H15.3134V14.2109H12.9141V9.72953Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5813 9.93828C13.5813 9.93828 15.1723 10.8203 15.299 12.3107C15.4397 13.9545 14.4794 14.4514 14.6169 14.1083C14.9718 13.2264 15.0372 11.8562 14.1283 11.0799C13.1833 10.2726 12.2392 9.2936 13.5813 9.93828Z",
    fill: "url(#paint84_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 9.73977H15.2993V14.1953H12.9375V9.73977Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5834 9.94925C13.5834 9.94925 15.1582 10.8215 15.2849 12.2965C15.4259 13.9321 14.4922 14.4355 14.6286 14.0941C14.981 13.2166 15.0641 11.8487 14.1553 11.0582C13.252 10.2722 12.2507 9.30781 13.5834 9.94925Z",
    fill: "url(#paint85_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9609 9.75034H15.2865V14.1797H12.9609V9.75034Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5861 9.96005C13.5861 9.96005 15.1448 10.8226 15.2712 12.2824C15.4128 13.9093 14.5056 14.4195 14.6414 14.08C14.9912 13.2067 15.0918 11.8417 14.183 11.0364C13.321 10.2724 12.2628 9.32183 13.5861 9.96005Z",
    fill: "url(#paint86_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 9,
    width: 4,
    height: 6
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9844 9.76839H15.2741V14.1719H12.9844V9.76839Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5897 9.9788C13.5897 9.9788 15.1322 10.8317 15.2586 12.2759C15.4005 13.8947 14.5198 14.4114 14.6546 14.0735C15.0022 13.2048 15.1196 11.843 14.2111 11.0221C13.3902 10.2808 12.2757 9.34382 13.5897 9.9788Z",
    fill: "url(#paint87_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 3,
    height: 6
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0078 9.77895H15.2626V14.1562H13.0078V9.77895Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5937 9.98942C13.5937 9.98942 15.1204 10.8323 15.2465 12.2613C15.389 13.8721 14.5352 14.3955 14.6687 14.0593C15.014 13.195 15.1475 11.8368 14.2403 11.0001C13.4602 10.2807 12.2891 9.35767 13.5937 9.98942Z",
    fill: "url(#paint88_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 3,
    height: 6
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0273 9.797H15.2475V14.1484H13.0273V9.797Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5946 10.0078C13.5946 10.0078 15.1054 10.8413 15.2312 12.2551C15.3741 13.8575 14.5467 14.3874 14.6796 14.0528C15.022 13.1931 15.1717 11.8394 14.2658 10.9862C13.5264 10.2894 12.2994 9.37963 13.5946 10.0078Z",
    fill: "url(#paint89_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 3,
    height: 6
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0469 9.80724H15.2334V14.1328H13.0469V9.80724Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5961 10.0189C13.5961 10.0189 15.0908 10.8423 15.2162 12.241C15.3594 13.8349 14.5589 14.3713 14.6908 14.0386C15.031 13.1831 15.1955 11.8342 14.2922 10.9642C13.5929 10.2904 12.3103 9.39325 13.5961 10.0189Z",
    fill: "url(#paint90_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 3,
    height: 6
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0664 9.8178H15.22V14.1172H13.0664V9.8178Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5982 10.0297C13.5982 10.0297 15.0767 10.8435 15.2022 12.2266C15.3457 13.8125 14.5717 14.3553 14.7027 14.0242C15.0405 13.1733 15.219 11.8303 14.3192 10.9425C13.6597 10.2916 12.3218 9.40736 13.5982 10.0297Z",
    fill: "url(#paint91_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 3,
    height: 6
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0859 9.83585H15.2069V14.1094H13.0859V9.83585Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.601 10.0478C13.601 10.0478 15.0633 10.8519 15.1884 12.2198C15.3326 13.7973 14.5855 14.3472 14.7151 14.0178C15.0504 13.171 15.2424 11.8345 14.3469 10.9279C13.7267 10.3 12.3339 9.42902 13.601 10.0478Z",
    fill: "url(#paint92_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 9,
    width: 3,
    height: 6
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1055 9.8461H15.195V14.0938H13.1055V9.8461Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6042 10.0587C13.6042 10.0587 15.0507 10.8531 15.1758 12.2058C15.3203 13.7748 14.5997 14.3312 14.7287 14.0034C15.0614 13.1612 15.2647 11.8324 14.375 10.9061C13.7937 10.3018 12.3469 9.4431 13.6042 10.0587Z",
    fill: "url(#paint93_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69141 8.45233H14.7839V15.4297H9.69141V8.45233Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask129_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71484 8.50486H14.7704V15.4062H9.71484V8.50486Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4185 10.602C10.854 11.0608 11.8786 11.6156 12.2927 11.9518C12.499 12.1199 12.9497 12.4669 13.3241 12.9334C13.7958 13.5183 13.9468 14.4572 13.5465 15.3033C13.3548 15.7113 14.3865 14.8202 14.6157 14.1484C14.844 13.4756 15.0467 12.086 13.4696 11.0598C11.8931 10.0352 11.0247 9.51406 10.3102 8.76075C9.41593 7.81442 9.59246 9.73036 10.4185 10.602Z",
    fill: "url(#paint94_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73438 8.55806H14.7551V15.3828H9.73438V8.55806Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4265 10.6094C10.8607 11.0656 11.8781 11.6172 12.2926 11.9544C12.4999 12.1241 12.9544 12.4778 13.3295 12.9492C13.7905 13.5279 13.9396 14.4471 13.5529 15.2799C13.3641 15.686 14.3789 14.8037 14.6056 14.1354C14.8312 13.4662 15.0184 12.0885 13.4484 11.0691C11.8791 10.0517 11.0336 9.54991 10.3253 8.80759C9.44716 7.88744 9.60364 9.74358 10.4265 10.6094Z",
    fill: "url(#paint95_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75391 8.6106H14.7387V15.3594H9.75391V8.6106Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4343 10.6173C10.8666 11.0703 11.8773 11.6183 12.2921 11.9568C12.5006 12.1282 12.9591 12.4883 13.3344 12.9649C13.7854 13.5375 13.9335 14.4373 13.5588 15.2565C13.3735 15.661 14.371 14.7868 14.595 14.1224C14.8184 13.4573 14.9894 12.091 13.4269 11.0787C11.8647 10.068 11.0431 9.58502 10.3402 8.85434C9.47895 7.95909 9.61441 9.75702 10.4343 10.6173Z",
    fill: "url(#paint96_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77734 8.66314H14.7266V15.3359H9.77734V8.66314Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4454 10.6248C10.8764 11.0748 11.8799 11.6193 12.2951 11.9591C12.5049 12.132 12.9679 12.4984 13.3436 12.9804C13.7845 13.5462 13.9313 14.4275 13.5686 15.2332C13.3872 15.6358 14.3668 14.7699 14.5883 14.1094C14.8094 13.4476 14.9646 12.0932 13.4092 11.0878C11.8541 10.0842 11.0565 9.61959 10.3588 8.90055C9.51491 8.0302 9.62936 9.76994 10.4454 10.6248Z",
    fill: "url(#paint97_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79688 8.71568H14.7106V15.3125H9.79688V8.71568Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4533 10.6324C10.8823 11.0798 11.8791 11.6204 12.2945 11.9618C12.5053 12.1361 12.9725 12.5085 13.3485 12.9961C13.7795 13.5554 13.9253 14.418 13.5745 15.2098C13.3967 15.6107 14.3589 14.7533 14.5781 14.0963C14.7963 13.4384 14.936 12.0957 13.3876 11.0973C11.8396 10.1005 11.0656 9.65468 10.3737 8.94728C9.54704 8.10182 9.64015 9.78336 10.4533 10.6324Z",
    fill: "url(#paint98_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82031 8.76886H14.6991V15.2891H9.82031V8.76886Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.465 10.6398C10.8924 11.084 11.8821 11.6214 12.2982 11.9641C12.5099 12.1399 12.982 12.5185 13.3576 13.0116C13.7792 13.5645 13.9231 14.4083 13.5843 15.1865C13.4107 15.5855 14.3551 14.7365 14.5717 14.083C14.7873 13.429 14.9115 12.0979 13.3702 11.1066C11.8297 10.1167 11.0796 9.68958 10.3929 8.99381C9.58299 8.17325 9.65509 9.79627 10.465 10.6398Z",
    fill: "url(#paint99_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83984 8.82109H14.6834V15.2656H9.83984V8.82109Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4731 10.6477C10.8985 11.0887 11.8814 11.6225 12.2975 11.9665C12.5109 12.1437 12.9868 12.5287 13.3628 13.0273C13.7744 13.5733 13.9176 14.3987 13.5904 15.163C13.4204 15.5604 14.3473 14.7198 14.5613 14.0703C14.7747 13.4198 14.8827 12.1003 13.3489 11.1158C11.8155 10.133 11.0893 9.72433 10.4078 9.0402C9.61533 8.24453 9.66608 9.80935 10.4731 10.6477Z",
    fill: "url(#paint100_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85938 8.87362H14.6683V15.2422H9.85938V8.87362Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4808 10.6547C10.9046 11.0931 11.8807 11.6233 12.2971 11.9686C12.5115 12.1477 12.9919 12.5386 13.3683 13.043C13.7701 13.5819 13.9118 14.3889 13.5965 15.1396C13.4303 15.5354 14.3395 14.7028 14.5509 14.0569C14.7617 13.4102 14.8542 12.1024 13.3275 11.1251C11.8012 10.1493 11.0986 9.75909 10.4229 9.08661C9.64794 8.31583 9.67703 9.82246 10.4808 10.6547Z",
    fill: "url(#paint101_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87891 8.92616H14.6532V15.2188H9.87891V8.92616Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4888 10.6626C10.911 11.0981 11.88 11.6244 12.297 11.971C12.5124 12.1514 12.9976 12.5485 13.3737 13.0587C13.7658 13.5905 13.9065 14.3794 13.6029 15.1162C13.4403 15.5103 14.3319 14.6859 14.5408 14.0438C14.749 13.401 14.826 12.1046 13.3064 11.1343C11.7872 10.1654 11.1089 9.79387 10.438 9.13302C9.68048 8.38682 9.68824 9.83557 10.4888 10.6626Z",
    fill: "url(#paint102_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 6,
    height: 8
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 8.98619H14.6385V15.2031H9.89844V8.98619Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4969 10.6778C10.9172 11.1104 11.8794 11.6332 12.2965 11.9814C12.5131 12.1634 13.0029 12.5663 13.3789 13.0819C13.7617 13.6067 13.9007 14.3778 13.6091 15.1007C13.4504 15.4929 14.3243 14.6768 14.5309 14.0383C14.7365 13.3994 14.7976 12.1146 13.2852 11.1515C11.7734 10.1896 11.1187 9.83656 10.4533 9.18735C9.71324 8.46605 9.69933 9.85661 10.4969 10.6778Z",
    fill: "url(#paint103_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 6,
    height: 7
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 9.03873H14.6241V15.1797H9.91797V9.03873Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5088 10.6853C10.9275 11.115 11.8829 11.6342 12.3003 11.9837C12.5182 12.167 13.0129 12.576 13.3886 13.0975C13.7617 13.6154 13.8997 14.3684 13.6194 15.0771C13.4645 15.468 14.3207 14.6601 14.5247 14.0254C14.728 13.3901 14.773 12.1169 13.268 11.1605C11.7633 10.2055 11.1328 9.87118 10.4726 9.23394C9.75004 8.53688 9.71447 9.86957 10.5088 10.6853Z",
    fill: "url(#paint104_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 6,
    height: 7
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94141 9.09127H14.6132V15.1562H9.94141V9.09127Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5169 10.693C10.9339 11.1195 11.8822 11.6355 12.2999 11.9859C12.5191 12.1709 13.0183 12.586 13.394 13.113C13.7581 13.6242 13.8948 14.359 13.6255 15.0538C13.4748 15.4428 14.3132 14.6429 14.5146 14.0121C14.7154 13.3807 14.7448 12.1191 13.2469 11.1696C11.7493 10.222 11.1431 9.90577 10.4878 9.28048C9.78328 8.60768 9.72573 9.88281 10.5169 10.693Z",
    fill: "url(#paint105_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 6,
    height: 7
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96094 9.14349H14.5991V15.1328H9.96094V9.14349Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.525 10.7006C10.9407 11.1241 11.8819 11.6366 12.2999 11.9883C12.5201 12.1749 13.0242 12.5958 13.3995 13.1287C13.5895 13.4031 13.7099 13.7196 13.7503 14.0508C13.7908 14.3821 13.7502 14.7183 13.632 15.0304C13.4852 15.4177 14.3058 14.6262 14.5046 13.999C14.7028 13.3715 14.7167 12.1215 13.2259 11.1791C11.7354 10.2383 11.1532 9.94049 10.5033 9.32684C9.81659 8.67893 9.73706 9.89588 10.525 10.7006Z",
    fill: "url(#paint106_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 6,
    height: 7
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98047 9.1957H14.5851V15.1094H9.98047V9.1957Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5333 10.7079C10.9475 11.1285 11.8818 11.6374 12.3002 11.9904C12.5216 12.1786 13.0302 12.6054 13.4053 13.144C13.5905 13.4132 13.7083 13.7228 13.749 14.047C13.7896 14.3712 13.7518 14.7004 13.6387 15.0069C13.4961 15.3926 14.2986 14.6093 14.4948 13.9859C14.6907 13.3619 14.6885 12.1236 13.2051 11.188C11.7218 10.2543 11.1641 9.9746 10.5191 9.37325C9.84981 8.74958 9.74862 9.90897 10.5333 10.7079Z",
    fill: "url(#paint107_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 7
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.24825H14.5713V15.0859H10V9.24825Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5418 10.7153C10.954 11.133 11.8813 11.6384 12.3 11.993C12.5227 12.1825 13.0362 12.6148 13.4109 13.1595C13.5912 13.4234 13.7064 13.7263 13.7471 14.0433C13.7879 14.3603 13.753 14.6824 13.6453 14.9833C13.5066 15.3677 14.2912 14.5924 14.4852 13.9727C14.6782 13.3526 14.6605 12.1259 13.1842 11.1974C11.7083 10.2704 11.1745 10.0092 10.5344 9.41981C9.88356 8.82039 9.76005 9.9219 10.5418 10.7153Z",
    fill: "url(#paint108_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 7
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 9.30014H14.5575V15.0625H10.0195V9.30014Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5503 10.7226C10.9609 11.1374 11.8813 11.6392 12.3004 11.9948C12.5241 12.1862 13.0427 12.6243 13.4171 13.1749C13.7446 13.6569 13.8765 14.3217 13.6518 14.9599C13.5173 15.3427 14.2842 14.5755 14.4753 13.9592C14.6663 13.343 14.6327 12.128 13.1639 11.2063C11.6948 10.2864 11.1856 10.0436 10.5503 9.46588C9.91723 8.89071 9.77174 9.93467 10.5503 10.7226Z",
    fill: "url(#paint109_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 7
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0391 9.35236H14.5441V15.0391H10.0391V9.35236Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5586 10.73C10.9676 11.1419 11.8813 11.6401 12.3006 11.9974C12.5253 12.1901 13.0488 12.6337 13.4228 13.1907C13.7413 13.665 13.8722 14.3123 13.6585 14.9363C13.5282 15.3178 14.277 14.5586 14.4655 13.9463C14.654 13.3336 14.6049 12.1299 13.1432 11.2156C11.6812 10.3026 11.1965 10.0779 10.5658 9.51242C9.95114 8.96118 9.78367 9.94792 10.5586 10.73Z",
    fill: "url(#paint110_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 7
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0586 9.40424H14.5309V15.0156H10.0586V9.40424Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5675 10.7376C10.9746 11.1463 11.8811 11.641 12.3008 11.9995C12.5271 12.1938 13.0557 12.6429 13.4288 13.2058C13.7385 13.673 13.8682 14.3031 13.6655 14.9128C13.5394 15.2927 14.2701 14.5414 14.4563 13.9329C14.6422 13.3241 14.5769 12.1321 13.1226 11.2249C11.6677 10.3186 11.2077 10.112 10.5817 9.55883C9.98524 9.03151 9.79545 9.9607 10.5675 10.7376Z",
    fill: "url(#paint111_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0781 9.45647H14.5181V14.9922H10.0781V9.45647Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5763 10.7452C10.982 11.1509 11.8815 11.642 12.3015 12.0019C12.5288 12.1978 13.0626 12.6527 13.435 13.2217C13.736 13.6812 13.8647 14.2941 13.6726 14.8894C13.5504 15.2676 14.2633 14.5247 14.447 13.9198C14.6303 13.3148 14.5495 12.1344 13.1023 11.234C11.6549 10.3349 11.219 10.1464 10.5976 9.60518C10.0196 9.10211 9.80746 9.97407 10.5763 10.7452Z",
    fill: "url(#paint112_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0977 9.50803H14.5053V14.9688H10.0977V9.50803Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5851 10.7524C10.9892 11.1556 11.8819 11.6428 12.3022 12.0039C12.5307 12.2012 13.0694 12.6619 13.4412 13.2371C13.7335 13.6894 13.8612 14.2846 13.6798 14.8659C13.5621 15.2426 14.2566 14.5077 14.4376 13.9063C14.6187 13.3053 14.522 12.1365 13.082 11.2432C11.6416 10.3509 11.2307 10.1802 10.6138 9.65154C10.0542 9.17175 9.81947 9.98681 10.5851 10.7524Z",
    fill: "url(#paint113_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1172 9.55994H14.4932V14.9453H10.1172V9.55994Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.594 10.7597C10.9965 11.16 11.8821 11.6437 12.3027 12.0061C12.5326 12.2049 13.077 12.6712 13.4479 13.2525C13.7314 13.697 13.8581 14.2754 13.6871 14.8422C13.5736 15.2179 14.25 14.4904 14.4285 13.8933C14.6069 13.2958 14.4944 12.1387 13.0618 11.2521C11.6286 10.3669 11.2426 10.214 10.6302 9.69767C10.089 9.2418 9.83163 9.99997 10.594 10.7597Z",
    fill: "url(#paint114_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1367 9.61182H14.4807V14.9219H10.1367V9.61182Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6033 10.767C11.0035 11.1643 11.8826 11.6448 12.3036 12.0085C12.5344 12.2086 13.0844 12.68 13.4542 13.2678C13.7294 13.7046 13.8548 14.2665 13.6944 14.8187C13.5855 15.1928 14.2434 14.4734 14.4193 13.8798C14.5955 13.2862 14.4672 12.1407 13.0417 11.2613C11.6156 10.3829 11.2544 10.2477 10.6463 9.74402C10.1241 9.31176 9.84382 10.0127 10.6033 10.767Z",
    fill: "url(#paint115_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 9.67089H14.4689V14.9062H10.1562V9.67089Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6125 10.7825C11.0115 11.1766 11.8835 11.6535 12.3044 12.0185C12.5365 12.2203 13.0923 12.6968 13.4612 13.2911C13.7276 13.7204 13.8521 14.2652 13.7018 14.8029C13.5976 15.1757 14.2372 14.4644 14.4108 13.8743C14.5841 13.2846 14.4402 12.1508 13.0218 11.2782C11.6028 10.4068 11.2669 10.2891 10.663 9.79836C10.1592 9.38938 9.8563 10.0337 10.6125 10.7825Z",
    fill: "url(#paint116_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1758 9.72246H14.4574V14.8828H10.1758V9.72246Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6218 10.7898C11.0191 11.181 11.8843 11.6543 12.3056 12.0206C12.539 12.224 13.1003 12.7057 13.4679 13.3064C13.7255 13.728 13.8497 14.256 13.7094 14.7794C13.6101 15.1506 14.2309 14.4474 14.4019 13.8612C14.5729 13.275 14.4132 12.1528 13.002 11.2873C11.5904 10.4228 11.2794 10.3222 10.6793 9.84439C10.195 9.45868 9.86877 10.0465 10.6218 10.7898Z",
    fill: "url(#paint117_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1914 9.77371H14.442V14.8594H10.1914V9.77371Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6276 10.797C11.023 11.1853 11.8811 11.6551 12.303 12.0227C12.5374 12.2277 13.1045 12.7146 13.4708 13.3221C13.7204 13.7356 13.8436 14.2471 13.7133 14.7557C13.6185 15.1259 14.2209 14.4301 14.3893 13.8478C14.5578 13.2655 14.3825 12.1546 12.9784 11.2962C11.5736 10.4391 11.2884 10.3554 10.6923 9.89082C10.2267 9.52806 9.87752 10.0596 10.6276 10.797Z",
    fill: "url(#paint118_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2148 9.82494H14.4347V14.8359H10.2148V9.82494Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6412 10.8044C11.035 11.1898 11.8863 11.656 12.3082 12.0249C12.5439 12.2315 13.1171 12.7236 13.4818 13.3376C13.723 13.7436 13.8455 14.238 13.7252 14.732C13.6354 15.1009 14.2189 14.4135 14.3848 13.8345C14.5507 13.2561 14.3596 12.1568 12.9629 11.3055C11.5655 10.4549 11.3056 10.3883 10.713 9.9373C10.2665 9.5975 9.89434 10.0724 10.6412 10.8044Z",
    fill: "url(#paint119_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2305 9.86838H14.4199V14.8047H10.2305V9.86838Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6469 10.8037C11.0391 11.1862 11.8836 11.6489 12.3058 12.0194C12.5428 12.2273 13.1222 12.7242 13.4849 13.3449C13.7177 13.7433 13.8399 14.2208 13.7294 14.7006C13.6443 15.0682 14.2092 14.3883 14.3724 13.8134C14.536 13.2386 14.3291 12.151 12.9395 11.3065C11.5493 10.4633 11.3152 10.4128 10.7261 9.9754C10.299 9.65824 9.90331 10.0772 10.6469 10.8037Z",
    fill: "url(#paint120_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9.9193H14.4097V14.7812H10.25V9.9193Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6569 10.8111C11.0474 11.1907 11.8848 11.6498 12.3077 12.0216C12.5457 12.2311 13.1315 12.7328 13.4926 13.3604C13.7173 13.751 13.8386 14.212 13.7377 14.6769C13.6582 15.0432 14.2036 14.3714 14.3646 13.8001C14.5256 13.2288 14.3028 12.1532 12.9204 11.3158C11.5372 10.4794 11.3294 10.4451 10.7432 10.0219C10.3355 9.72736 9.91649 10.0904 10.6569 10.8111Z",
    fill: "url(#paint121_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 5,
    height: 6
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 9.96991H14.3953V14.7578H10.2656V9.96991Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6632 10.8185C11.0519 11.1948 11.8824 11.6504 12.3053 12.0235C12.5446 12.2346 13.1369 12.7412 13.4961 13.3756C13.7127 13.7584 13.8336 14.2029 13.7421 14.6533C13.6678 15.0183 14.1944 14.3542 14.3525 13.7865C14.511 13.2194 14.2724 12.1551 12.8973 11.3245C11.5213 10.4952 11.3399 10.4764 10.7567 10.0681C10.3684 9.79587 9.92577 10.103 10.6632 10.8185Z",
    fill: "url(#paint122_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 5,
    height: 5
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2891 10.0205H14.389V14.7344H10.2891V10.0205Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6775 10.8259C11.0648 11.1993 11.8883 11.6513 12.3115 12.0257C12.5517 12.2384 13.1511 12.7496 13.5077 13.391C13.7166 13.7657 13.8365 14.1938 13.7544 14.6296C13.6859 14.9933 14.1931 14.3373 14.3487 13.7732C14.5045 13.2096 14.2504 12.1573 12.8824 11.3338C11.5139 10.5113 11.3584 10.5077 10.778 10.1146C10.4091 9.86434 9.94323 10.1162 10.6775 10.8259Z",
    fill: "url(#paint123_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 5,
    height: 5
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 10.078H14.3755V14.7188H10.3047V10.078Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6838 10.8408C11.0695 11.2116 11.8859 11.6597 12.3098 12.0354C12.5513 12.2498 13.1571 12.7658 13.5115 13.414C13.7123 13.7813 13.8329 14.1922 13.7592 14.6138C13.6968 14.9762 14.184 14.3277 14.3369 13.7677C14.4905 13.2077 14.2205 12.167 12.8597 11.3503C11.4982 10.5349 11.3696 10.5462 10.7918 10.1683C10.4423 9.94036 9.95314 10.1366 10.6838 10.8408Z",
    fill: "url(#paint124_linear_10834_56546)"
  })))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9441 4.90363C16.9441 4.90363 14.8226 4.23276 12.8743 4.74262C10.9021 5.25991 9.54418 6.74359 9.53125 8.23438C9.53125 8.23438 9.61014 6.01776 12.5671 4.93111C14.3925 4.25959 16.9441 4.90363 16.9441 4.90363ZM18.0754 5.50887L17.2154 7.23179C17.2154 7.23179 17.69 5.96506 18.0754 5.50855",
    fill: "#00C2F3"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7326 5.95206C13.7326 5.95206 12.4849 6.36072 12.1742 7.56311C12.0688 7.97372 12.3009 8.41406 12.3009 8.41406C12.3009 8.41406 11.967 8.05519 12.1471 7.44316C12.3524 6.74546 13.0216 6.16932 13.7326 5.95173",
    fill: "#00C2F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 3,
    height: 3
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M11.043 11.1502H13.7119V13.9297H11.043V11.1502Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.043 11.1502C11.043 11.1502 12.4539 12.155 12.7323 12.4263C13.0536 12.7386 13.6107 13.3801 13.7119 13.9297C13.7119 13.9297 13.6731 13.1505 12.7323 12.3322C11.9553 11.6571 11.043 11.1502 11.043 11.1502Z",
    fill: "#00C2F3"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 4,
    height: 5
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8711 12.4368H15.6241V16.1406H12.8711V12.4368Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6014 12.4368C15.6014 12.4368 15.8219 13.5693 14.8814 14.6324C14.0757 15.5419 12.8711 16.1406 12.8711 16.1406C12.8711 16.1406 14.5222 15.0569 15.1006 14.0731C15.6955 13.0605 15.6018 12.4371 15.6018 12.4371",
    fill: "#00C2F3"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 11,
    width: 11,
    height: 7
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47656 11.978H17.536V17.6562H7.47656V11.978Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask163_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48828 12.0528H17.4928V17.6406H7.48828V12.0528Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2396 12.3178C16.344 14.333 14.6544 16.4229 12.1979 16.7083C12.1979 16.7083 10.9305 16.8377 9.91788 16.46C8.07501 15.7698 7.45943 14.1846 7.54478 12.7475C7.54478 12.7475 7.53702 12.6883 7.50566 13.1513C7.40673 14.6094 7.62205 17.6676 11.0818 17.6404C15.9612 17.6013 17.493 12.0533 17.493 12.0533",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50391 12.1278H17.4544V17.625H7.50391V12.1278Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2093 12.3849C16.3211 14.3642 14.6315 16.4344 12.1931 16.7141C12.1931 16.7141 10.9341 16.8402 9.92994 16.4693C8.10291 15.7913 7.48539 14.2314 7.55458 12.8052C7.55458 12.8052 7.54747 12.7513 7.51837 13.2045C7.42849 14.6368 7.65965 17.651 11.0948 17.6248C15.9244 17.5867 17.454 12.1279 17.454 12.1279",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 12.2023H17.4115V17.6094H7.51562V12.2023Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1748 12.4527C16.2944 14.3958 14.6051 16.4466 12.1841 16.7208C12.1841 16.7208 10.9339 16.843 9.93842 16.4789C8.12691 15.8135 7.5081 14.2781 7.5608 12.8633C7.5608 12.8633 7.55401 12.8152 7.5275 13.2584C7.44634 14.6648 7.69335 17.6348 11.104 17.6092C15.8838 17.573 17.4114 12.2028 17.4114 12.2028",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52734 12.2779H17.3692V17.5938H7.52734V12.2779Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1408 12.5202C16.2679 14.4268 14.5789 16.4585 12.1757 16.7268C12.1757 16.7268 10.9339 16.8451 9.94714 16.4885C8.15148 15.8351 7.53072 14.3249 7.56726 12.9211C7.56726 12.9211 7.56079 12.8781 7.53686 13.312C7.46444 14.6925 7.7273 17.6182 11.1133 17.5936C15.8434 17.5584 17.3694 12.2777 17.3694 12.2777",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 12.345H17.3276V17.5703H7.53906V12.345Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1073 12.5796C16.2421 14.4499 14.5532 16.4625 12.1678 16.725C12.1678 16.725 10.935 16.8398 9.95666 16.4897C8.17651 15.8489 7.55446 14.3636 7.57451 12.9711C7.57451 12.9711 7.56804 12.9336 7.54703 13.3574C7.48042 14.7121 7.76171 17.5935 11.1235 17.5702C15.8044 17.5362 17.3278 12.3442 17.3278 12.3442",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55078 12.4195H17.2863V17.5547H7.55078V12.4195Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0739 12.6467C16.2164 14.4812 14.5275 16.4741 12.1595 16.7311C12.1595 16.7311 10.9355 16.8426 9.96619 16.4989C8.20156 15.8708 7.57725 14.4104 7.58145 13.0292C7.58145 13.0292 7.57531 12.9968 7.55689 13.4107C7.49869 14.7395 7.79613 17.5769 11.1333 17.5546C15.7648 17.5216 17.2859 12.4191 17.2859 12.4191",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56641 12.4941H17.2486V17.5391H7.56641V12.4941Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0443 12.7148C16.1946 14.5127 14.5057 16.4862 12.1555 16.7378C12.1555 16.7378 10.9399 16.8454 9.97933 16.5089C8.23022 15.893 7.60462 14.4575 7.59233 13.0873C7.59233 13.0873 7.58651 13.0608 7.57099 13.4646C7.52055 14.7675 7.83481 17.5609 11.1475 17.5389C15.7288 17.5079 17.2483 12.494 17.2483 12.494",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57812 12.569H17.2073V17.5234H7.57812V12.569Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0113 12.782C16.1691 14.5437 14.4798 16.4978 12.1481 16.7435C12.1481 16.7435 10.9415 16.8479 9.98934 16.5178C8.25607 15.9142 7.62852 14.5036 7.59975 13.145C7.59975 13.145 7.59425 13.124 7.58132 13.5182C7.53929 14.7949 7.86971 17.544 11.1578 17.5233C15.6899 17.4929 17.2069 12.5683 17.2069 12.5683",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58984 12.6439H17.166V17.5078H7.58984V12.6439Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 12.8498C16.1441 14.5749 14.4552 16.5096 12.1406 16.7499C12.1406 16.7499 10.9427 16.8507 9.9993 16.5274C8.28187 15.9364 7.65206 14.551 7.60744 13.2031C7.60744 13.2031 7.60227 13.1876 7.59193 13.5717C7.55798 14.8229 7.90457 17.5277 11.1681 17.5077C15.6511 17.4789 17.1661 12.6438 17.1661 12.6438",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59766 12.7107H17.1214V17.4844H7.59766V12.7107Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9419 12.9091C16.1149 14.5984 14.4265 16.5134 12.1297 16.7481C12.1297 16.7481 10.9406 16.8454 10.0056 16.5289C8.30368 15.9502 7.67258 14.5897 7.61148 13.2531C7.61148 13.2531 7.60663 13.2434 7.59887 13.6175C7.573 14.8428 7.93608 17.503 11.1753 17.4843C15.6082 17.4565 17.1213 12.7106 17.1213 12.7106",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 12.7856H17.0811V17.4688H7.60938V12.7856Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.909 12.9769C16.0901 14.6297 14.4017 16.5256 12.1227 16.7545C12.1227 16.7545 10.9423 16.8482 10.016 16.5385C8.32964 15.9724 7.6966 14.6365 7.61965 13.3115C7.61965 13.3115 7.61512 13.3067 7.60995 13.6711C7.59217 14.8705 7.97141 17.4868 11.1858 17.4687C15.5699 17.4425 17.0807 12.7855 17.0807 12.7855",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 11,
    height: 6
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62109 12.8605H17.0404V17.4531H7.62109V12.8605Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.877 13.0444C16.0655 14.6609 14.3771 16.5378 12.1159 16.7608C12.1159 16.7608 10.9442 16.8504 10.0267 16.5481C8.35613 15.9943 7.72115 14.6832 7.62772 13.3693C7.62772 13.3693 7.62384 13.37 7.62125 13.7249C7.61188 14.8986 8.00728 17.4702 11.1974 17.453C15.5314 17.4285 17.0403 12.8604 17.0403 12.8604",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 10,
    height: 6
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63281 12.9354H17.0004V17.4375H7.63281V12.9354Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8452 13.1119C16.0411 14.6922 14.3531 16.5496 12.1097 16.7672C12.1097 16.7672 10.9467 16.8532 10.0379 16.557C8.38289 16.0158 7.7463 14.73 7.63637 13.4274C7.63637 13.4274 7.63314 13.4335 7.63281 13.7785C7.63184 14.9263 8.04342 17.4539 11.2089 17.4374C15.4935 17.4141 17.0004 12.9353 17.0004 12.9353",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64062 13.01H16.9575V17.4219H7.64062V13.01Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8102 13.1793C16.0139 14.7235 14.3259 16.5611 12.1003 16.7732C12.1003 16.7732 10.946 16.856 10.0459 16.5666C8.40676 16.0377 7.76822 14.7768 7.64213 13.4855C7.64213 13.4855 7.63922 13.4968 7.64149 13.8321C7.64892 14.954 8.07634 17.437 11.2176 17.4218C15.453 17.3995 16.9574 13.0099 16.9574 13.0099",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64844 13.0771H16.9158V17.3984H7.64844V13.0771Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7768 13.2393C15.9883 14.7472 14.3003 16.5655 12.0921 16.7718C12.0921 16.7718 10.9466 16.851 10.0552 16.5688C8.43121 16.0521 7.79138 14.8158 7.64913 13.5358C7.64913 13.5358 7.64654 13.5526 7.65139 13.8778C7.66756 14.9739 8.11082 17.4129 11.2275 17.3984C15.4131 17.3777 16.9159 13.0773 16.9159 13.0773",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65625 13.152H16.8745V17.3828H7.65625V13.152Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7438 13.3065C15.9627 14.7775 14.275 16.5771 12.0846 16.7778C12.0846 16.7778 10.9481 16.8535 10.0652 16.5774C8.45701 16.0737 7.81491 14.8625 7.65649 13.5932C7.65649 13.5932 7.65455 13.6159 7.66166 13.9314C7.68591 15.0016 8.14598 17.3963 11.2381 17.3828C15.3739 17.3634 16.8744 13.1519 16.8744 13.1519",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 13.2265H16.8335V17.3672H7.66406V13.2265Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7107 13.3739C15.937 14.8094 14.2497 16.5889 12.077 16.7839C12.077 16.7839 10.9487 16.856 10.0748 16.5873C8.48247 16.0952 7.83876 14.9093 7.66417 13.651C7.66417 13.651 7.66255 13.6791 7.67193 13.9847C7.70491 15.0296 8.18082 17.3797 11.2484 17.3671C15.3347 17.3487 16.8333 13.2265 16.8333 13.2265",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67188 13.3015H16.7925V17.3516H7.67188V13.3015Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.678 13.4414C15.9121 14.8404 14.2247 16.6005 12.0699 16.7899C12.0699 16.7899 10.9506 16.8585 10.0851 16.5966C8.5083 16.1171 7.86297 14.9558 7.67189 13.7094C7.67189 13.7094 7.67093 13.7427 7.68289 14.0382C7.72427 15.0573 8.21635 17.3632 11.2593 17.3515C15.2962 17.3344 16.7925 13.3014 16.7925 13.3014",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67969 13.3764H16.7518V17.3359H7.67969V13.3764Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6454 13.5089C15.8872 14.8716 14.1999 16.6127 12.0628 16.7963C12.0628 16.7963 10.9522 16.8613 10.0955 16.6059C8.5342 16.139 7.88725 15.0029 7.67969 13.7672C7.67969 13.7672 7.67969 13.8063 7.69359 14.0918C7.7437 15.085 8.25162 17.3466 11.27 17.3359C15.2574 17.3201 16.7518 13.3763 16.7518 13.3763",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6875 13.4435H16.7108V17.3125H7.6875V13.4435Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6128 13.5689C15.8624 14.8954 14.175 16.617 12.0557 16.7952C12.0557 16.7952 10.9539 16.856 10.1059 16.6076C8.56011 16.1534 7.91123 15.0419 7.6875 13.8175C7.6875 13.8175 7.6875 13.8621 7.70463 14.1376C7.7638 15.1052 8.2866 17.3228 11.2805 17.3125C15.2184 17.2986 16.7111 13.4434 16.7111 13.4434",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69531 13.518H16.6701V17.2969H7.69531V13.518Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5799 13.6363C15.8372 14.9263 14.1499 16.6289 12.0484 16.8015C12.0484 16.8015 10.9556 16.8591 10.1156 16.6172C8.58571 16.1753 7.93521 15.0886 7.69531 13.8756C7.69531 13.8756 7.69629 13.9254 7.71536 14.1914C7.78326 15.1329 8.32189 17.3062 11.2915 17.2968C15.1796 17.2839 16.6701 13.5183 16.6701 13.5183",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 13.5929H16.6288V17.2812H7.70312V13.5929Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.547 13.6963C15.8117 14.9501 14.1247 16.6333 12.0407 16.8001C12.0407 16.8001 10.9566 16.8541 10.1257 16.619C8.6113 16.189 7.95886 15.1279 7.70312 13.9259C7.70312 13.9259 7.70442 13.9815 7.72576 14.2375C7.80271 15.1535 8.35686 17.2821 11.3019 17.2734C15.1406 17.2621 16.6288 13.5857 16.6288 13.5857",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71094 13.6678H16.5881V17.2656H7.71094V13.6678Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5144 13.7716C15.7869 14.9889 14.1002 16.6526 12.0339 16.8139C12.0339 16.8139 10.9583 16.864 10.1358 16.6361C8.63755 16.219 7.98316 15.1822 7.71094 13.9914C7.71094 13.9914 7.7132 14.0522 7.7368 14.2986C7.8228 15.1887 8.39248 17.273 11.3126 17.2656C15.1018 17.2553 16.5881 13.6678 16.5881 13.6678",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71875 13.7346H16.5474V17.2422H7.71875V13.7346Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4818 13.8309C15.7617 15.0123 14.075 16.6567 12.0265 16.8118C12.0265 16.8118 10.9599 16.8591 10.1462 16.6376C8.66314 16.2328 8.00747 15.2215 7.71875 14.0417C7.71875 14.0417 7.72198 14.108 7.74785 14.3443C7.84258 15.2086 8.42777 17.2486 11.3237 17.2422C15.0634 17.2331 16.5474 13.7349 16.5474 13.7349",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72656 13.8098H16.5067V17.2266H7.72656V13.8098Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4492 13.8984C15.7369 15.0436 14.0502 16.6682 12.0195 16.8182C12.0195 16.8182 10.9616 16.8615 10.1566 16.6472C8.68938 16.2547 8.03177 15.2676 7.72656 14.0995C7.72656 14.0995 7.73044 14.1716 7.75857 14.3979C7.86332 15.2362 8.46306 17.2324 11.3344 17.2265C15.0246 17.2191 16.5067 13.8098 16.5067 13.8098",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73047 13.8766H16.4618V17.2031H7.73047V13.8766Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4126 13.9655C15.7078 15.0745 14.0214 16.6797 12.0085 16.8236C12.0085 16.8236 10.959 16.8637 10.1624 16.6561C8.71139 16.2759 8.05184 15.3141 7.73047 14.1569C7.73047 14.1569 7.735 14.2345 7.76539 14.4511C7.87952 15.2636 8.49445 17.2151 11.3412 17.2109C14.9817 17.2041 16.4618 13.8841 16.4618 13.8841",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 10,
    height: 5
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73828 13.9515H16.4211V17.1875H7.73828V13.9515Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3797 14.0252C15.6827 15.0979 13.9963 16.6838 12.0011 16.8225C12.0011 16.8225 10.9607 16.8587 10.1728 16.6576C8.73731 16.29 8.07582 15.353 7.73828 14.2069C7.73828 14.2069 7.74378 14.2903 7.77611 14.4969C7.89994 15.2835 8.52975 17.1911 11.3522 17.1875C14.9433 17.182 16.4208 13.9512 16.4208 13.9512",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 10,
    height: 4
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 14.0261H16.3837V17.1719H7.75V14.0261Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3471 14.093C15.6575 15.1295 13.9714 16.6963 11.9941 16.8288C11.9941 16.8288 10.9621 16.8615 10.1835 16.6675C8.7629 16.3122 8.0998 15.4001 7.74609 14.2656C7.74609 14.2656 7.75256 14.3536 7.78683 14.5508C7.92068 15.3115 8.56504 17.1745 11.363 17.1719C14.9045 17.168 16.3801 14.0261 16.3801 14.0261",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 10,
    height: 4
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75391 14.101H16.3388V17.1562H7.75391V14.101Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3142 14.1605C15.632 15.1605 13.9466 16.7078 11.9867 16.8352C11.9867 16.8352 10.9634 16.864 10.1933 16.6768C8.7885 16.3341 8.12377 15.4469 7.75391 14.3231C7.75391 14.3231 7.76102 14.4168 7.79756 14.6044C7.94175 15.3389 8.60001 17.1582 11.3734 17.1562C14.8651 17.1537 16.3391 14.101 16.3391 14.101",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 10,
    height: 4
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76172 14.1759H16.2981V17.1406H7.76172V14.1759Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2816 14.2276C15.6075 15.1914 13.9214 16.7197 11.9793 16.8409C11.9793 16.8409 10.9651 16.8668 10.2034 16.686C8.81442 16.3556 8.14807 15.4934 7.76172 14.3812C7.76172 14.3812 7.7698 14.4801 7.80827 14.6576C7.96282 15.366 8.6353 17.1413 11.3841 17.1406C14.8267 17.139 16.2981 14.1759 16.2981 14.1759",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 14,
    width: 10,
    height: 4
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 14.2505H16.2574V17.125H7.76953V14.2505Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.249 14.2954C15.5823 15.223 13.8969 16.7315 11.9722 16.8476C11.9722 16.8476 10.9667 16.8693 10.2138 16.6956C8.84033 16.3775 8.17238 15.5405 7.76953 14.4389C7.76953 14.4389 8.00231 17.125 11.3951 17.125C14.788 17.125 16.2577 14.2505 16.2577 14.2505",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.4186H7.5797V15.7969H6V12.4186Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask195_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01172 12.4395H7.5746V15.7812H6.01172V12.4395Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5746 12.4395L6.01172 15.7812C6.01172 15.7812 7.22704 14.2368 7.5746 12.4395Z",
    fill: "url(#paint125_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02344 12.4526H7.56918V15.7578H6.02344V12.4526Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56918 12.4526L6.02344 15.7578C6.02344 15.7578 7.22324 14.2221 7.56918 12.4526Z",
    fill: "url(#paint126_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03125 12.4732H7.56019V15.7422H6.03125V12.4732Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56019 12.4732L6.03125 15.7422C6.03125 15.7422 7.21586 14.2149 7.56019 12.4732Z",
    fill: "url(#paint127_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04297 12.4941H7.55477V15.7266H6.04297V12.4941Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55477 12.4941L6.04297 15.7266C6.04297 15.7266 7.21173 14.208 7.55477 12.4941Z",
    fill: "url(#paint128_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05469 12.5072H7.54968V15.7031H6.05469V12.5072Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.54968 12.5072L6.05469 15.7031C6.05469 15.7031 7.20826 14.1933 7.54968 12.5072Z",
    fill: "url(#paint129_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06641 12.5281H7.5449V15.6875H6.06641V12.5281Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5449 12.5281L6.06641 15.6875C6.06641 15.6875 7.20478 14.1864 7.5449 12.5281Z",
    fill: "url(#paint130_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07422 12.5412H7.53558V15.6641H6.07422V12.5412Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53558 12.5412L6.07422 15.6641C6.07422 15.6641 7.19708 14.1717 7.53558 12.5412Z",
    fill: "url(#paint131_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08594 12.5618H7.53049V15.6484H6.08594V12.5618Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53049 12.5618L6.08594 15.6484C6.08594 15.6484 7.1936 14.1644 7.53049 12.5618Z",
    fill: "url(#paint132_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09766 12.5749H7.52539V15.625H6.09766V12.5749Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52539 12.5749L6.09766 15.625C6.09766 15.625 7.19012 14.1494 7.52539 12.5749Z",
    fill: "url(#paint133_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask204_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10938 12.5958H7.5203V15.6094H6.10938V12.5958Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask204_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5203 12.5958L6.10938 15.6094C6.10938 15.6094 7.186 14.1428 7.5203 12.5958Z",
    fill: "url(#paint134_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask205_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 12.6086H7.51131V15.5859H6.11719V12.6086Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask205_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.51131 12.6086L6.11719 15.5859C6.11719 15.5859 7.17862 14.1275 7.51131 12.6086Z",
    fill: "url(#paint135_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask206_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12891 12.622H7.50588V15.5625H6.12891V12.622Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask206_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50588 12.6217L6.12891 15.5625C6.12891 15.5625 7.17481 14.1128 7.50588 12.6217Z",
    fill: "url(#paint136_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask207_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14062 12.6426H7.50079V15.5469H6.14062V12.6426Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask207_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50079 12.6426L6.14062 15.5469C6.14062 15.5469 7.17102 14.1059 7.50079 12.6426Z",
    fill: "url(#paint137_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask208_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15234 12.6557H7.4957V15.5234H6.15234V12.6557Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask208_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4957 12.6557L6.15234 15.5234C6.15234 15.5234 7.16754 14.0909 7.4957 12.6557Z",
    fill: "url(#paint138_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask209_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16406 12.6766H7.49028V15.5078H6.16406V12.6766Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask209_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49028 12.6766L6.16406 15.5078C6.16406 15.5078 7.16374 14.0839 7.49028 12.6766Z",
    fill: "url(#paint139_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask210_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 12.6897H7.4816V15.4844H6.17188V12.6897Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask210_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4816 12.6897L6.17188 15.4844C6.17188 15.4844 7.15603 14.0692 7.4816 12.6897Z",
    fill: "url(#paint140_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask211_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18359 12.7106H7.47619V15.4688H6.18359V12.7106Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask211_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47619 12.7106L6.18359 15.4688C6.18359 15.4688 7.15223 14.0623 7.47619 12.7106Z",
    fill: "url(#paint141_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask212_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19531 12.7237H7.47109V15.4453H6.19531V12.7237Z",
    fill: "white"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask212_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47109 12.7237L6.19531 15.4453C6.19531 15.4453 7.14875 14.0476 7.47109 12.7237Z",
    fill: "url(#paint142_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask213_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20703 12.7443H7.466V15.4297H6.20703V12.7443Z",
    fill: "white"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask213_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.466 12.7443L6.20703 15.4297C6.20703 15.4297 7.14528 14.0404 7.466 12.7443Z",
    fill: "url(#paint143_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask214_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 12.7652H7.46091V15.4141H6.21875V12.7652Z",
    fill: "white"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask214_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.46091 12.7652L6.21875 15.4141C6.21875 15.4141 7.14148 14.0335 7.46091 12.7652Z",
    fill: "url(#paint144_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask215_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22656 12.7783H7.45191V15.3906H6.22656V12.7783Z",
    fill: "white"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask215_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45191 12.7783L6.22656 15.3906C6.22656 15.3906 7.1341 14.0188 7.45191 12.7783Z",
    fill: "url(#paint145_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask216_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23828 12.7992H7.44649V15.375H6.23828V12.7992Z",
    fill: "white"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask216_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.44649 12.7992L6.23828 15.375C6.23828 15.375 7.12997 14.0119 7.44649 12.7992Z",
    fill: "url(#paint146_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask217_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.812H7.4414V15.3516H6.25V12.812Z",
    fill: "white"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask217_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4414 12.812L6.25 15.3516C6.25 15.3516 7.1265 13.9969 7.4414 12.812Z",
    fill: "url(#paint147_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask218_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26172 12.8251H7.4363V15.3281H6.26172V12.8251Z",
    fill: "white"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask218_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4363 12.8251L6.26172 15.3281C6.26172 15.3281 7.12302 13.9822 7.4363 12.8251Z",
    fill: "url(#paint148_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask219_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26953 12.8382H7.42698V15.3047H6.26953V12.8382Z",
    fill: "white"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask219_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42698 12.8382L6.26953 15.3047C6.26953 15.3047 7.11531 13.9672 7.42698 12.8382Z",
    fill: "url(#paint149_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask220_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 12.8591H7.42221V15.2891H6.28125V12.8591Z",
    fill: "white"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask220_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42221 12.8591L6.28125 15.2891C6.28125 15.2891 7.11151 13.9602 7.42221 12.8591Z",
    fill: "url(#paint150_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask221_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29297 12.8718H7.41712V15.2656H6.29297V12.8718Z",
    fill: "white"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask221_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.41712 12.8718L6.29297 15.2656C6.29297 15.2656 7.10803 13.9455 7.41712 12.8718Z",
    fill: "url(#paint151_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask222_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30469 12.8931H7.4117V15.25H6.30469V12.8931Z",
    fill: "white"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask222_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4117 12.8931L6.30469 15.25C6.30469 15.25 7.10423 13.9383 7.4117 12.8931Z",
    fill: "url(#paint152_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask223_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3125 12.914H7.4027V15.2344H6.3125V12.914Z",
    fill: "white"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask223_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4027 12.914L6.3125 15.2344C6.3125 15.2344 7.09653 13.9314 7.4027 12.914Z",
    fill: "url(#paint153_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask224_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32422 12.9271H7.39761V15.2109H6.32422V12.9271Z",
    fill: "white"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask224_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39761 12.9271L6.32422 15.2109C6.32422 15.2109 7.09273 13.9171 7.39761 12.9271Z",
    fill: "url(#paint154_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask225_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 2,
    height: 4
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 12.9477H7.39252V15.1953H6.33594V12.9477Z",
    fill: "white"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask225_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39252 12.9477L6.33594 15.1953C6.33594 15.1953 7.08925 13.9095 7.39252 12.9477Z",
    fill: "url(#paint155_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask226_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6992 4.90214H20.4907V13.5859H16.6992V4.90214Z",
    fill: "white"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask226_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6353 4.92016C19.6353 4.92016 19.99 5.34629 19.6353 6.22828C19.3431 6.95185 16.7165 13.1261 16.7165 13.1261C16.7165 13.1261 16.5736 14.2115 17.11 13.0472C17.6466 11.882 20.3557 5.90852 20.4449 5.65311C20.6292 5.12643 20.236 4.8222 19.6353 4.92016Z",
    fill: "url(#paint156_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask227_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7109 4.92182H20.4814V13.5781H16.7109V4.92182Z",
    fill: "white"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask227_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6508 4.93738C19.6508 4.93738 19.9984 5.35995 19.6508 6.22383C19.364 6.93479 16.7274 13.1304 16.7274 13.1304C16.7274 13.1304 16.5894 14.1873 17.1119 13.0534C17.635 11.9183 20.3469 5.92025 20.4361 5.66677C20.6169 5.15077 20.2373 4.84847 19.6508 4.93738Z",
    fill: "url(#paint157_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask228_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 4.92618H20.464V13.5547H16.7148V4.92618Z",
    fill: "white"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask228_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6582 4.93904C19.6582 4.93904 19.998 5.35806 19.6582 6.20384C19.3766 6.90187 16.7307 13.1191 16.7307 13.1191C16.7307 13.1191 16.5971 14.1476 17.106 13.0438C17.6149 11.939 20.3304 5.91609 20.419 5.66456C20.5965 5.15922 20.2305 4.85854 19.6582 4.93904Z",
    fill: "url(#paint158_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask229_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 4.93804H20.4508V13.5391H16.7227V4.93804Z",
    fill: "white"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask229_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.013
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6698 4.94863C19.6698 4.94863 20.0025 5.36441 19.6698 6.19208C19.3934 6.87685 16.7377 13.1155 16.7377 13.1155C16.7377 13.1155 16.609 14.1158 17.104 13.0421C17.5993 11.9677 20.3177 5.92017 20.4063 5.67026C20.5803 5.17591 20.2278 4.87685 19.6698 4.94863Z",
    fill: "url(#paint159_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask230_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7266 4.94989H20.4336V13.5234H16.7266V4.94989Z",
    fill: "white"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask230_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.016
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6773 4.95825C19.6773 4.95825 20.0022 5.37048 19.6773 6.18005C19.406 6.85189 16.7409 13.1121 16.7409 13.1121C16.7409 13.1121 16.6168 14.0837 17.0979 13.0404C17.5793 11.9964 20.3012 5.9243 20.3892 5.676C20.5599 5.19265 20.2211 4.89521 19.6773 4.95825Z",
    fill: "url(#paint160_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask231_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7305 4.96174H20.4169V13.5078H16.7305V4.96174Z",
    fill: "white"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask231_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.019
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6845 4.96812C19.6845 4.96812 20.0027 5.37679 19.6845 6.16793C19.4188 6.82684 16.744 13.1088 16.744 13.1088C16.744 13.1088 16.6251 14.0515 17.0919 13.0389C17.5597 12.025 20.2849 5.92803 20.3725 5.68199C20.5397 5.20931 20.2144 4.91349 19.6845 4.96812Z",
    fill: "url(#paint161_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask232_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7422 4.97264H20.4072V13.4922H16.7422V4.97264Z",
    fill: "white"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask232_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.023
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7 4.9776C19.7 4.9776 20.0107 5.38304 19.7 6.15575C19.4394 6.80172 16.755 13.1053 16.755 13.1053C16.755 13.1053 16.6409 14.0196 17.0941 13.0371C17.5477 12.0539 20.2762 5.93202 20.3638 5.6876C20.5274 5.22591 20.2154 4.93169 19.7 4.9776Z",
    fill: "url(#paint162_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask233_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7461 4.98384H20.3904V13.4766H16.7461V4.98384Z",
    fill: "white"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask233_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.026
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7075 4.98709C19.7075 4.98709 20.0108 5.38896 19.7075 6.14357C19.4521 6.77661 16.7583 13.1019 16.7583 13.1019C16.7583 13.1019 16.6484 13.9877 17.0881 13.0353C17.5281 12.0825 20.2598 5.936 20.3467 5.6932C20.5071 5.24218 20.2087 4.94958 19.7075 4.98709Z",
    fill: "url(#paint163_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask234_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 4,
    width: 5,
    height: 10
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7539 4.99474H20.3769V13.4609H16.7539V4.99474Z",
    fill: "white"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask234_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.029
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7191 4.99663C19.7191 4.99663 20.0149 5.39495 19.7191 6.13145C19.4688 6.75156 16.7653 13.0985 16.7653 13.0985C16.7653 13.0985 16.6605 13.9556 17.0863 13.0338C17.5121 12.1111 20.247 5.94005 20.334 5.69918C20.4905 5.25883 20.206 4.96785 19.7191 4.99663Z",
    fill: "url(#paint164_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask235_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 5.00497H20.3601V13.4453H16.7578V5.00497Z",
    fill: "white"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask235_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7265 5.00612C19.7265 5.00612 20.0149 5.4012 19.7265 6.11927C19.4815 6.72645 16.7686 13.095 16.7686 13.095C16.7686 13.095 16.6683 13.9237 17.0802 13.032C17.4921 12.14 20.2306 5.94403 20.3172 5.70478C20.4705 5.27543 20.1992 4.98607 19.7265 5.00612Z",
    fill: "url(#paint165_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask236_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7656 5.01521H20.3473V13.4297H16.7656V5.01521Z",
    fill: "white"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask236_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.035
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7381 5.0156C19.7381 5.0156 20.0191 5.40713 19.7381 6.1071C19.4982 6.70134 16.7756 13.0916 16.7756 13.0916C16.7756 13.0916 16.6803 13.8918 17.0783 13.0301C17.4766 12.1682 20.2186 5.94803 20.3042 5.7104C20.4549 5.29236 20.1966 5.00429 19.7381 5.0156Z",
    fill: "url(#paint166_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask237_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7734 5.02513H20.3344V13.4141H16.7734V5.02513Z",
    fill: "white"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask237_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.039
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7494 5.02514C19.7494 5.02514 20.0233 5.41344 19.7494 6.0953C19.515 6.67661 16.7827 13.0882 16.7827 13.0882C16.7827 13.0882 16.6922 13.8596 17.0763 13.0287C17.4607 12.1971 20.2063 5.95207 20.2916 5.71605C20.4387 5.30901 20.1937 5.02223 19.7494 5.02514Z",
    fill: "url(#paint167_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask238_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7773 5.03504H20.3173V13.3984H16.7773V5.03504Z",
    fill: "white"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask238_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.042
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7569 5.03495C19.7569 5.03495 20.0233 5.41937 19.7569 6.08312C19.5277 6.6515 16.786 13.0847 16.786 13.0847C16.786 13.0847 16.7 13.8277 17.0705 13.0269C17.441 12.2257 20.1898 5.95606 20.2745 5.72198C20.4184 5.32528 20.1869 5.04045 19.7569 5.03495Z",
    fill: "url(#paint168_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask239_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7852 5.04463H20.3041V13.3828H16.7852V5.04463Z",
    fill: "white"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask239_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.045
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7685 5.04457C19.7685 5.04457 20.0275 5.42576 19.7685 6.07109C19.5445 6.62621 16.7931 13.0814 16.7931 13.0814C16.7931 13.0814 16.7119 13.7956 17.0686 13.0252C17.4252 12.2544 20.1772 5.95987 20.2619 5.72773C20.4022 5.34202 20.1843 5.0588 19.7685 5.04457Z",
    fill: "url(#paint169_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask240_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7891 5.0539H20.2876V13.3672H16.7891V5.0539Z",
    fill: "white"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask240_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.048
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7762 5.05398C19.7762 5.05398 20.0277 5.4316 19.7762 6.05883C19.5573 6.60134 16.7962 13.0779 16.7962 13.0779C16.7962 13.0779 16.7203 13.7636 17.0627 13.0236C17.4057 12.2832 20.1609 5.96378 20.245 5.73325C20.3821 5.35854 20.1777 5.07693 19.7762 5.05398Z",
    fill: "url(#paint170_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask241_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7969 5.05569H20.275V13.3438H16.7969V5.05569Z",
    fill: "white"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask241_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.052
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7876 5.05564C19.7876 5.05564 20.0317 5.43004 19.7876 6.03883C19.5739 6.56841 16.8034 13.0666 16.8034 13.0666C16.8034 13.0666 16.732 13.7239 17.0605 13.0139C17.3896 12.3036 20.1484 5.95995 20.2322 5.73104C20.366 5.36732 20.1749 5.08733 19.7876 5.05564Z",
    fill: "url(#paint171_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask242_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8047 5.07309H20.2618V13.3359H16.8047V5.07309Z",
    fill: "white"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask242_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.055
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7992 5.07309C19.7992 5.07309 20.0359 5.44393 19.7992 6.03461C19.591 6.55126 16.8106 13.0711 16.8106 13.0711C16.8106 13.0711 16.744 13.6997 17.0589 13.0201C17.3738 12.3405 20.1358 5.97189 20.2196 5.7446C20.3495 5.39187 20.1723 5.11318 19.7992 5.07309Z",
    fill: "url(#paint172_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask243_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8086 5.08269H20.2451V13.3203H16.8086V5.08269Z",
    fill: "white"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask243_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.058
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8068 5.08257C19.8068 5.08257 20.036 5.45018 19.8068 6.02244C19.6037 6.52615 16.8139 13.0674 16.8139 13.0674C16.8139 13.0674 16.7518 13.6678 17.0528 13.0186C17.3541 12.369 20.1194 5.97588 20.2028 5.75053C20.3292 5.40814 20.1656 5.13171 19.8068 5.08257Z",
    fill: "url(#paint173_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask244_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8164 5.09228H20.2325V13.3047H16.8164V5.09228Z",
    fill: "white"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask244_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.061
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8181 5.09212C19.8181 5.09212 20.0403 5.45616 19.8181 6.01032C19.6203 6.5011 16.8211 13.0643 16.8211 13.0643C16.8211 13.0643 16.7638 13.6356 17.0509 13.0168C17.3384 12.3976 20.1069 5.97992 20.1899 5.75619C20.3131 5.4248 20.1631 5.14966 19.8181 5.09212Z",
    fill: "url(#paint174_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask245_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8203 5.09375H20.216V13.2812H16.8203V5.09375Z",
    fill: "white"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask245_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8259 5.09379C19.8259 5.09379 20.0406 5.4546 19.8259 5.99065C19.6336 6.46818 16.8243 13.053 16.8243 13.053C16.8243 13.053 16.772 13.5959 17.0452 13.0071C17.319 12.4187 20.0907 5.97578 20.1735 5.75399C20.2928 5.43358 20.1564 5.16007 19.8259 5.09379Z",
    fill: "url(#paint175_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask246_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8281 5.10366H20.2035V13.2656H16.8281V5.10366Z",
    fill: "white"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask246_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.068
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8374 5.1036C19.8374 5.1036 20.0447 5.46053 19.8374 5.97847C19.6502 6.44307 16.8316 13.0493 16.8316 13.0493C16.8316 13.0493 16.7837 13.564 17.0434 13.0056C17.303 12.4473 20.078 5.97977 20.1604 5.75959C20.2765 5.45018 20.1536 5.17828 19.8374 5.1036Z",
    fill: "url(#paint176_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask247_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8359 5.11292H20.1912V13.25H16.8359V5.11292Z",
    fill: "white"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask247_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.071
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8491 5.11276C19.8491 5.11276 20.0489 5.46678 19.8491 5.96629C19.6671 6.41828 16.8388 13.0458 16.8388 13.0458C16.8388 13.0458 16.7961 13.5321 17.0415 13.0038C17.2875 12.4758 20.0654 5.98343 20.1479 5.76552C20.2604 5.46678 20.1511 5.1965 19.8491 5.11276Z",
    fill: "url(#paint177_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask248_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8398 5.12252H20.1751V13.2344H16.8398V5.12252Z",
    fill: "white"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask248_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.074
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8567 5.1227C19.8567 5.1227 20.0491 5.47285 19.8567 5.95425C19.6799 6.39299 16.8422 13.0425 16.8422 13.0425C16.8422 13.0425 16.804 13.5 17.0355 13.0021C17.2677 12.5045 20.0491 5.98755 20.1309 5.77126C20.2399 5.48351 20.1445 5.21452 19.8567 5.1227Z",
    fill: "url(#paint178_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask249_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8477 5.1321H20.1629V13.2188H16.8477V5.1321Z",
    fill: "white"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask249_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.077
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8685 5.13224C19.8685 5.13224 20.0535 5.47883 19.8685 5.94214C19.6969 6.36794 16.8495 13.0391 16.8495 13.0391C16.8495 13.0391 16.8162 13.4678 17.0341 13.0006C17.2523 12.5331 20.037 5.99161 20.1185 5.77693C20.2239 5.49985 20.1421 5.23279 19.8685 5.13224Z",
    fill: "url(#paint179_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask250_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8516 5.14171H20.1471V13.2031H16.8516V5.14171Z",
    fill: "white"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask250_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.081
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8762 5.14172C19.8762 5.14172 20.054 5.48508 19.8762 5.92995C19.71 6.34314 16.8529 13.0357 16.8529 13.0357C16.8529 13.0357 16.8245 13.4359 17.0285 12.9988C17.2328 12.562 20.0204 5.99559 20.1022 5.78252C20.2034 5.51612 20.1358 5.251 19.8762 5.14172Z",
    fill: "url(#paint180_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask251_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 5.15129H20.1355V13.1875H16.8594V5.15129Z",
    fill: "white"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask251_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.084
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8878 5.15121C19.8878 5.15121 20.0582 5.49133 19.8878 5.91777C19.7268 6.31803 16.8603 13.0322 16.8603 13.0322C16.8603 13.0322 16.8364 13.404 17.0265 12.997C17.2169 12.5906 20.0081 5.99925 20.0896 5.78845C20.1872 5.53271 20.1329 5.26921 19.8878 5.15121Z",
    fill: "url(#paint181_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask252_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8633 5.16122H20.1203V13.1719H16.8633V5.16122Z",
    fill: "white"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask252_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.087
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8959 5.16107C19.8959 5.16107 20.0588 5.4973 19.8959 5.90564C19.74 6.29297 16.8639 13.0288 16.8639 13.0288C16.8639 13.0288 16.8448 13.3719 17.0213 12.9955C17.1979 12.6192 19.9919 6.00328 20.0731 5.7941C20.1675 5.54936 20.1267 5.28748 19.8959 5.16107Z",
    fill: "url(#paint182_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask253_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8711 5.17016H20.1097V13.1562H16.8711V5.17016Z",
    fill: "white"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask253_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.09
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9079 5.17022C19.9079 5.17022 20.0638 5.50356 19.9079 5.89379C19.7573 6.26786 16.8714 13.0254 16.8714 13.0254C16.8714 13.0254 16.8575 13.34 17.0198 12.9937C17.1824 12.6477 19.98 6.00728 20.0608 5.79971C20.1517 5.56596 20.1245 5.30537 19.9079 5.17022Z",
    fill: "url(#paint183_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask254_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.18008H20.0955V13.1406H16.875V5.18008Z",
    fill: "white"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask254_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.094
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9159 5.18017C19.9159 5.18017 20.0639 5.50962 19.9159 5.88175C19.7704 6.24289 16.8751 13.0221 16.8751 13.0221C16.8751 13.0221 16.8654 13.3079 17.0142 12.992C17.1632 12.6764 19.9637 6.0114 20.0442 5.80545C20.1318 5.58237 20.1183 5.32372 19.9159 5.18017Z",
    fill: "url(#paint184_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask255_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8789 5.18967H20.0819V13.125H16.8789V5.18967Z",
    fill: "white"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask255_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9242 5.18964C19.9242 5.18964 20.0651 5.51554 19.9242 5.86956C19.7842 6.21777 16.8789 13.0186 16.8789 13.0186C16.8789 13.0186 16.8744 13.276 17.0092 12.9902C17.144 12.705 19.9481 6.01505 20.0283 5.81137C20.1124 5.59895 20.1123 5.34192 19.9242 5.18964Z",
    fill: "url(#paint185_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask256_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 5,
    width: 5,
    height: 9
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8867 5.19927H20.0729V13.1094H16.8867V5.19927Z",
    fill: "white"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask256_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9359 5.19904C19.9359 5.19904 20.0694 5.5217 19.9359 5.85729C19.801 6.19256 16.8867 13.0151 16.8867 13.0151C16.8867 13.0151 16.8867 13.244 17.0076 12.9886C17.1289 12.7338 19.9359 6.01895 20.0157 5.81688C20.0962 5.61546 20.1098 5.36005 19.9359 5.19904Z",
    fill: "url(#paint186_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask257_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4727 4.83399H22.0999V13.5H18.4727V4.83399Z",
    fill: "white"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask257_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4088 4.83414C21.4088 4.83414 21.2998 5.22567 20.9452 6.10734C20.6522 6.83155 18.4899 13.0404 18.4899 13.0404C18.4899 13.0404 18.347 14.1254 18.8831 12.9612C19.4201 11.7966 21.9587 6.04429 22.048 5.79049C22.2336 5.26349 21.8944 4.95635 21.4088 4.83414Z",
    fill: "url(#paint187_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask258_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4805 4.84358H22.0919V13.4844H18.4805V4.84358Z",
    fill: "white"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask258_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.42 4.84363C21.42 4.84363 21.3195 5.23289 20.9722 6.09646C20.6845 6.80742 18.497 13.037 18.497 13.037C18.497 13.037 18.3589 14.0935 18.8814 12.9594C19.4042 11.8252 21.9519 6.04085 22.0408 5.78867C22.2231 5.27266 21.8956 4.96713 21.42 4.84363Z",
    fill: "url(#paint188_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask259_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4883 4.85318H22.0845V13.4688H18.4883V4.85318Z",
    fill: "white"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask259_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.012
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4316 4.85326C21.4316 4.85326 21.3391 5.24025 20.999 6.08571C20.7168 6.78374 18.504 13.0337 18.504 13.0337C18.504 13.0337 18.3708 14.0615 18.8794 12.9577C19.3886 11.8539 21.945 6.03754 22.0336 5.78729C22.2127 5.28196 21.8968 4.97806 21.4316 4.85326Z",
    fill: "url(#paint189_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask260_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4922 4.86244H22.0729V13.4531H18.4922V4.86244Z",
    fill: "white"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask260_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.015
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4393 4.86274C21.4393 4.86274 21.3549 5.24748 21.0222 6.07451C20.7451 6.75961 18.5072 13.0302 18.5072 13.0302C18.5072 13.0302 18.3788 14.0296 18.8738 12.9558C19.3688 11.8825 21.9346 6.03409 22.0225 5.78547C22.1981 5.2908 21.8942 4.98883 21.4393 4.86274Z",
    fill: "url(#paint190_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask261_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.87236H22.0651V13.4375H18.5V4.87236Z",
    fill: "white"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask261_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.019
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4505 4.87246C21.4505 4.87246 21.3742 5.25462 21.0487 6.06354C20.7771 6.7357 18.5142 13.0267 18.5142 13.0267C18.5142 13.0267 18.3907 13.9976 18.8715 12.9543C19.3526 11.9113 21.9274 6.03056 22.0154 5.78355C22.1874 5.29988 21.8951 4.99952 21.4505 4.87246Z",
    fill: "url(#paint191_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask262_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5039 4.88195H22.0539V13.4219H18.5039V4.88195Z",
    fill: "white"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask262_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.023
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4577 4.88176C21.4577 4.88176 21.3895 5.26198 21.0714 6.0528C20.8053 6.71203 18.5175 13.0234 18.5175 13.0234C18.5175 13.0234 18.3982 13.9655 18.8654 12.9526C19.3329 11.9396 21.9165 6.02725 22.0041 5.78186C22.1729 5.3095 21.8923 5.01044 21.4577 4.88176Z",
    fill: "url(#paint192_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask263_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5117 4.89155H22.0465V13.4062H18.5117V4.89155Z",
    fill: "white"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask263_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.027
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4692 4.89166C21.4692 4.89166 21.4091 5.26929 21.0984 6.04201C20.8375 6.6883 18.5245 13.0197 18.5245 13.0197C18.5245 13.0197 18.4104 13.9337 18.8637 12.9508C19.317 11.9683 21.9096 6.0239 21.9969 5.78013C22.1624 5.31844 21.8931 5.02163 21.4692 4.89166Z",
    fill: "url(#paint193_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask264_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5195 4.90114H22.0384V13.3906H18.5195V4.90114Z",
    fill: "white"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask264_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.031
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4808 4.9012C21.4808 4.9012 21.4288 5.27657 21.1255 6.03117C20.8698 6.66421 18.5316 13.0163 18.5316 13.0163C18.5316 13.0163 18.4223 13.9015 18.8617 12.9494C19.3014 11.9972 21.9031 6.0205 21.9897 5.77867C22.1517 5.32765 21.8943 5.03214 21.4808 4.9012Z",
    fill: "url(#paint194_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask265_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 4.90291H22.0272V13.3672H18.5234V4.90291Z",
    fill: "white"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask265_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.035
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 4.90288C21.4883 4.90288 21.4443 5.27598 21.1481 6.01248C20.8976 6.63259 18.5348 13.005 18.5348 13.005C18.5348 13.005 18.4301 13.8618 18.8559 12.9397C19.2814 12.018 21.8921 6.00925 21.9784 5.76903C22.1372 5.329 21.8914 5.03543 21.4883 4.90288Z",
    fill: "url(#paint195_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask266_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5312 4.92H22.0198V13.3594H18.5312V4.92Z",
    fill: "white"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask266_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.039
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 4.92018C21.4996 4.92018 21.464 5.29102 21.1753 6.00909C20.9302 6.61659 18.5419 13.0094 18.5419 13.0094C18.5419 13.0094 18.442 13.8377 18.8539 12.9457C19.2655 12.0543 21.8853 6.01362 21.9713 5.77501C22.1264 5.34598 21.8924 5.05403 21.4996 4.92018Z",
    fill: "url(#paint196_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask267_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5391 4.92992H22.0121V13.3438H18.5391V4.92992Z",
    fill: "white"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask267_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.043
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5109 4.93004C21.5109 4.93004 21.4834 5.2983 21.2022 5.99826C20.9619 6.59283 18.5491 13.006 18.5491 13.006C18.5491 13.006 18.4537 13.8056 18.8517 12.9443C19.2497 12.083 21.8782 6.0099 21.9639 5.77323C22.1158 5.35519 21.8934 5.06486 21.5109 4.93004Z",
    fill: "url(#paint197_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask268_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 5,
    height: 10
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5469 4.93171H22.005V13.3203H18.5469V4.93171Z",
    fill: "white"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask268_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.046
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5225 4.93172C21.5225 4.93172 21.5028 5.2977 21.229 5.97956C20.9946 6.56088 18.5562 12.9948 18.5562 12.9948C18.5562 12.9948 18.4656 13.7658 18.8497 12.9346C19.2338 12.1037 21.8714 5.99896 21.9571 5.76392C22.1051 5.35655 21.8947 5.06783 21.5225 4.93172Z",
    fill: "url(#paint198_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask269_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 4,
    height: 10
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5508 4.94129H21.9934V13.3047H18.5508V4.94129Z",
    fill: "white"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask269_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5302 4.94134C21.5302 4.94134 21.5185 5.30506 21.2521 5.96849C21.0226 6.5372 18.5593 12.9914 18.5593 12.9914C18.5593 12.9914 18.4739 13.7338 18.8441 12.9329C19.2143 12.1324 21.8606 5.99533 21.946 5.76222C22.0908 5.36584 21.8916 5.07874 21.5302 4.94134Z",
    fill: "url(#paint199_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask270_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 4,
    height: 10
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5547 4.9509H21.9824V13.2891H18.5547V4.9509Z",
    fill: "white"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask270_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.054
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5374 4.95083C21.5374 4.95083 21.5342 5.31228 21.2749 5.95761C21.0508 6.51338 18.5626 12.9877 18.5626 12.9877C18.5626 12.9877 18.4815 13.7019 18.8381 12.9314C19.1944 12.161 21.8497 5.99189 21.9348 5.7604C22.076 5.37501 21.8888 5.08953 21.5374 4.95083Z",
    fill: "url(#paint200_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask271_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 4,
    height: 10
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 4.96797H21.975V13.2812H18.5625V4.96797Z",
    fill: "white"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask271_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.058
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.549 4.96812C21.549 4.96812 21.5539 5.32732 21.302 5.95454C21.0831 6.49706 18.5697 12.992 18.5697 12.992C18.5697 12.992 18.4934 13.6778 18.8365 12.9374C19.1785 12.1973 21.8429 5.99625 21.9276 5.7667C22.0657 5.39166 21.8901 5.10812 21.549 4.96812Z",
    fill: "url(#paint201_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask272_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 4,
    height: 10
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5664 4.97008H21.9638V13.2578H18.5664V4.97008Z",
    fill: "white"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask272_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.062
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5567 4.97027C21.5567 4.97027 21.5693 5.32721 21.3249 5.936C21.1115 6.46558 18.5729 12.9809 18.5729 12.9809C18.5729 12.9809 18.5018 13.6379 18.8306 12.9279C19.1587 12.2182 21.8325 5.98514 21.9169 5.75721C22.0511 5.39316 21.8875 5.11156 21.5567 4.97027Z",
    fill: "url(#paint202_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask273_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 4,
    height: 10
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5781 4.97967H21.9606V13.2422H18.5781V4.97967Z",
    fill: "white"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask273_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.066
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.572 4.97966C21.572 4.97966 21.5927 5.33433 21.3557 5.92502C21.1475 6.44167 18.584 12.9774 18.584 12.9774C18.584 12.9774 18.5174 13.6059 18.8323 12.9263C19.1469 12.2467 21.8294 5.98159 21.9135 5.75528C22.0444 5.40222 21.8921 5.12224 21.572 4.97966Z",
    fill: "url(#paint203_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask274_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 4,
    width: 4,
    height: 10
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M18.582 4.98926H21.9493V13.2266H18.582V4.98926Z",
    fill: "white"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask274_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5798 4.98915C21.5798 4.98915 21.6086 5.34156 21.3787 5.91414C21.176 6.41786 18.5873 12.9739 18.5873 12.9739C18.5873 12.9739 18.5255 13.574 18.8265 12.9245C19.1272 12.2753 21.8187 5.97815 21.9025 5.75345C22.0299 5.41107 21.8896 5.13302 21.5798 4.98915Z",
    fill: "url(#paint204_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask275_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 4.99853H21.938V13.2109H18.5859V4.99853Z",
    fill: "white"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask275_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.074
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5873 4.99877C21.5873 4.99877 21.6242 5.34892 21.4018 5.90307C21.2042 6.39385 18.5906 12.9706 18.5906 12.9706C18.5906 12.9706 18.5334 13.5419 18.8208 12.9228C19.1076 12.304 21.8082 5.97484 21.8912 5.75208C22.0151 5.42036 21.8867 5.14394 21.5873 4.99877Z",
    fill: "url(#paint205_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask276_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 5.00812H21.9313V13.1953H18.5938V5.00812Z",
    fill: "white"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask276_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.077
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5987 5.00818C21.5987 5.00818 21.644 5.35605 21.429 5.8921C21.2366 6.36995 18.5978 12.9671 18.5978 12.9671C18.5978 12.9671 18.5454 13.5099 18.8189 12.9212C19.0918 12.3324 21.8011 5.97131 21.8842 5.75017C22.0048 5.42944 21.8881 5.15464 21.5987 5.00818Z",
    fill: "url(#paint206_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask277_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5977 5.01804H21.9203V13.1797H18.5977V5.01804Z",
    fill: "white"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask277_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.081
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6066 5.01821C21.6066 5.01821 21.6599 5.3635 21.452 5.88145L18.6011 12.9636C18.6011 12.9636 18.5535 13.478 18.8135 12.9196C19.0721 12.3616 21.7908 5.9681 21.8733 5.74857C21.9903 5.43884 21.8856 5.16564 21.6066 5.01821Z",
    fill: "url(#paint207_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask278_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6094 5.02763H21.9175V13.1641H18.6094V5.02763Z",
    fill: "white"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask278_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.085
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6222 5.0276C21.6222 5.0276 21.6833 5.37063 21.4832 5.87046C21.3015 6.32213 18.6122 12.9603 18.6122 12.9603C18.6122 12.9603 18.5695 13.446 18.8156 12.9177C19.0606 12.39 21.7881 5.96455 21.8705 5.74664C21.9837 5.44758 21.8906 5.17664 21.6222 5.0276Z",
    fill: "url(#paint208_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask279_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6133 5.03723H21.9068V13.1484H18.6133V5.03723Z",
    fill: "white"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask279_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.089
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6298 5.037C21.6298 5.037 21.699 5.37777 21.506 5.85918C21.3298 6.29823 18.6156 12.9568 18.6156 12.9568C18.6156 12.9568 18.5775 13.414 18.8096 12.9161C19.0408 12.4182 21.7769 5.96069 21.8594 5.74472C21.969 5.45665 21.8878 5.18734 21.6298 5.037Z",
    fill: "url(#paint209_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask280_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6211 5.04682H21.9004V13.1328H18.6211V5.04682Z",
    fill: "white"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask280_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.093
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6413 5.04671C21.6413 5.04671 21.7186 5.38522 21.533 5.84852C21.3617 6.27464 18.6229 12.9533 18.6229 12.9533C18.6229 12.9533 18.5896 13.382 18.8078 12.9145C19.0251 12.4473 21.77 5.95747 21.8521 5.74344C21.9582 5.46604 21.889 5.19802 21.6413 5.04671Z",
    fill: "url(#paint210_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask281_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 5.04861H21.8901V13.1094H18.625V5.04861Z",
    fill: "white"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask281_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.649 5.04871C21.649 5.04871 21.7347 5.38463 21.5565 5.82982C21.3903 6.24269 18.6263 12.942 18.6263 12.942C18.6263 12.942 18.5979 13.3423 18.8022 12.9048C19.0056 12.468 21.7596 5.94622 21.8413 5.7338C21.9438 5.46707 21.8863 5.20131 21.649 5.04871Z",
    fill: "url(#paint211_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask282_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 5.05787H21.8801V13.0938H18.6289V5.05787Z",
    fill: "white"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask282_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.101
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.657 5.05792C21.657 5.05792 21.7508 5.3919 21.5797 5.81899C21.419 6.21892 18.6298 12.9386 18.6298 12.9386C18.6298 12.9386 18.6062 13.3101 18.7967 12.9034C18.9861 12.4966 21.7491 5.94282 21.8306 5.73203C21.9295 5.47629 21.884 5.21214 21.657 5.05792Z",
    fill: "url(#paint212_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask283_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6367 5.0756H21.874V13.0859H18.6367V5.0756Z",
    fill: "white"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask283_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.105
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6687 5.07555C21.6687 5.07555 21.7705 5.40693 21.6066 5.81592C21.4514 6.20292 18.6373 12.943 18.6373 12.943C18.6373 12.943 18.6182 13.286 18.7951 12.9093C18.9706 12.533 21.7424 5.94719 21.8235 5.73833C21.9189 5.49326 21.8853 5.23073 21.6687 5.07555Z",
    fill: "url(#paint213_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask284_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6406 5.08519H21.8647V13.0703H18.6406V5.08519Z",
    fill: "white"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask284_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.108
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6768 5.08502C21.6768 5.08502 21.7864 5.41415 21.6303 5.80471C21.4803 6.1791 18.6409 12.9395 18.6409 12.9395C18.6409 12.9395 18.6267 13.2541 18.7897 12.9075C18.9513 12.5616 21.7315 5.94341 21.8129 5.73649C21.9044 5.50209 21.8831 5.2415 21.6768 5.08502Z",
    fill: "url(#paint214_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask285_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 5.08698H21.8596V13.0469H18.6484V5.08698Z",
    fill: "white"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask285_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.112
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6886 5.08675C21.6886 5.08675 21.8066 5.41361 21.6579 5.78607C21.5131 6.1472 18.6486 12.9283 18.6486 12.9283C18.6486 12.9283 18.6392 13.2141 18.7885 12.8982C18.9363 12.5824 21.7255 5.9322 21.8067 5.72689C21.8946 5.50349 21.8846 5.24452 21.6886 5.08675Z",
    fill: "url(#paint215_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask286_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6523 5.09592H21.8508V13.0312H18.6523V5.09592Z",
    fill: "white"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask286_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.116
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6966 5.09607C21.6966 5.09607 21.8227 5.42068 21.6811 5.77503C21.5418 6.12323 18.6524 12.9247 18.6524 12.9247C18.6524 12.9247 18.6482 13.1824 18.783 12.8963C18.9175 12.6111 21.7151 5.9286 21.7959 5.72492C21.8803 5.5125 21.8822 5.25514 21.6966 5.09607Z",
    fill: "url(#paint216_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask287_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 5,
    width: 4,
    height: 9
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6602 5.10615H21.847V13.0156H18.6602V5.10615Z",
    fill: "white"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask287_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.709 5.10593C21.709 5.10593 21.8431 5.42827 21.709 5.76451C21.5748 6.09978 18.6602 12.9213 18.6602 12.9213C18.6602 12.9213 18.6601 13.1502 18.7817 12.8948C18.9017 12.6397 21.709 5.92552 21.7895 5.72377C21.8706 5.52203 21.8842 5.26662 21.709 5.10593Z",
    fill: "url(#paint217_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask288_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 10
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8281 9.18311H25.95V18.0625H22.8281V9.18311Z",
    fill: "white"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask288_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4043 9.18306C25.4043 9.18306 25.2717 9.69421 24.9875 10.5539C23.4062 15.3217 22.8281 17.4084 22.8281 17.4084C22.8281 17.4084 23.2833 18.7336 23.6736 17.6114C24.0632 16.4886 25.9306 12.3945 25.95 10.6645C25.9545 10.1048 25.8482 9.52964 25.4043 9.18306Z",
    fill: "url(#paint218_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask289_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 10
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8477 9.19264H25.9424V18.0391H22.8477V9.19264Z",
    fill: "white"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask289_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.01
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4083 9.19254C25.4083 9.19254 25.2825 9.70757 25.0061 10.5501C23.4723 15.198 22.8477 17.4024 22.8477 17.4024C22.8477 17.4024 23.288 18.6927 23.6682 17.5996C24.0478 16.5058 25.9107 12.4282 25.9421 10.6717C25.9518 10.1098 25.8431 9.53622 25.4083 9.19254Z",
    fill: "url(#paint219_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask290_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 10
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8711 9.21846H25.9393V18.0312H22.8711V9.21846Z",
    fill: "white"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask290_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.012
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4165 9.21836C25.4165 9.21836 25.2975 9.73663 25.0289 10.5617C23.5426 15.0903 22.8711 17.4123 22.8711 17.4123C22.8711 17.4123 23.2969 18.6671 23.6671 17.6034C24.0366 16.5391 25.8924 12.478 25.938 10.6946C25.9526 10.1307 25.8423 9.55913 25.4165 9.21836Z",
    fill: "url(#paint220_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask291_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 10
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8906 9.23548H25.9323V18.0156H22.8906V9.23548Z",
    fill: "white"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask291_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.015
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4212 9.23558C25.4212 9.23558 25.309 9.75773 25.0481 10.5657C23.6087 14.9743 22.8906 17.4144 22.8906 17.4144C22.8906 17.4144 23.3019 18.6339 23.662 17.5993C24.0216 16.5644 25.8703 12.5194 25.9304 10.7096C25.9491 10.1434 25.8376 9.57344 25.4212 9.23558Z",
    fill: "url(#paint221_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask292_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 9
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9141 9.24503H25.9296V17.9922H22.9141V9.24503Z",
    fill: "white"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask292_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.019
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4294 9.24514C25.4294 9.24514 25.3253 9.77116 25.0709 10.5613C23.6881 14.8539 22.9141 17.4087 22.9141 17.4087C22.9141 17.4087 23.3108 18.5927 23.6609 17.5875C24.0104 16.5817 25.8513 12.5529 25.9267 10.7168C25.9503 10.1485 25.8368 9.58041 25.4294 9.24514Z",
    fill: "url(#paint222_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask293_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 9
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9336 9.27051H25.9229V17.9844H22.9336V9.27051Z",
    fill: "white"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask293_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.023
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4338 9.27049C25.4338 9.27049 25.3368 9.80008 25.0901 10.5728C23.7561 14.7461 22.9336 17.4186 22.9336 17.4186C22.9336 17.4186 23.3157 18.5673 23.6559 17.5912C23.995 16.6145 25.8288 12.6022 25.919 10.7396C25.9468 10.169 25.8317 9.60253 25.4338 9.27049Z",
    fill: "url(#paint223_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask294_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 9
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M22.957 9.28786H25.9205V17.9688H22.957V9.28786Z",
    fill: "white"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask294_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.027
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4423 9.28803C25.4423 9.28803 25.3521 9.8215 25.1129 10.5768C23.828 14.6314 22.957 17.4206 22.957 17.4206C22.957 17.4206 23.3246 18.5341 23.6547 17.5871C23.9839 16.6401 25.8099 12.6443 25.9153 10.7546C25.9473 10.182 25.8309 9.61749 25.4423 9.28803Z",
    fill: "url(#paint224_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask295_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 9,
    width: 4,
    height: 9
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9766 9.30587H25.9135V17.9531H22.9766V9.30587Z",
    fill: "white"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask295_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.031
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4463 9.30587C25.4463 9.30587 25.3632 9.84256 25.1318 10.5807C23.8961 14.516 22.9766 17.4229 22.9766 17.4229C22.9766 17.4229 23.3293 18.5005 23.6491 17.5833C23.9685 16.6654 25.7868 12.6861 25.9074 10.7698C25.9436 10.195 25.8259 9.63209 25.4463 9.30587Z",
    fill: "url(#paint225_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask296_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.3154H25.9111V17.9297H23V9.3154Z",
    fill: "white"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask296_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.035
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4546 9.31534C25.4546 9.31534 25.3789 9.85591 25.1545 10.5766C23.9677 14.3929 23 17.4169 23 17.4169C23 17.4169 23.3382 18.4595 23.6479 17.5714C23.9573 16.6826 25.7679 12.7198 25.9037 10.777C25.9441 10.1999 25.8251 9.63897 25.4546 9.31534Z",
    fill: "url(#paint226_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask297_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0195 9.34057H25.9048V17.9219H23.0195V9.34057Z",
    fill: "white"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask297_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.039
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4592 9.34063C25.4592 9.34063 25.39 9.88508 25.1737 10.5883C24.0354 14.2853 23.0195 17.4269 23.0195 17.4269C23.0195 17.4269 23.3432 18.4341 23.6429 17.575C23.9423 16.716 25.7447 12.769 25.896 10.7997C25.9406 10.2207 25.8204 9.66136 25.4592 9.34063Z",
    fill: "url(#paint227_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask298_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M23.043 9.35792H25.9026V17.9062H23.043V9.35792Z",
    fill: "white"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask298_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.043
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4675 9.35817C25.4675 9.35817 25.4054 9.90586 25.1965 10.5919C24.107 14.17 23.043 17.429 23.043 17.429C23.043 17.429 23.3521 18.4008 23.6417 17.5709C23.9311 16.741 25.7251 12.8105 25.8923 10.8147C25.9408 10.2331 25.8192 9.67599 25.4675 9.35817Z",
    fill: "url(#paint228_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask299_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 9.3756H25.8963V17.8906H23.0625V9.3756Z",
    fill: "white"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask299_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.046
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4718 9.3756C25.4718 9.3756 25.4168 9.92718 25.2157 10.5958C24.1744 14.0546 23.0625 17.4309 23.0625 17.4309C23.0625 17.4309 23.357 18.3675 23.6367 17.567C23.9157 16.7662 25.7017 12.8525 25.8847 10.8295C25.9374 10.246 25.8148 9.69051 25.4718 9.3756Z",
    fill: "url(#paint229_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask300_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0859 9.39328H25.8942V17.875H23.0859V9.39328Z",
    fill: "white"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask300_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4804 9.39341C25.4804 9.39341 25.4322 9.9482 25.2385 10.5994C24.2456 13.9395 23.0859 17.4332 23.0859 17.4332C23.0859 17.4332 23.3659 18.3342 23.6356 17.5628C23.9046 16.7914 25.6824 12.8939 25.881 10.8447C25.9379 10.2589 25.8137 9.70508 25.4804 9.39341Z",
    fill: "url(#paint230_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask301_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1055 9.41063H25.8879V17.8594H23.1055V9.41063Z",
    fill: "white"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask301_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.054
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4844 9.41076C25.4844 9.41076 25.443 9.96944 25.2571 10.6031C24.3127 13.8239 23.1055 17.4353 23.1055 17.4353C23.1055 17.4353 23.3706 18.3008 23.6302 17.5588C23.8892 16.8165 25.658 12.9355 25.873 10.8598C25.9338 10.2717 25.8087 9.71985 25.4844 9.41076Z",
    fill: "url(#paint231_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask302_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1289 9.42831H25.8855V17.8438H23.1289V9.42831Z",
    fill: "white"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask302_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.058
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.493 9.42806C25.493 9.42806 25.4584 9.99062 25.2802 10.6068C24.3837 13.708 23.1289 17.4371 23.1289 17.4371C23.1289 17.4371 23.3795 18.2677 23.6291 17.5548C23.878 16.8419 25.6384 12.977 25.8693 10.8749C25.934 10.2845 25.8079 9.73423 25.493 9.42806Z",
    fill: "url(#paint232_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask303_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1484 9.44598H25.8794V17.8281H23.1484V9.44598Z",
    fill: "white"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask303_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.062
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4973 9.44581C25.4973 9.44581 25.4698 10.0116 25.2991 10.6107C24.4507 13.5926 23.1484 17.439 23.1484 17.439C23.1484 17.439 23.3848 18.2344 23.624 17.5509C23.8629 16.8674 25.614 13.0187 25.8613 10.8897C25.9302 10.2974 25.8031 9.74907 25.4973 9.44581Z",
    fill: "url(#paint233_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask304_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1719 9.46301H25.8777V17.8125H23.1719V9.46301Z",
    fill: "white"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask304_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.066
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5059 9.46313C25.5059 9.46313 25.4848 10.0328 25.3222 10.6144C24.5217 13.4767 23.1719 17.4411 23.1719 17.4411C23.1719 17.4411 23.3937 18.2012 23.6229 17.5465C23.8518 16.8925 25.5944 13.0603 25.8576 10.9048C25.9304 10.3099 25.8023 9.76348 25.5059 9.46313Z",
    fill: "url(#paint234_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask305_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1914 9.48069H25.8717V17.7969H23.1914V9.48069Z",
    fill: "white"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask305_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5102 9.48071C25.5102 9.48071 25.4963 10.0536 25.3411 10.6181C24.5881 13.3608 23.1914 17.4432 23.1914 17.4432C23.1914 17.4432 23.3986 18.1677 23.6179 17.5428C23.8364 16.9175 25.57 13.1015 25.85 10.9198C25.9266 10.3226 25.7973 9.77816 25.5102 9.48071Z",
    fill: "url(#paint235_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask306_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2109 9.49837H25.866V17.7812H23.2109V9.49837Z",
    fill: "white"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask306_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.074
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5145 9.49818C25.5145 9.49818 25.5074 10.0746 25.3603 10.622C24.6548 13.2453 23.2109 17.4455 23.2109 17.4455C23.2109 17.4455 23.4036 18.1344 23.6128 17.5386C23.8213 16.9427 25.5459 13.1432 25.8424 10.935C25.9229 10.3356 25.7926 9.79271 25.5145 9.49818Z",
    fill: "url(#paint236_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask307_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2344 9.5157H25.8635V17.7656H23.2344V9.5157Z",
    fill: "white"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask307_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.077
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5228 9.51571C25.5228 9.51571 25.5221 10.0961 25.3828 10.626C24.7245 13.1297 23.2344 17.4475 23.2344 17.4475C23.2344 17.4475 23.4122 18.1012 23.6114 17.5345C23.8099 16.968 25.525 13.185 25.8383 10.9499C25.9227 10.3486 25.7914 9.80766 25.5228 9.51571Z",
    fill: "url(#paint237_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask308_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2578 9.53339H25.8617V17.75H23.2578V9.53339Z",
    fill: "white"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask308_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.081
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.531 9.53333C25.531 9.53333 25.5372 10.1169 25.4059 10.6297C24.7945 13.0134 23.2578 17.4493 23.2578 17.4493C23.2578 17.4493 23.4211 18.0681 23.6102 17.5304C23.7987 16.9931 25.5045 13.2262 25.8346 10.9649C25.9225 10.3613 25.7906 9.82204 25.531 9.53333Z",
    fill: "url(#paint238_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask309_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2773 9.55074H25.8561V17.7344H23.2773V9.55074Z",
    fill: "white"
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask309_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.085
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5353 9.55067C25.5353 9.55067 25.5483 10.1381 25.4248 10.6334C24.8603 12.8976 23.2773 17.4514 23.2773 17.4514C23.2773 17.4514 23.4261 18.0347 23.6052 17.5264C23.7836 17.0185 25.4797 13.2675 25.827 10.9797C25.9188 10.3741 25.7859 9.8368 25.5353 9.55067Z",
    fill: "url(#paint239_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask310_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 9.56841H25.8504V17.7188H23.2969V9.56841Z",
    fill: "white"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask310_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.089
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.54 9.56835C25.54 9.56835 25.5594 10.159 25.4437 10.6372C24.9257 12.7814 23.2969 17.4536 23.2969 17.4536C23.2969 17.4536 23.4311 18.0013 23.6001 17.5224C23.7686 17.0439 25.4553 13.3087 25.8193 10.9948C25.915 10.3867 25.7809 9.85124 25.54 9.56835Z",
    fill: "url(#paint240_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask311_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3203 9.58577H25.8486V17.7031H23.3203V9.58577Z",
    fill: "white"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask311_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.093
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5482 9.58581C25.5482 9.58581 25.5741 10.1801 25.4668 10.6408C24.9951 12.6653 23.3203 17.4558 23.3203 17.4558C23.3203 17.4558 23.4399 17.968 23.599 17.5182C23.7574 17.0692 25.4344 13.3504 25.8156 11.01C25.9149 10.3996 25.7801 9.8658 25.5482 9.58581Z",
    fill: "url(#paint241_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask312_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3398 9.60312H25.8429V17.6875H23.3398V9.60312Z",
    fill: "white"
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask312_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5526 9.60323C25.5526 9.60323 25.5852 10.2007 25.4857 10.6449C25.0602 12.5492 23.3398 17.4577 23.3398 17.4577C23.3398 17.4577 23.4449 17.9346 23.5936 17.5143C23.7424 17.0943 25.4097 13.3918 25.8077 11.0248C25.9108 10.4122 25.7753 9.88063 25.5526 9.60323Z",
    fill: "url(#paint242_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask313_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3633 9.62081H25.8408V17.6719H23.3633V9.62081Z",
    fill: "white"
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask313_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.101
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5608 9.62077C25.5608 9.62077 25.5993 10.2215 25.5084 10.6482C25.1279 12.4326 23.3633 17.4598 23.3633 17.4598C23.3633 17.4598 23.4535 17.9014 23.5925 17.5102C23.7306 17.1193 25.3882 13.4329 25.8036 11.0398C25.9106 10.4248 25.7742 9.89526 25.5608 9.62077Z",
    fill: "url(#paint243_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask314_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3828 9.63816H25.8354V17.6562H23.3828V9.63816Z",
    fill: "white"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask314_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.105
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5652 9.63829C25.5652 9.63829 25.6101 10.2429 25.5273 10.6522C25.1917 12.3163 23.3828 17.4618 23.3828 17.4618C23.3828 17.4618 23.4585 17.8682 23.5871 17.506C23.7155 17.1446 25.3631 13.4744 25.796 11.055C25.9066 10.4378 25.7695 9.90987 25.5652 9.63829Z",
    fill: "url(#paint244_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask315_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4062 9.65582H25.8337V17.6406H23.4062V9.65582Z",
    fill: "white"
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask315_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.108
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5737 9.6558C25.5737 9.6558 25.6245 10.2636 25.5504 10.6558C25.2591 12.1996 23.4062 17.4638 23.4062 17.4638C23.4062 17.4638 23.4677 17.8349 23.5863 17.5019C23.7043 17.1699 25.3419 13.5152 25.7923 11.0696C25.9064 10.4505 25.7687 9.92415 25.5737 9.6558Z",
    fill: "url(#paint245_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask316_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4258 9.67351H25.828V17.625H23.4258V9.67351Z",
    fill: "white"
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask316_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.112
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5781 9.67336C25.5781 9.67336 25.6346 10.2844 25.5693 10.6598C25.3217 12.0833 23.4258 17.4658 23.4258 17.4658C23.4258 17.4658 23.4727 17.8014 23.581 17.4981C23.6893 17.1952 25.3126 13.556 25.7847 11.0849C25.9014 10.4632 25.764 9.93912 25.5781 9.67336Z",
    fill: "url(#paint246_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask317_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4492 9.69086H25.8265V17.6094H23.4492V9.69086Z",
    fill: "white"
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask317_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.116
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5863 9.69086C25.5863 9.69086 25.6484 10.3052 25.5924 10.6634C25.3875 11.9663 23.4492 17.4678 23.4492 17.4678C23.4492 17.4678 23.4815 17.7681 23.5802 17.494C23.6781 17.2201 25.2927 13.5974 25.7809 11.0999C25.9019 10.4759 25.7628 9.95339 25.5863 9.69086Z",
    fill: "url(#paint247_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask318_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 9,
    width: 3,
    height: 9
  }, _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4688 9.7082H25.8212V17.5938H23.4688V9.7082Z",
    fill: "white"
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask318_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.591 9.70828C25.591 9.70828 25.6588 10.3261 25.6113 10.6672C25.4503 11.8502 23.4688 17.47 23.4688 17.47C23.4688 17.47 23.4865 17.7348 23.5748 17.4897C23.6631 17.2456 25.2689 13.6388 25.7733 11.115C25.8981 10.4884 25.7581 9.96822 25.591 9.70828Z",
    fill: "url(#paint248_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask319_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 10,
    height: 4
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.801H15.1532V18.4531H6V15.801Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask319_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask320_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 10,
    height: 4
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02734 15.8301H15.1001V18.4531H6.02734V15.8301Z",
    fill: "white"
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask320_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.019
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02734 15.83C6.02734 15.83 6.43827 16.0939 7.11205 16.5423C7.22844 16.6196 7.35453 16.6984 7.48903 16.777C8.27079 17.2316 9.33707 17.6771 10.3859 17.7534C10.569 17.7671 10.7523 17.7776 10.9358 17.7848C11.7997 17.8171 12.4211 17.7489 13.0351 17.5455C14.2119 17.1543 14.9459 16.7728 15.0804 16.6994C15.0933 16.6926 15.0998 16.6884 15.1001 16.6884C14.8233 17.0023 14.5083 17.2802 14.1625 17.5158C13.8031 17.7632 13.4129 17.9627 13.0018 18.109C12.189 18.4007 11.2572 18.5061 10.1583 18.4285C8.85857 18.336 7.82559 17.6862 7.11787 17.0599C6.41014 16.4333 6.02734 15.83 6.02734 15.83Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask321_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 10,
    height: 4
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05078 15.8517H15.0424V18.4453H6.05078V15.8517Z",
    fill: "white"
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask321_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.038
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05078 15.8516C6.05078 15.8516 6.45718 16.1151 7.12417 16.5587C7.23927 16.635 7.36439 16.7129 7.49824 16.7909C8.27193 17.2409 9.32721 17.6822 10.3679 17.7601C10.5494 17.7738 10.7312 17.7841 10.913 17.7912C11.7679 17.8225 12.3857 17.7559 12.9939 17.5584C14.1539 17.1775 14.8797 16.8038 15.023 16.7294C15.0359 16.723 15.0424 16.7191 15.0424 16.7191C14.7902 17.0211 14.4966 17.2778 14.1649 17.5047C13.8001 17.7565 13.4035 17.9587 12.9855 18.1061C12.1775 18.3922 11.2519 18.4979 10.1584 18.421C8.8652 18.3295 7.83772 17.6871 7.13452 17.0673C6.43067 16.4481 6.05078 15.8516 6.05078 15.8516Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask322_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 9,
    height: 4
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 15.8808H14.9889V18.4453H6.07812V15.8808Z",
    fill: "white"
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask322_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.057
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07812 15.8807C6.07812 15.8807 6.48 16.1439 7.1402 16.5823C7.25433 16.6583 7.37848 16.7353 7.51104 16.8125C8.27696 17.2577 9.32125 17.6952 10.3542 17.7737C10.534 17.7874 10.714 17.7978 10.8942 17.8048C11.7399 17.8358 12.3539 17.7708 12.9566 17.5785C14.0998 17.2086 14.8188 16.8452 14.9695 16.7676C14.9821 16.7611 14.9886 16.7569 14.9889 16.7569C14.7658 17.0414 14.4916 17.2817 14.1709 17.5005C13.8012 17.7572 13.3983 17.9626 12.9734 18.1109C12.1703 18.3925 11.2501 18.4973 10.1625 18.4213C8.87508 18.3308 7.85407 17.6955 7.15475 17.0828C6.45543 16.4705 6.07812 15.8807 6.07812 15.8807Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask323_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 9,
    height: 4
  }, _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10156 15.9102H14.9315V18.4453H6.10156V15.9102Z",
    fill: "white"
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask323_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.076
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10156 15.9097C6.10156 15.9097 6.49923 16.1729 7.15232 16.6061C7.27264 16.6858 7.39534 16.7618 7.52025 16.8341C8.27841 17.2751 9.31139 17.7083 10.3363 17.7875C10.5245 17.8021 10.7016 17.8124 10.8714 17.8182C11.7081 17.849 12.3188 17.7872 12.9157 17.5984C14.0427 17.2421 14.7546 16.8865 14.9124 16.8056L14.9318 16.795C14.7388 17.062 14.4824 17.2861 14.174 17.4965C13.7991 17.7583 13.3896 17.9667 12.9574 18.1157C12.1588 18.3928 11.2451 18.4969 10.1627 18.4215C8.88203 18.3317 7.86651 17.7038 7.17172 17.0985C6.4766 16.493 6.10156 15.9101 6.10156 15.9101",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask324_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 9,
    height: 4
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12891 15.9393H14.8783V18.4453H6.12891V15.9393Z",
    fill: "white"
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask324_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.095
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.12891 15.9392C6.12891 15.9392 6.52205 16.2017 7.16867 16.6301C7.28086 16.7044 7.40275 16.7804 7.53304 16.8561C8.28377 17.2922 9.3051 17.7209 10.3232 17.8011C10.4993 17.8152 10.6756 17.8254 10.8521 17.8318C11.6798 17.8622 12.2876 17.8024 12.878 17.6185C13.9889 17.2738 14.6944 16.9282 14.8589 16.8435L14.8783 16.8331C14.7151 17.0821 14.4778 17.2903 14.1803 17.4933C13.8003 17.7596 13.3845 17.9708 12.9453 18.1206C12.1522 18.3931 11.2437 18.4962 10.1667 18.4219C8.89224 18.333 7.88287 17.7122 7.19227 17.1138C6.50104 16.5153 6.12891 15.9392 6.12891 15.9392Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask325_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 9,
    height: 4
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15234 15.9606H14.8206V18.4375H6.15234V15.9606Z",
    fill: "white"
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask325_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.114
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15234 15.9605C6.15234 15.9605 6.54129 16.223 7.18079 16.6459C7.29201 16.72 7.41293 16.7946 7.54193 16.87C8.2849 17.3013 9.29524 17.7261 10.3053 17.8073C10.4797 17.8213 10.6545 17.8316 10.8294 17.8383C11.648 17.8674 12.2519 17.8098 12.8371 17.6314C13.9312 17.2977 14.6276 16.9576 14.8015 16.8732C14.8135 16.8677 14.8196 16.8635 14.8209 16.8635C14.6874 17.095 14.4689 17.2864 14.1827 17.4817C13.7976 17.7529 13.3753 17.9671 12.9289 18.1176C12.1407 18.3853 11.2383 18.4878 10.1669 18.4144C8.89887 18.3265 7.89531 17.7129 7.2086 17.1212C6.52189 16.5302 6.15234 15.9605 6.15234 15.9605Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask326_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 9,
    height: 4
  }, _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17969 15.9897H14.7671V18.4375H6.17969V15.9897Z",
    fill: "white"
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask326_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.133
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17969 15.9896C6.17969 15.9896 6.5641 16.2515 7.19682 16.6699C7.30675 16.7429 7.42702 16.817 7.55472 16.8917C8.28993 17.3184 9.28929 17.7391 10.2912 17.8209C10.4641 17.8348 10.6372 17.845 10.8105 17.8516C11.62 17.881 12.2201 17.8247 12.7998 17.6511C13.8771 17.3285 14.567 16.9996 14.7484 16.9111C14.76 16.9056 14.7662 16.9017 14.7671 16.9014C14.6637 17.1154 14.4639 17.2903 14.1891 17.4778C13.7989 17.7539 13.3702 17.971 12.9168 18.1222C12.1338 18.386 11.2369 18.4875 10.1709 18.4145C8.90907 18.3275 7.91101 17.7213 7.22883 17.1367C6.54664 16.5525 6.17969 15.9896 6.17969 15.9896Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask327_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20312 16.011H14.7097V18.4297H6.20312V16.011Z",
    fill: "white"
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask327_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.152
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.20312 16.0114C6.20312 16.0114 6.58302 16.2726 7.20895 16.6858C7.31887 16.7582 7.4372 16.8319 7.56362 16.9057C8.29107 17.3276 9.2791 17.744 10.2736 17.8271C10.4447 17.8415 10.6161 17.8516 10.7877 17.8575C11.5879 17.8866 12.1847 17.8319 12.7582 17.6638C13.819 17.3525 14.5028 17.0337 14.691 16.9412L14.7097 16.9315C14.636 17.1281 14.4547 17.2872 14.1915 17.4663C13.7965 17.7475 13.3614 17.9676 12.9008 18.1194C12.1229 18.3787 11.2316 18.4789 10.1708 18.4071C8.9157 18.3211 7.92378 17.722 7.24548 17.1443C6.5675 16.5668 6.20312 16.0111 6.20312 16.0111",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask328_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 16.0398H14.6559V18.4297H6.23047V16.0398Z",
    fill: "white"
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask328_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.171
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 16.04C6.23047 16.04 6.60551 16.3012 7.22497 16.7099C7.3336 16.781 7.45097 16.8541 7.57673 16.9272C8.2961 17.3442 9.27314 17.7568 10.2599 17.8402C10.4367 17.8551 10.6058 17.8654 10.7685 17.8716C11.5599 17.8997 12.1532 17.847 12.7212 17.6837C13.7652 17.3837 14.4413 17.0727 14.6375 16.9789L14.6563 16.9692C14.6126 17.1483 14.4493 17.2906 14.1981 17.4626C13.7977 17.7483 13.3561 17.9713 12.8884 18.1237C12.1157 18.3792 11.2298 18.4784 10.1749 18.4073C8.92591 18.3223 7.94013 17.7303 7.26603 17.1593C6.59225 16.5893 6.23047 16.04 6.23047 16.04Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask329_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25391 16.0617H14.5989V18.4219H6.25391V16.0617Z",
    fill: "white"
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask329_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25391 16.0618C6.25391 16.0618 6.62507 16.3227 7.23742 16.7262C7.34508 16.7966 7.46147 16.8687 7.58562 16.9412C8.29755 17.354 9.26328 17.7621 10.2423 17.8468C10.4169 17.8613 10.5847 17.872 10.746 17.8775C11.5281 17.9056 12.1181 17.8548 12.68 17.6967C13.7075 17.4074 14.3758 17.1044 14.5804 17.0094L14.5989 17C14.5853 17.161 14.4411 17.2871 14.2009 17.4513C13.7954 17.7418 13.3474 17.9677 12.8727 18.1209C12.1049 18.3721 11.2251 18.4701 10.175 18.3996C8.93286 18.3159 7.95226 17.731 7.28268 17.1678C6.61311 16.6043 6.25391 16.0618 6.25391 16.0618Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask330_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 16.0908H14.5467V18.4219H6.28125V16.0908Z",
    fill: "white"
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask330_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.209
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 16.0907C6.28125 16.0907 6.64789 16.3513 7.25345 16.7496C7.35981 16.8198 7.47523 16.8912 7.59841 16.9627C8.30258 17.371 9.257 17.7748 10.2285 17.8602C10.3942 17.8747 10.5602 17.8849 10.7264 17.8909C11.5001 17.9187 12.0863 17.8699 12.6427 17.7166C13.6534 17.4389 14.3152 17.1463 14.527 17.047C14.5376 17.0419 14.5431 17.0386 14.5454 17.038C14.5616 17.1815 14.4361 17.2911 14.2072 17.4473C13.7966 17.7427 13.3421 17.9716 12.8603 18.1256C12.0973 18.3726 11.2237 18.4693 10.1791 18.4001C8.94306 18.317 7.96861 17.7396 7.30323 17.1828C6.63786 16.6264 6.28125 16.0907 6.28125 16.0907Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask331_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30859 16.1202H14.5026V18.4219H6.30859V16.1202Z",
    fill: "white"
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask331_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.228
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30859 16.1201C6.30859 16.1201 6.67102 16.3804 7.26947 16.7735C7.37487 16.843 7.48932 16.9138 7.61153 16.9843C8.30794 17.3885 9.25104 17.7881 10.2148 17.8738C10.3788 17.8884 10.5431 17.8987 10.7076 17.9048C11.4719 17.932 12.0545 17.8847 12.6054 17.7367C13.5992 17.4696 14.2549 17.1883 14.4741 17.0852C14.4841 17.0803 14.4903 17.0765 14.4919 17.0761C14.5378 17.2022 14.4311 17.2954 14.2139 17.4438C13.7982 17.7441 13.3372 17.9759 12.8482 18.1305C12.0907 18.3733 11.2223 18.469 10.1831 18.4001C8.95359 18.318 7.98496 17.7483 7.32379 17.1984C6.6623 16.6491 6.30859 16.1201 6.30859 16.1201Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask332_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 16.1493H14.4571V18.4219H6.32812V16.1493Z",
    fill: "white"
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask332_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.247
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 16.1488C6.32812 16.1488 6.68603 16.4091 7.27769 16.7974C7.38244 16.8659 7.4956 16.9361 7.61652 17.0063C8.30517 17.4049 9.23727 17.8006 10.1933 17.8873C10.3555 17.9022 10.5181 17.9127 10.6809 17.9186C11.4361 17.9451 12.0152 17.8999 12.5603 17.757C13.5376 17.5009 14.1849 17.2268 14.4125 17.1226L14.4306 17.1139C14.5063 17.2225 14.4177 17.2992 14.212 17.4401C13.7914 17.7451 13.3241 17.9799 12.8283 18.1353C12.0759 18.3742 11.213 18.4683 10.1794 18.4004C8.95599 18.3192 7.99317 17.7563 7.33621 17.2138C6.67924 16.6713 6.32812 16.1492 6.32812 16.1492",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask333_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35547 16.1781H14.4263V18.4219H6.35547V16.1781Z",
    fill: "white"
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask333_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.266
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35547 16.178C6.35547 16.178 6.70885 16.4376 7.29372 16.821C7.39718 16.8889 7.50937 16.9581 7.62899 17.0273C8.31021 17.4217 9.23132 17.8129 10.1793 17.9012C10.3399 17.9158 10.5008 17.926 10.662 17.9319C11.4078 17.9578 11.9837 17.9148 12.5229 17.7767C13.4832 17.532 14.1233 17.2659 14.359 17.1605C14.3687 17.156 14.3745 17.1524 14.3771 17.1518C14.4825 17.2423 14.4127 17.3031 14.2187 17.436C13.7928 17.746 13.3187 17.9838 12.8155 18.1398C12.0687 18.3745 11.2116 18.4676 10.1831 18.4007C8.96653 18.3199 8.00952 17.7648 7.35676 17.2287C6.70367 16.6933 6.35547 16.178 6.35547 16.178Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask334_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38281 16.1994H14.4003V18.4141H6.38281V16.1994Z",
    fill: "white"
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask334_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.285
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38281 16.1996C6.38281 16.1996 6.73199 16.4589 7.30974 16.8372C7.41256 16.9045 7.52378 16.973 7.64211 17.0415C8.31524 17.4314 9.22503 17.8188 10.1655 17.907C10.3295 17.9222 10.4889 17.9329 10.6431 17.9381C11.3802 17.9639 11.9518 17.9219 12.4859 17.7897C13.4294 17.5556 14.0627 17.2999 14.3055 17.1906L14.3236 17.1822C14.4588 17.2556 14.408 17.2995 14.225 17.4247C13.7943 17.7396 13.3139 17.9803 12.8038 18.1369C12.0618 18.3681 11.2102 18.4593 10.1872 18.393C8.97673 18.3138 8.02587 17.7658 7.37764 17.2368C6.72875 16.7082 6.38281 16.1996 6.38281 16.1996Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask335_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40625 16.2285H14.3749V18.4141H6.40625V16.2285Z",
    fill: "white"
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask335_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.305
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.40625 16.2285C6.40625 16.2285 6.7509 16.4875 7.32219 16.8609C7.42371 16.9272 7.53396 16.9951 7.65132 17.063C8.31669 17.4481 9.21517 17.8312 10.1479 17.9204C10.3099 17.9356 10.467 17.9463 10.6203 17.9518C11.348 17.977 11.9168 17.9363 12.4447 17.8095C13.3713 17.5865 13.9969 17.3385 14.2488 17.2282C14.2578 17.224 14.2633 17.2208 14.2663 17.2198C14.4315 17.2758 14.3995 17.3032 14.2278 17.4206C13.7919 17.7405 13.305 17.9843 12.7877 18.1416C12.0512 18.3689 11.2048 18.4587 10.1877 18.3931C8.98368 18.3149 8.03832 17.7737 7.39429 17.2522C6.74961 16.7307 6.40625 16.2285 6.40625 16.2285Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask336_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 16.2498H14.3566V18.4062H6.43359V16.2498Z",
    fill: "white"
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask336_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.324
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 16.2501C6.43359 16.2501 6.77404 16.5088 7.33822 16.8767C7.44503 16.9464 7.5537 17.0133 7.66411 17.0772C8.32173 17.4574 9.20889 17.8363 10.1342 17.9265C10.2939 17.9417 10.4491 17.9524 10.6014 17.9575C11.3201 17.9824 11.8849 17.9433 12.4074 17.8217C13.3175 17.61 13.9363 17.3723 14.195 17.2582L14.2128 17.2501C14.408 17.2883 14.3945 17.2996 14.2341 17.4089C13.7933 17.7339 13.3 17.9807 12.7757 18.1386C12.0443 18.362 11.2034 18.4506 10.1918 18.3853C8.99389 18.308 8.05435 17.7742 7.41452 17.2602C6.77436 16.7451 6.43359 16.2498 6.43359 16.2498",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask337_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45703 16.2789H14.338V18.4062H6.45703V16.2789Z",
    fill: "white"
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask337_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.343
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45703 16.2787C6.45703 16.2787 6.79327 16.5374 7.35034 16.9005C7.45056 16.9654 7.5579 17.0317 7.673 17.0983C8.32286 17.4743 9.19903 17.8491 10.1166 17.9402C10.274 17.9554 10.4276 17.9661 10.5783 17.9709C11.2879 17.9958 11.8492 17.9583 12.3662 17.8419C13.2595 17.6408 13.8705 17.4106 14.1379 17.2959C14.1466 17.2926 14.1521 17.2894 14.1554 17.2881C14.3804 17.3088 14.3852 17.3036 14.2368 17.4048C13.7911 17.7349 13.2912 17.9847 12.7596 18.1433C12.0335 18.3625 11.1984 18.4498 10.1916 18.3857C9.00051 18.3091 8.0668 17.7825 7.43084 17.2749C6.79489 16.7676 6.45703 16.2791 6.45703 16.2791",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask338_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48438 16.3005H14.3259V18.3984H6.48438V16.3005Z",
    fill: "white"
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask338_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.362
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48438 16.3003C6.48438 16.3003 6.81577 16.5579 7.36637 16.9165C7.4653 16.9805 7.57199 17.0465 7.6858 17.1124C8.32789 17.4832 9.19307 17.8541 10.1029 17.9459C10.2581 17.9614 10.41 17.9718 10.5594 17.9773C11.26 18.0012 11.8177 17.9653 12.3289 17.8544C13.2054 17.664 13.8077 17.4399 14.0844 17.3258C14.0928 17.3226 14.0983 17.3193 14.1016 17.318C14.357 17.3213 14.3803 17.2996 14.2432 17.3934C13.7925 17.7284 13.2862 17.9813 12.7475 18.1402C12.0266 18.3559 11.1969 18.4412 10.1957 18.3782C9.01072 18.3025 8.08315 17.7833 7.4514 17.2825C6.81998 16.7817 6.4847 16.3003 6.4847 16.3003",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask339_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 16.3293H14.3164V18.3984H6.51172V16.3293Z",
    fill: "white"
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask339_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.381
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.51172 16.3295C6.51172 16.3295 6.83891 16.5871 7.38239 16.9405C7.48035 17.0039 7.58608 17.0689 7.69891 17.1339C8.33325 17.5005 9.18679 17.8671 10.0888 17.9596C10.2421 17.9751 10.3924 17.9858 10.5402 17.991C11.232 18.0142 11.7859 17.98 12.2912 17.8746C13.1512 17.6945 13.7474 17.4827 14.0306 17.3637C14.0394 17.3605 14.0449 17.3576 14.0481 17.3563C14.3326 17.3417 14.3753 17.3039 14.2495 17.3896C13.7939 17.7296 13.2811 17.9854 12.7354 18.1448C12.0196 18.3569 11.1952 18.4407 10.1997 18.3783C9.02125 18.3039 8.09917 17.7915 7.47195 17.2984C6.84441 16.8044 6.51172 16.3295 6.51172 16.3295Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask340_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 16.3583H14.3017V18.3984H6.53125V16.3583Z",
    fill: "white"
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask340_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 16.3584C6.53125 16.3584 6.85391 16.6158 7.39125 16.964C7.4876 17.0267 7.59235 17.0914 7.7039 17.1557C8.33047 17.5178 9.17302 17.8799 10.0673 17.973C10.2183 17.9886 10.367 17.9992 10.5135 18.0044C11.196 18.0274 11.7462 17.995 12.2464 17.8945C13.089 17.7254 13.6796 17.5253 13.97 17.4018L13.9868 17.394C14.3014 17.362 14.3625 17.308 14.248 17.3859C13.7874 17.7308 13.2682 17.9895 12.7155 18.1496C12.0049 18.3584 11.1863 18.4399 10.1957 18.3785C9.02365 18.3051 8.10771 17.8001 7.48437 17.3132C6.86135 16.8266 6.53125 16.3584 6.53125 16.3584Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask341_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55859 16.3874H14.2967V18.3984H6.55859V16.3874Z",
    fill: "white"
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask341_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.55859 16.3875C6.55859 16.3875 6.87706 16.6445 7.40696 16.9876C7.50299 17.05 7.60644 17.1137 7.71734 17.177C8.33583 17.5346 9.16706 17.8925 10.0539 17.9869C10.2026 18.0024 10.3494 18.0131 10.4946 18.018C11.168 18.0406 11.7151 18.0099 12.2091 17.9148C13.0351 17.7564 13.6171 17.5624 13.9165 17.4396C13.9243 17.4363 13.9297 17.4334 13.9336 17.4321C14.278 17.3823 14.3578 17.3118 14.2547 17.382C13.789 17.7321 13.2631 17.994 12.7031 18.1547C11.9983 18.3594 11.1848 18.4395 10.2 18.3784C9.0345 18.306 8.12439 17.8084 7.50525 17.3287C6.88611 16.8492 6.55859 16.3878 6.55859 16.3878",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask342_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58594 16.4165H14.293V18.3984H6.58594V16.4165Z",
    fill: "white"
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask342_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.438
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58594 16.4164C6.58594 16.4164 6.89987 16.6731 7.42298 17.0116C7.51804 17.073 7.62053 17.1357 7.72981 17.1991C8.34086 17.5515 9.1611 17.9052 10.0399 18.0003C10.1866 18.0158 10.3318 18.0264 10.4757 18.0316C11.1401 18.0536 11.6832 18.0242 12.1718 17.9346C12.981 17.7865 13.5546 17.599 13.8633 17.4768C13.8708 17.4739 13.8759 17.4713 13.8798 17.4703C14.2542 17.4028 14.3525 17.3155 14.261 17.3782C13.7904 17.7332 13.2581 17.9979 12.691 18.159C11.991 18.3604 11.1834 18.4387 10.2038 18.3788C9.04471 18.3071 8.14041 17.8166 7.52547 17.3443C6.91086 16.8713 6.58594 16.4164 6.58594 16.4164Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask343_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60938 16.4382H14.287V18.3906H6.60938V16.4382Z",
    fill: "white"
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask343_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.457
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60938 16.4379C6.60938 16.4379 6.91878 16.694 7.43511 17.0273C7.52887 17.0881 7.63071 17.1502 7.7387 17.2126C8.34199 17.5605 9.15092 17.9103 10.0222 18.0063C10.1668 18.0218 10.31 18.0328 10.4529 18.0374C11.1082 18.0593 11.6475 18.0312 12.1305 17.9472C12.9227 17.8094 13.4907 17.6345 13.8059 17.5074L13.8221 17.5C14.2262 17.415 14.3436 17.3118 14.2634 17.3665C13.788 17.7267 13.2492 17.9944 12.675 18.1557C11.9799 18.3536 11.1781 18.4305 10.2039 18.371C9.05134 18.3005 8.15253 17.8172 7.54212 17.3513C6.93171 16.8857 6.60938 16.4379 6.60938 16.4379Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask344_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63672 16.4669H14.2869V18.3906H6.63672V16.4669Z",
    fill: "white"
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask344_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.476
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.63672 16.4671C6.63672 16.4671 6.9416 16.7228 7.45146 17.0513C7.54425 17.1111 7.6448 17.1729 7.75149 17.2343C8.34703 17.5776 9.14496 17.9233 10.0085 18.0199C10.1508 18.0361 10.293 18.0464 10.4337 18.051C11.0803 18.0726 11.616 18.0455 12.0932 17.9672C12.8685 17.8398 13.4308 17.6779 13.7525 17.545C13.7592 17.5421 13.7647 17.5395 13.7689 17.5385C14.2028 17.4357 14.3386 17.3161 14.2701 17.363C13.7898 17.7281 13.2445 17.9987 12.6632 18.1602C11.9733 18.3549 11.1766 18.4296 10.208 18.3714C9.06155 18.3015 8.16889 17.8256 7.56268 17.3668C6.95647 16.9081 6.63672 16.4671 6.63672 16.4671Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask345_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66016 16.4882H14.2838V18.3828H6.66016V16.4882Z",
    fill: "white"
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask345_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.495
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66016 16.4883C6.66016 16.4883 6.96084 16.7438 7.46358 17.0671C7.55605 17.1262 7.65498 17.1867 7.7607 17.2481C8.34848 17.5863 9.13542 17.928 9.99122 18.0257C10.1312 18.0419 10.2712 18.0522 10.4112 18.0571C11.0481 18.0777 11.5806 18.0522 12.0523 17.9795C12.8108 17.8621 13.3614 17.6982 13.6954 17.5743L13.7116 17.5682C14.1758 17.4479 14.33 17.3118 14.2728 17.3509C13.7874 17.7214 13.2353 17.995 12.6466 18.157C11.9628 18.3477 11.1716 18.4211 10.2085 18.3639C9.06849 18.2947 8.18133 17.8259 7.57933 17.3745C6.97732 16.9225 6.66048 16.488 6.66048 16.488",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask346_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 16.517H14.2859V18.3828H6.6875V16.517Z",
    fill: "white"
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask346_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.514
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68783 16.517C6.68783 16.517 6.98365 16.7724 7.47994 17.0905C7.57046 17.149 7.66875 17.2092 7.77318 17.2693C8.3532 17.6033 9.12882 17.9405 9.97686 18.0391C10.1149 18.0553 10.2533 18.0656 10.392 18.0705C11.0199 18.0908 11.5488 18.0666 12.015 17.9993C12.7564 17.8927 13.3008 17.7413 13.6419 17.6123L13.6581 17.6059C14.1518 17.4681 14.3247 17.3159 14.2788 17.3472C13.7887 17.7228 13.2302 17.9995 12.6345 18.162C11.9558 18.3495 11.1699 18.4206 10.2122 18.3637C9.0787 18.2958 8.19736 17.8341 7.59988 17.3893C7.00176 16.9447 6.6875 16.517 6.6875 16.517",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask347_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71484 16.5461H14.289V18.3828H6.71484V16.5461Z",
    fill: "white"
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask347_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.533
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71484 16.5462C6.71484 16.5462 7.0068 16.8017 7.49564 17.1146C7.58584 17.1728 7.68284 17.2317 7.7863 17.2912C8.35856 17.6209 9.12286 17.9539 9.96347 18.0529C10.0993 18.069 10.2357 18.0797 10.3731 18.0842C10.9919 18.104 11.517 18.0813 11.9777 18.0199C12.7019 17.9232 13.2405 17.7832 13.5884 17.6504L13.6046 17.6442C14.1284 17.489 14.3198 17.3203 14.2855 17.3435C13.7903 17.7241 13.2253 18.0038 12.6224 18.1667C11.9489 18.351 11.1688 18.4198 10.2163 18.3639C9.08924 18.297 8.21371 17.8427 7.62011 17.405C7.02652 16.9675 6.71484 16.5462 6.71484 16.5462Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask348_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73438 16.5755H14.2859V18.3828H6.73438V16.5755Z",
    fill: "white"
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask348_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.552
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73438 16.5758C6.73438 16.5758 7.02212 16.8302 7.50386 17.1383C7.59309 17.1956 7.68911 17.2544 7.7916 17.3129C8.3561 17.6375 9.10909 17.967 9.94161 18.0662C10.0755 18.0824 10.2103 18.0934 10.3461 18.0979C10.9562 18.1173 11.4777 18.0957 11.9326 18.0397C12.6406 17.9531 13.1728 17.8273 13.5275 17.6883C13.5329 17.6864 13.5383 17.6842 13.5436 17.6818C14.0965 17.5095 14.307 17.3242 14.284 17.3398C13.7838 17.7203 13.2439 17.999 12.6028 18.1716C11.9345 18.353 11.1595 18.419 10.2125 18.364C9.09195 18.2981 8.22225 17.8509 7.63286 17.4203C7.04379 16.9893 6.73438 16.5755 6.73438 16.5755",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask349_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76172 16.6046H14.291V18.3828H6.76172V16.6046Z",
    fill: "white"
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask349_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.571
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76172 16.6047C6.76172 16.6047 7.04461 16.8588 7.51988 17.1624C7.60846 17.2187 7.7032 17.2765 7.80439 17.3347C8.36113 17.6548 9.10313 17.9797 9.9279 18.0806C10.0595 18.0968 10.1927 18.1074 10.3272 18.112C10.9282 18.131 11.4458 18.1094 11.8952 18.0602C12.5862 17.9826 13.1054 17.8507 13.474 17.7259L13.4898 17.7201C14.0731 17.5294 14.302 17.3279 14.2906 17.336C13.7853 17.7211 13.2399 18.003 12.59 18.176C11.9279 18.3538 11.1578 18.4185 10.2166 18.3641C9.10216 18.2995 8.23795 17.8598 7.65341 17.4356C7.06822 17.0121 6.76172 16.6047 6.76172 16.6047Z",
    fill: "#005EAD"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask350_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 16,
    width: 9,
    height: 3
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78906 16.6259H14.297V18.375H6.78906V16.6259Z",
    fill: "white"
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask350_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.297 17.3239C13.7868 17.7142 13.2359 17.999 12.5783 18.173C11.9206 18.3469 11.1567 18.4099 10.2207 18.3566C9.11269 18.2926 8.25495 17.86 7.67396 17.4432C7.09297 17.0262 6.78906 16.6259 6.78906 16.6259C6.78906 16.6259 7.18124 16.9832 7.81719 17.3482C8.45314 17.7135 9.33287 18.086 10.3083 18.1173C11.7991 18.1646 12.7962 17.966 13.4208 17.7559C14.0451 17.5457 14.297 17.3243 14.297 17.3243",
    fill: "#005EAD"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask351_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 3,
    height: 4
  }, _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 15.8168H16.0267V18.3047H14.793V15.8168Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask351_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask352_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 3,
    height: 4
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8008 15.8446H16.02V18.3047H14.8008V15.8446Z",
    fill: "white"
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask352_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9479 15.8456C15.7749 15.8857 15.0785 16.5304 14.9321 16.9167C14.9321 16.9167 14.5192 17.7952 15.1577 18.1159C15.7219 18.3985 16.0329 18.3147 16.0197 18.1815C16.0068 18.049 15.441 17.8382 15.5211 17.3713C15.6007 16.9041 16.1215 15.8052 15.9479 15.8456Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask353_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 3,
    height: 4
  }, _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8047 15.8643H16.0093V18.2969H14.8047V15.8643Z",
    fill: "white"
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask353_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9325 15.8655C15.7615 15.9052 15.0796 16.536 14.9351 16.9204C14.9351 16.9204 14.5255 17.7908 15.1582 18.1089C15.7169 18.3902 16.0224 18.3068 16.0091 18.1745C15.9962 18.042 15.4288 17.8364 15.5083 17.3727C15.5872 16.9085 16.1042 15.8251 15.9325 15.8655Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask354_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 2,
    height: 4
  }, _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8086 15.8921H15.999V18.2969H14.8086V15.8921Z",
    fill: "white"
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask354_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9174 15.8933C15.7479 15.9331 15.0813 16.55 14.9377 16.9315C14.9377 16.9315 14.5323 17.7941 15.1582 18.1106C15.7111 18.3896 16.0118 18.3065 15.9985 18.1753C15.9856 18.0443 15.4172 17.8426 15.4958 17.3819C15.574 16.9205 16.0874 15.8533 15.9174 15.8933Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask355_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 2,
    height: 4
  }, _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 15.9196H15.9884V18.2969H14.8125V15.9196Z",
    fill: "white"
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask355_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.902 15.9208C15.7342 15.9603 15.0827 16.5636 14.9404 16.9425C14.9404 16.9425 14.5389 17.7973 15.1587 18.1119C15.706 18.389 16.0009 18.3065 15.9879 18.1759C15.975 18.0456 15.405 17.8484 15.4829 17.3909C15.5605 16.9325 16.0701 15.8811 15.902 15.9208Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask356_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 2,
    height: 4
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8164 15.9396H15.9777V18.2891H14.8164V15.9396Z",
    fill: "white"
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask356_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8865 15.9407C15.7203 15.9798 15.084 16.5692 14.9434 16.9462C14.9434 16.9462 14.5454 17.7932 15.1587 18.1052C15.7006 18.3807 15.9902 18.2986 15.9773 18.1689C15.9644 18.0396 15.3931 17.8469 15.4697 17.392C15.5467 16.9368 16.053 15.9015 15.8865 15.9407Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask357_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 2,
    height: 4
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8203 15.9599H15.9671V18.2812H14.8203V15.9599Z",
    fill: "white"
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask357_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.871 15.9607C15.7067 15.9995 15.0853 16.5756 14.9463 16.95C14.9463 16.95 14.5519 17.7887 15.1587 18.0987C15.6954 18.3723 15.9793 18.2908 15.967 18.1615C15.9541 18.0331 15.3808 17.8453 15.4571 17.3936C15.5331 16.941 16.0359 15.9216 15.871 15.9607Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask358_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 2,
    height: 4
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8281 15.9874H15.9607V18.2812H14.8281V15.9874Z",
    fill: "white"
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask358_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8597 15.9886C15.697 16.0274 15.0902 16.5893 14.9528 16.9611C14.9528 16.9611 14.5626 17.792 15.1629 18.1001C15.6938 18.3717 15.9725 18.2905 15.9602 18.1625C15.9473 18.0348 15.3731 17.8515 15.4484 17.4027C15.5234 16.953 16.0226 15.9498 15.8597 15.9886Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask359_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M14.832 16.007H15.95V18.2734H14.832V16.007Z",
    fill: "white"
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask359_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8439 16.0083C15.6833 16.0468 15.0919 16.5951 14.9555 16.9643C14.9555 16.9643 14.5691 17.7871 15.1634 18.0936C15.6884 18.3636 15.962 18.2824 15.9497 18.1551C15.9367 18.0283 15.3609 17.8495 15.4356 17.404C15.51 16.9572 16.0056 15.9698 15.8443 16.0083",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask360_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8359 16.0352H15.9394V18.2734H14.8359V16.0352Z",
    fill: "white"
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask360_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8288 16.0362C15.6694 16.0744 15.0933 16.6088 14.9584 16.9757C14.9584 16.9757 14.5756 17.7908 15.1634 18.0947C15.6827 18.3631 15.951 18.2822 15.9387 18.1561C15.9264 18.0301 15.349 17.8558 15.4227 17.4132C15.4964 16.9696 15.9885 15.9981 15.8288 16.0362Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask361_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8398 16.0623H15.9288V18.2734H14.8398V16.0623Z",
    fill: "white"
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask361_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8134 16.0637C15.6559 16.1016 15.0943 16.6227 14.9611 16.9868C14.9611 16.9868 14.5822 17.7944 15.1639 18.0957C15.6776 18.3625 15.9404 18.2823 15.9282 18.1568C15.9159 18.0314 15.3371 17.862 15.4099 17.4223C15.483 16.9816 15.9712 16.0256 15.8134 16.0637Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask362_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 16.0823H15.9184V18.2656H14.8438V16.0823Z",
    fill: "white"
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask362_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7982 16.0835C15.6423 16.121 15.0959 16.6283 14.964 16.9901C14.964 16.9901 14.5887 17.7896 15.1642 18.0896C15.6721 18.3541 15.9298 18.2743 15.9178 18.1495C15.9058 18.025 15.3252 17.8601 15.3973 17.4233C15.4694 16.9859 15.9543 16.046 15.7982 16.0835Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask363_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8516 16.1026H15.9114V18.2578H14.8516V16.1026Z",
    fill: "white"
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask363_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7866 16.1035C15.6324 16.141 15.1012 16.6343 14.9709 16.9935C14.9709 16.9935 14.5991 17.785 15.1681 18.0831C15.6705 18.3459 15.9227 18.2661 15.9111 18.1426C15.8988 18.0187 15.3168 17.8584 15.3883 17.4248C15.4594 16.99 15.9408 16.0663 15.7866 16.1035Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask364_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8555 16.1301H15.9011V18.2578H14.8555V16.1301Z",
    fill: "white"
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask364_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7711 16.1313C15.6188 16.1684 15.1025 16.6479 14.9735 17.0052C14.9735 17.0052 14.6059 17.7882 15.1681 18.0844C15.6651 18.3453 15.9118 18.2661 15.9004 18.1432C15.8885 18.0204 15.3049 17.8645 15.3754 17.4339C15.4462 17.0023 15.9237 16.0941 15.7711 16.1309",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask365_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8594 16.1501H15.8904V18.25H14.8594V16.1501Z",
    fill: "white"
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask365_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7557 16.1511C15.605 16.188 15.1036 16.6539 14.9765 17.0079C14.9765 17.0079 14.6122 17.7838 15.1686 18.0777C15.66 18.337 15.9012 18.2581 15.8899 18.1359C15.8779 18.014 15.2931 17.8627 15.3629 17.435C15.4324 17.0066 15.9067 16.1143 15.7557 16.1511Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask366_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8633 16.1779H15.8794V18.25H14.8633V16.1779Z",
    fill: "white"
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask366_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7406 16.179C15.5915 16.2155 15.1052 16.6675 14.9792 17.0196C14.9792 17.0196 14.619 17.7874 15.1686 18.0791C15.6546 18.3364 15.8906 18.2579 15.8793 18.1373C15.8676 18.0157 15.2811 17.8689 15.35 17.4444C15.4189 17.0186 15.8896 16.1424 15.7406 16.179Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask367_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8672 16.1976H15.8688V18.2422H14.8672V16.1976Z",
    fill: "white"
  }))), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask367_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.725 16.1988C15.5779 16.2353 15.1065 16.674 14.982 17.0232C14.982 17.0232 14.6254 17.783 15.1689 18.0723C15.649 18.3281 15.8799 18.2502 15.8686 18.1296C15.8569 18.0093 15.2691 17.8677 15.3374 17.4454C15.4053 17.0229 15.8724 16.1629 15.725 16.1991",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask368_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8711 16.2254H15.8585V18.2422H14.8711V16.2254Z",
    fill: "white"
  }))), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask368_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7133 16.2264C15.5678 16.2622 15.1119 16.6874 14.9887 17.0346C14.9887 17.0346 14.636 17.786 15.173 18.0738C15.6476 18.3276 15.873 18.25 15.8617 18.1303C15.8503 18.011 15.2609 17.8733 15.3282 17.4546C15.3958 17.0346 15.8591 16.1905 15.7136 16.2264",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask369_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 16.2454H15.8478V18.2344H14.875V16.2454Z",
    fill: "white"
  }))), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask369_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6945 16.2465C15.5506 16.282 15.1093 16.6933 14.9877 17.0376C14.9877 17.0376 14.6385 17.7819 15.1694 18.0674C15.6385 18.3192 15.8584 18.2419 15.8474 18.1233C15.8361 18.0046 15.2454 17.8711 15.3117 17.4556C15.3783 17.0386 15.8387 16.2109 15.6945 16.2465Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask370_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8828 16.2729H15.8411V18.2344H14.8828V16.2729Z",
    fill: "white"
  }))), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask370_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.683 16.2741C15.5408 16.3097 15.1143 16.707 14.9944 17.0491C14.9944 17.0491 14.6491 17.7853 15.1735 18.0685C15.6368 18.3187 15.8515 18.2418 15.8405 18.1241C15.8295 18.0061 15.2372 17.8777 15.3028 17.4652C15.3684 17.051 15.8249 16.2389 15.6827 16.2741",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask371_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8867 16.3003H15.8305V18.2344H14.8867V16.3003Z",
    fill: "white"
  }))), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask371_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6675 16.3017C15.5272 16.3369 15.1159 16.7207 14.9969 17.0605C14.9969 17.0605 14.6558 17.7886 15.1738 18.0699C15.6316 18.3182 15.8408 18.2416 15.8301 18.1249C15.8188 18.0075 15.2252 17.884 15.2902 17.474C15.3548 17.0631 15.8075 16.2668 15.6675 16.3017Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask372_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8906 16.3203H15.8198V18.2266H14.8906V16.3203Z",
    fill: "white"
  }))), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask372_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6523 16.3218C15.5132 16.3567 15.1175 16.7266 14.9998 17.0638C14.9998 17.0638 14.6623 17.7838 15.1741 18.0635C15.6258 18.3099 15.8298 18.2336 15.8194 18.1178C15.8081 18.0014 15.2129 17.8821 15.2769 17.4751C15.3416 17.0677 15.7913 16.2872 15.6523 16.3218Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask373_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8945 16.3403H15.8095V18.2188H14.8945V16.3403Z",
    fill: "white"
  }))), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask373_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6368 16.3414C15.5 16.376 15.1185 16.7326 15.0028 17.0669C15.0028 17.0669 14.6688 17.7794 15.1741 18.0568C15.6209 18.3016 15.8198 18.2256 15.8091 18.1105C15.7984 17.9948 15.2013 17.8803 15.2647 17.4768C15.328 17.0717 15.7735 16.3071 15.6365 16.3414",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask374_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8984 16.3684H15.7989V18.2188H14.8984V16.3684Z",
    fill: "white"
  }))), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask374_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6212 16.3693C15.4861 16.4036 15.1201 16.746 15.0053 17.0783C15.0053 17.0783 14.6756 17.7828 15.1744 18.058C15.6151 18.3011 15.8088 18.2255 15.7984 18.1113C15.7877 17.9965 15.1893 17.8863 15.2514 17.4854C15.3141 17.0838 15.7564 16.3351 15.6212 16.3693Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask375_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 16.3878H15.7921V18.2109H14.9062V16.3878Z",
    fill: "white"
  }))), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask375_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6099 16.3891C15.4764 16.4231 15.1252 16.7519 15.0121 17.082C15.0121 17.082 14.6859 17.7784 15.1789 18.0516C15.6138 18.2928 15.8019 18.2174 15.7919 18.1043C15.7809 17.9901 15.1812 17.8844 15.2429 17.4867C15.305 17.0881 15.7434 16.3552 15.6099 16.3891Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask376_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 16.4153H15.7776V18.2109H14.9062V16.4153Z",
    fill: "white"
  }))), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask376_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5906 16.4165C15.4586 16.4502 15.1227 16.7657 15.0112 17.0929C15.0112 17.0929 14.6885 17.7816 15.1748 18.0531C15.6045 18.2924 15.7875 18.2171 15.7771 18.1049C15.7668 17.9917 15.1654 17.8908 15.2262 17.4957C15.2873 17.1 15.7221 16.3829 15.5906 16.4165Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask377_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 16.4434H15.7712V18.2109H14.9141V16.4434Z",
    fill: "white"
  }))), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask377_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.579 16.4447C15.449 16.4783 15.1277 16.7796 15.0177 17.1046C15.0177 17.1046 14.699 17.7851 15.1794 18.0541C15.6029 18.2918 15.7807 18.2171 15.7704 18.1058C15.7601 17.9933 15.1571 17.897 15.2175 17.5051C15.2774 17.112 15.709 16.411 15.579 16.4447Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask378_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M14.918 16.4631H15.7605V18.2031H14.918V16.4631Z",
    fill: "white"
  }))), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask378_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5638 16.4645C15.4354 16.4982 15.1292 16.7856 15.0206 17.1079C15.0206 17.1079 14.7057 17.7804 15.179 18.0475C15.5977 18.2835 15.77 18.2091 15.76 18.0986C15.75 17.9873 15.1454 17.8955 15.2046 17.5066C15.2641 17.1167 15.6921 16.4312 15.5638 16.4645Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask379_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9219 16.4831H15.7495V18.1953H14.9219V16.4831Z",
    fill: "white"
  }))), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask379_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5487 16.4844C15.4216 16.5177 15.1307 16.7912 15.0233 17.111C15.0233 17.111 14.7123 17.776 15.1795 18.0408C15.5923 18.2749 15.7592 18.2015 15.7495 18.0913C15.7391 17.9807 15.1332 17.8934 15.1918 17.5077C15.2506 17.1207 15.6751 16.4514 15.5487 16.4844Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask380_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9258 16.5109H15.7392V18.1953H14.9258V16.5109Z",
    fill: "white"
  }))), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask380_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5371 16.512C15.4119 16.545 15.1362 16.8049 15.0301 17.1224C15.0301 17.1224 14.7226 17.7794 15.1837 18.0422C15.5911 18.2744 15.7527 18.2013 15.7427 18.092C15.7327 17.9824 15.1252 17.8997 15.183 17.5165C15.2409 17.1328 15.6615 16.479 15.5371 16.512Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask381_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9297 16.5309H15.7289V18.1875H14.9297V16.5309Z",
    fill: "white"
  }))), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask381_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5176 16.5322C15.3944 16.5648 15.1335 16.8109 15.0291 17.1261C15.0291 17.1261 14.7252 17.7753 15.1801 18.0356C15.5816 18.2661 15.7381 18.1933 15.7281 18.085C15.7184 17.9761 15.1096 17.8981 15.1662 17.5183C15.2234 17.1371 15.6405 16.4998 15.5176 16.5322Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask382_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 2,
    height: 3
  }, _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9375 16.5583H15.7215V18.1875H14.9375V16.5583Z",
    fill: "white"
  }))), _g372 || (_g372 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask382_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0357 17.1372C15.0357 17.1372 14.7357 17.7784 15.1844 18.037C15.5802 18.2656 15.7308 18.1932 15.7215 18.0855C15.7118 17.9778 15.1013 17.9041 15.1573 17.5271C15.2139 17.1489 15.6274 16.5278 15.5065 16.5598C15.3846 16.5921 15.1385 16.8246 15.0357 17.1372Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask383_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 3,
    height: 7
  }, _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6523 12.1882H23.8176V18.2344H21.6523V12.1882Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask383_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask384_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 3,
    height: 7
  }, _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6602 12.3307H23.7743V18.2344H21.6602V12.3307Z",
    fill: "white"
  }))), _g373 || (_g373 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask384_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7606 12.3311C23.5876 12.3716 21.9375 16.4595 21.7916 16.8462C21.7916 16.8462 21.3785 17.7249 22.017 18.045C22.5812 18.3282 22.8932 18.2445 22.8789 18.1113C22.866 17.9787 22.3002 17.7686 22.3801 17.3004C22.4599 16.8332 23.9333 12.291 23.7606 12.3311Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask385_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 3,
    height: 7
  }, _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6602 12.4652H23.7238V18.2266H21.6602V12.4652Z",
    fill: "white"
  }))), _g374 || (_g374 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask385_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7093 12.4656C23.5386 12.5057 21.935 16.4649 21.7905 16.8497C21.7905 16.8497 21.3812 17.7204 22.0133 18.0385C22.5719 18.3198 22.8781 18.2367 22.8645 18.1041C22.8513 17.9725 22.2842 17.7666 22.3634 17.3023C22.4426 16.8374 23.8804 12.4258 23.7093 12.4656Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask386_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 3,
    height: 7
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 12.6078H23.6803V18.2266H21.668V12.6078Z",
    fill: "white"
  }))), _g375 || (_g375 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask386_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6661 12.6081C23.497 12.6479 21.9406 16.4791 21.7973 16.8606C21.7973 16.8606 21.3916 17.7238 22.0172 18.04C22.5701 18.3194 22.8714 18.2363 22.8578 18.105C22.8445 17.9741 22.2758 17.773 22.3547 17.311C22.433 16.8496 23.8355 12.5686 23.6661 12.6081Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask387_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 3,
    height: 7
  }, _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6719 12.7425H23.6331V18.2188H21.6719V12.7425Z",
    fill: "white"
  }))), _g376 || (_g376 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask387_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.619 12.7428C23.4515 12.7822 21.9417 16.4848 21.8 16.864C21.8 16.864 21.3982 17.7192 22.0176 18.0331C22.5653 18.3111 22.8608 18.2284 22.8476 18.0978C22.8343 17.9678 22.2643 17.7712 22.3419 17.3121C22.4195 16.8537 23.7868 12.7036 23.619 12.7428Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask388_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 12,
    width: 3,
    height: 7
  }, _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6758 12.8776H23.5862V18.2109H21.6758V12.8776Z",
    fill: "white"
  }))), _g377 || (_g377 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask388_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5718 12.8775C23.4062 12.9163 21.9429 16.4905 21.8026 16.8672C21.8026 16.8672 21.4049 17.7143 22.0179 18.0266C22.5598 18.3027 22.8501 18.2206 22.8369 18.0906C22.824 17.9613 22.252 17.7692 22.3293 17.3133C22.4056 16.8581 23.7379 12.8384 23.5718 12.8775Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask389_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 13.0199H23.5387V18.2109H21.6797V13.0199Z",
    fill: "white"
  }))), _g378 || (_g378 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask389_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5245 13.0202C23.3606 13.059 21.9445 16.5045 21.8055 16.8789C21.8055 16.8789 21.4114 17.7182 22.0182 18.0283C22.5543 18.3021 22.8388 18.2203 22.8259 18.0913C22.8129 17.9633 22.24 17.7754 22.3163 17.3228C22.392 16.8702 23.6888 12.9814 23.5245 13.0202Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask390_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6836 13.1621H23.4919V18.2109H21.6836V13.1621Z",
    fill: "white"
  }))), _g379 || (_g379 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask390_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4774 13.1626C23.3154 13.2014 21.9459 16.5179 21.8085 16.8904C21.8085 16.8904 21.4179 17.7213 22.0183 18.0294C22.5488 18.3016 22.8282 18.2202 22.8156 18.0921C22.8026 17.9644 22.2281 17.7817 22.3038 17.3317C22.3784 16.8823 23.64 13.1241 23.4774 13.1626Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask391_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6914 13.2972H23.4486V18.2031H21.6914V13.2972Z",
    fill: "white"
  }))), _g380 || (_g380 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask391_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4342 13.2972C23.2738 13.3357 21.9512 16.5242 21.8151 16.8937C21.8151 16.8937 21.4284 17.7169 22.0226 18.023C22.5474 18.2933 22.8215 18.2122 22.8086 18.0848C22.7963 17.958 22.2202 17.7799 22.2949 17.3331C22.3692 16.8866 23.5952 13.2591 23.4342 13.2972Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask392_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6914 13.4395H23.3978V18.2031H21.6914V13.4395Z",
    fill: "white"
  }))), _g381 || (_g381 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask392_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3831 13.4399C23.2246 13.478 21.9485 16.5381 21.814 16.9048C21.814 16.9048 21.4309 17.7205 22.019 18.0244C22.5383 18.2928 22.8069 18.2119 22.7943 18.0858C22.782 17.9597 22.2043 17.7861 22.278 17.3422C22.3514 16.899 23.5425 13.402 23.3831 13.4399Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask393_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 13.5739H23.3546V18.1953H21.6992V13.5739Z",
    fill: "white"
  }))), _g382 || (_g382 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask393_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3401 13.5744C23.1829 13.6122 21.954 16.5437 21.8205 16.9084C21.8205 16.9084 21.4416 17.7157 22.0232 18.0177C22.537 18.2844 22.8005 18.2042 22.7879 18.0781C22.7756 17.953 22.1962 17.7843 22.2693 17.3436C22.342 16.9029 23.4975 13.5369 23.3401 13.5744Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask394_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7031 13.709H23.3077V18.1875H21.7031V13.709Z",
    fill: "white"
  }))), _g383 || (_g383 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask394_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2924 13.7092C23.1372 13.747 21.9552 16.5498 21.8236 16.9119C21.8236 16.9119 21.4479 17.7111 22.0234 18.0111C22.531 18.2762 22.7893 18.1961 22.7767 18.0713C22.7651 17.9471 22.1841 17.7825 22.2562 17.3448C22.3283 16.9073 23.4486 13.672 23.2927 13.7092",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask395_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M21.707 13.8516H23.2605V18.1875H21.707V13.8516Z",
    fill: "white"
  }))), _g384 || (_g384 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask395_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2457 13.8517C23.0921 13.8889 21.957 16.5633 21.8264 16.9231C21.8264 16.9231 21.4545 17.7143 22.0236 18.0127C22.526 18.2755 22.7788 18.196 22.7665 18.0719C22.7543 17.9484 22.1723 17.7886 22.2437 17.3535C22.3149 16.9193 23.3999 13.8145 23.2457 13.852",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask396_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 3,
    height: 6
  }, _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7148 13.9938H23.2176V18.1875H21.7148V13.9938Z",
    fill: "white"
  }))), _g385 || (_g385 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask396_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2024 13.9944C23.0504 14.0316 21.9622 16.5773 21.8332 16.9346C21.8332 16.9346 21.4649 17.7183 22.0278 18.0141C22.5244 18.275 22.772 18.1958 22.7598 18.0726C22.7478 17.9498 22.1642 17.7949 22.2347 17.363C22.3049 16.9317 23.3546 13.9575 23.2024 13.9944Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask397_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 3,
    height: 5
  }, _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7148 14.1289H23.1665V18.1797H21.7148V14.1289Z",
    fill: "white"
  }))), _g386 || (_g386 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask397_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1516 14.129C23.0012 14.1658 21.9595 16.5829 21.8318 16.9379C21.8318 16.9379 21.4678 17.7135 22.0242 18.0074C22.5156 18.2667 22.7574 18.1878 22.7452 18.0656C22.7335 17.9437 22.1483 17.7931 22.2182 17.364C22.2873 16.936 23.3019 14.0921 23.1512 14.129",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask398_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 3,
    height: 5
  }, _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7227 14.2712H23.1236V18.1797H21.7227V14.2712Z",
    fill: "white"
  }))), _g387 || (_g387 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask398_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.108 14.2716C22.9599 14.3081 21.9648 16.5968 21.8387 16.9489C21.8387 16.9489 21.4782 17.7168 22.0281 18.0094C22.5137 18.2661 22.7507 18.1875 22.7384 18.0663C22.7271 17.945 22.1403 17.7992 22.2092 17.3734C22.2777 16.9483 23.257 14.2354 23.108 14.2719",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask399_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 3,
    height: 5
  }, _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7227 14.4056H23.0721V18.1719H21.7227V14.4056Z",
    fill: "white"
  }))), _g388 || (_g388 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask399_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0608 14.4062C22.914 14.4424 21.966 16.6028 21.8416 16.9526C21.8416 16.9526 21.4846 17.7124 22.0284 18.0021C22.5082 18.2578 22.7394 18.1799 22.7278 18.059C22.7161 17.9393 22.128 17.7977 22.1962 17.3745C22.2641 16.952 23.2079 14.37 23.0608 14.4065",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask400_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 3,
    height: 5
  }, _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7305 14.5407H23.0292V18.1641H21.7305V14.5407Z",
    fill: "white"
  }))), _g389 || (_g389 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask400_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0137 14.5409C22.8689 14.5771 21.9675 16.6088 21.8443 16.9561C21.8443 16.9561 21.4913 17.7078 22.0286 17.9958C22.5029 18.2496 22.7289 18.1717 22.7173 18.0518C22.7059 17.9321 22.1162 17.796 22.1838 17.376C22.2507 16.9564 23.1592 14.505 23.0137 14.5406",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask401_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 2,
    height: 5
  }, _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7344 14.683H22.9824V18.1641H21.7344V14.683Z",
    fill: "white"
  }))), _g390 || (_g390 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask401_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9664 14.6835C22.8235 14.719 21.969 16.6224 21.8471 16.967C21.8471 16.967 21.4979 17.7106 22.0288 17.9971C22.4976 18.2489 22.7178 18.1717 22.7064 18.0527C22.6954 17.9344 22.1041 17.8021 22.1707 17.3847C22.2373 16.9683 23.1106 14.6479 22.9667 14.6835",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask402_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 2,
    height: 5
  }, _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7383 14.8256H22.9355V18.1641H21.7383V14.8256Z",
    fill: "white"
  }))), _g391 || (_g391 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask402_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9193 14.8258C22.7777 14.8614 21.97 16.6364 21.8498 16.9784C21.8498 16.9784 21.5045 17.7146 22.0292 17.9985C22.4922 18.2484 22.7072 18.1715 22.6959 18.0535C22.6846 17.9354 22.0923 17.8084 22.1579 17.3939C22.2232 16.9804 23.0612 14.7906 22.9193 14.8258Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask403_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 14,
    width: 2,
    height: 5
  }, _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 14.9603H22.8925V18.1562H21.7461V14.9603Z",
    fill: "white"
  }))), _g392 || (_g392 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask403_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.876 14.9608C22.7364 14.9964 21.9756 16.6423 21.8566 16.9818C21.8566 16.9818 21.5149 17.7099 22.0332 17.9918C22.4906 18.2401 22.7005 18.1635 22.6892 18.0462C22.6782 17.9291 22.0842 17.8069 22.1489 17.3953C22.2136 16.9847 23.0163 14.9256 22.876 14.9608Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask404_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7461 15.1029H22.8418V18.1562H21.7461V15.1029Z",
    fill: "white"
  }))), _g393 || (_g393 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask404_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8252 15.1033C22.6874 15.1382 21.9732 16.6558 21.8552 16.993C21.8552 16.993 21.5177 17.7134 22.0298 17.9934C22.4815 18.2397 22.6861 18.1631 22.6751 18.047C22.6642 17.931 22.0686 17.8126 22.1326 17.4043C22.1963 16.9969 22.9635 15.0684 22.8252 15.1033Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask405_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7539 15.2374H22.7988V18.1484H21.7539V15.2374Z",
    fill: "white"
  }))), _g394 || (_g394 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask405_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7818 15.238C22.646 15.2726 21.9784 16.6619 21.8623 16.9968C21.8623 16.9968 21.528 17.7088 22.0336 17.9862C22.4798 18.2312 22.679 18.1556 22.668 18.0398C22.6573 17.9244 22.0605 17.8109 22.1235 17.4058C22.1866 17.0014 22.9189 15.2034 22.7818 15.238Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask406_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7578 15.3799H22.752V18.1484H21.7578V15.3799Z",
    fill: "white"
  }))), _g395 || (_g395 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask406_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7346 15.3804C22.6001 15.415 21.9796 16.6753 21.8652 17.008C21.8652 17.008 21.5344 17.7118 22.0339 17.9876C22.4746 18.2307 22.6683 18.1554 22.6579 18.0403C22.6469 17.9262 22.0482 17.8172 22.1106 17.4147C22.173 17.0132 22.8697 15.3462 22.7346 15.3804Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask407_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7617 15.5222H22.7051V18.1484H21.7617V15.5222Z",
    fill: "white"
  }))), _g396 || (_g396 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask407_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6872 15.5229C22.5547 15.5572 21.9811 16.6894 21.8679 17.0192C21.8679 17.0192 21.5411 17.7156 22.0341 17.9891C22.4693 18.2303 22.6575 18.155 22.6471 18.0412C22.6364 17.9274 22.0361 17.8233 22.0975 17.4237C22.1596 17.0254 22.8207 15.4887 22.6872 15.5229Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask408_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7656 15.657H22.6586V18.1406H21.7656V15.657Z",
    fill: "white"
  }))), _g397 || (_g397 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask408_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6403 15.6575C22.5094 15.6915 21.9824 16.6954 21.8708 17.0225C21.8708 17.0225 21.5475 17.7112 22.0344 17.9828C22.4638 18.222 22.6468 18.147 22.6364 18.0339C22.6261 17.9207 22.0244 17.8214 22.0852 17.4247C22.146 17.0297 22.7722 15.6239 22.6403 15.6575Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask409_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7695 15.7917H22.6263V18.1328H21.7695V15.7917Z",
    fill: "white"
  }))), _g398 || (_g398 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask409_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5931 15.7924C22.4638 15.826 21.984 16.7009 21.8734 17.0261C21.8734 17.0261 21.5543 17.7064 22.0347 17.9763C22.4583 18.2136 22.6358 18.139 22.6257 18.0271C22.6154 17.9149 22.0124 17.8199 22.0726 17.4264C22.1324 17.0339 22.7231 15.7588 22.5931 15.7924Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask410_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 2,
    height: 4
  }, _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7773 15.934H22.6196V18.1328H21.7773V15.934Z",
    fill: "white"
  }))), _g399 || (_g399 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask410_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5498 15.9349C22.4221 15.9685 21.9892 16.7151 21.8803 17.0374C21.8803 17.0374 21.5647 17.7099 22.0387 17.9779C22.4567 18.213 22.629 18.1389 22.6187 18.0277C22.6087 17.9162 22.0041 17.826 22.0636 17.4354C22.1224 17.0461 22.6782 15.9013 22.5498 15.9349Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask411_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 16,
    width: 2,
    height: 3
  }, _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7773 16.0687H22.605V18.125H21.7773V16.0687Z",
    fill: "white"
  }))), _g400 || (_g400 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask411_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5027 16.0696C22.377 16.1029 21.9906 16.7208 21.883 17.0409C21.883 17.0409 21.5713 17.7053 22.0391 17.971C22.4517 18.2048 22.6185 18.1311 22.6085 18.0202C22.5984 17.9099 21.9922 17.8242 22.0508 17.4369C22.1089 17.0502 22.6295 16.0367 22.5027 16.0696Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask412_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 16,
    width: 2,
    height: 3
  }, _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7852 16.2113H22.5983V18.125H21.7852V16.2113Z",
    fill: "white"
  }))), _g401 || (_g401 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask412_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4555 16.2122C22.3314 16.2452 21.9919 16.7346 21.8859 17.0521C21.8859 17.0521 21.5777 17.7088 22.0394 17.9723C22.4462 18.2041 22.6078 18.131 22.5978 18.0211C22.5878 17.9115 21.9803 17.8303 22.0378 17.4456C22.0954 17.0625 22.5806 16.1792 22.4555 16.2122Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask413_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 16,
    width: 2,
    height: 3
  }, _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7891 16.3458H22.588V18.1172H21.7891V16.3458Z",
    fill: "white"
  }))), _g402 || (_g402 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask413_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4084 16.3469C22.2862 16.3799 21.9932 16.7407 21.8885 17.0556C21.8885 17.0556 21.5846 17.7041 22.0395 17.966C22.4407 18.1959 22.5969 18.1228 22.5872 18.0139C22.5775 17.9052 21.9683 17.8286 22.0249 17.4471C22.0818 17.0669 22.5315 16.3139 22.4084 16.3469Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask414_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 16,
    width: 2,
    height: 3
  }, _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M21.793 16.488H22.577V18.1172H21.793V16.488Z",
    fill: "white"
  }))), _g403 || (_g403 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask414_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8914 17.067C21.8914 17.067 21.5908 17.7071 22.0402 17.9674C22.4356 18.1953 22.5866 18.1226 22.5769 18.0149C22.5675 17.9069 21.9564 17.8348 22.0124 17.4562C22.0683 17.0789 22.4828 16.4569 22.3615 16.4895C22.2406 16.5219 21.9946 16.7543 21.8914 17.067Z",
    fill: "#0081C8"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask415_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4102 4.78397H22.2191V5.46875H19.4102V4.78397Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask415_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask416_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 4.79432H22.2091V5.46875H19.4219V4.79432Z",
    fill: "white"
  }))), _g404 || (_g404 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask416_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1939 5.46875C22.1939 5.46875 22.385 4.78495 21.4018 4.79432C20.7277 4.79982 19.4219 4.7982 19.4219 4.7982C19.4219 4.7982 21.214 5.09985 22.1939 5.46875Z",
    fill: "url(#paint249_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask417_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4336 4.78872H22.1985V5.45312H19.4336V4.78872Z",
    fill: "white"
  }))), _g405 || (_g405 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask417_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1853 5.45312C22.1853 5.45312 22.3673 4.77967 21.3912 4.78905C20.7045 4.79455 19.4336 4.79131 19.4336 4.79131C19.4336 4.79131 21.228 5.08423 22.1853 5.45312Z",
    fill: "url(#paint250_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask418_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4492 4.79939H22.1928V5.45312H19.4492V4.79939Z",
    fill: "white"
  }))), _g406 || (_g406 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask418_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1809 5.45312C22.1809 5.45312 22.3542 4.79034 21.3846 4.79972C20.6852 4.80521 19.4492 4.80068 19.4492 4.80068C19.4492 4.80068 21.2462 5.0839 22.1809 5.45312Z",
    fill: "url(#paint251_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask419_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4609 4.8016H22.1829V5.44531H19.4609V4.8016Z",
    fill: "white"
  }))), _g407 || (_g407 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask419_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1722 5.44531C22.1722 5.44531 22.3365 4.79288 21.3736 4.80193C20.7361 4.80504 20.0985 4.80493 19.4609 4.8016C19.4609 4.8016 21.2605 5.07577 22.1722 5.44531Z",
    fill: "url(#paint252_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask420_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4727 4.79503H22.1733V5.42969H19.4727V4.79503Z",
    fill: "white"
  }))), _g408 || (_g408 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask420_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1639 5.42969C22.1639 5.42969 22.3191 4.78792 21.3634 4.79697C20.6392 4.80279 19.4727 4.79503 19.4727 4.79503C19.4727 4.79503 21.2748 5.06014 22.1639 5.42969Z",
    fill: "url(#paint253_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask421_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4883 4.80376H22.1672V5.42969H19.4883V4.80376Z",
    fill: "white"
  }))), _g409 || (_g409 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask421_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1588 5.42969C22.1588 5.42969 22.3056 4.79827 21.3564 4.80732C20.7337 4.81009 20.111 4.8089 19.4883 4.80376C19.4883 4.80376 21.2927 5.05982 22.1588 5.42969Z",
    fill: "url(#paint254_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask422_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.80532H22.1576V5.42188H19.5V4.80532Z",
    fill: "white"
  }))), _g410 || (_g410 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask422_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1505 5.42188C22.1505 5.42188 22.2882 4.80144 21.3458 4.80985C20.597 4.81599 19.5 4.80532 19.5 4.80532C19.5 4.80532 21.307 5.05168 22.1505 5.42188Z",
    fill: "url(#paint255_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask423_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5156 4.79842H22.1519V5.40625H19.5156V4.79842Z",
    fill: "white"
  }))), _g411 || (_g411 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask423_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1461 5.40625C22.1461 5.40625 22.2744 4.79584 21.3391 4.80457C20.5777 4.81071 19.5156 4.79842 19.5156 4.79842C19.5156 4.79842 21.3249 5.03574 22.1461 5.40625Z",
    fill: "url(#paint256_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask424_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5273 4.80716H22.1426V5.40625H19.5273V4.80716Z",
    fill: "white"
  }))), _g412 || (_g412 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask424_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1374 5.40625C22.1374 5.40625 22.2571 4.80652 21.3285 4.81492C20.5548 4.82106 19.5273 4.80716 19.5273 4.80716C19.5273 4.80716 21.3392 5.03541 22.1374 5.40625Z",
    fill: "url(#paint257_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask425_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 4.80807H22.133V5.39844H19.5391V4.80807Z",
    fill: "white"
  }))), _g413 || (_g413 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask425_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1288 5.39844C22.1288 5.39844 22.2397 4.80872 21.3179 4.81745C20.5316 4.82359 19.5391 4.80807 19.5391 4.80807C19.5391 4.80807 21.3535 5.02728 22.1288 5.39844Z",
    fill: "url(#paint258_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask426_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5547 4.80182H22.1276V5.38281H19.5547V4.80182Z",
    fill: "white"
  }))), _g414 || (_g414 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask426_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1244 5.38281C22.1244 5.38281 22.2262 4.80408 21.3112 4.81249C20.5123 4.81896 19.5547 4.80182 19.5547 4.80182C19.5547 4.80182 21.3717 5.01165 22.1244 5.38281Z",
    fill: "url(#paint259_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask427_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5664 4.81055H22.1183V5.38281H19.5664V4.81055Z",
    fill: "white"
  }))), _g415 || (_g415 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask427_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1157 5.38281C22.1157 5.38281 22.2085 4.81411 21.3003 4.82252C20.4891 4.82898 19.5664 4.81055 19.5664 4.81055C19.5664 4.81055 21.3857 5.01101 22.1157 5.38281Z",
    fill: "url(#paint260_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask428_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5781 4.81179H22.1093V5.375H19.5781V4.81179Z",
    fill: "white"
  }))), _g416 || (_g416 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask428_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1074 5.375C22.1074 5.375 22.1911 4.8173 21.29 4.82538C20.4663 4.83217 19.5781 4.81179 19.5781 4.81179C19.5781 4.81179 21.4 5.00319 22.1074 5.375Z",
    fill: "url(#paint261_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask429_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5898 4.81304H22.1004V5.36719H19.5898V4.81304Z",
    fill: "white"
  }))), _g417 || (_g417 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask429_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0987 5.36719C22.0987 5.36719 22.1737 4.81983 21.2791 4.82759C20.4431 4.83438 19.5898 4.81304 19.5898 4.81304C19.5898 4.81304 21.4143 4.99506 22.0987 5.36719Z",
    fill: "url(#paint262_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask430_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6055 4.81427H22.0953V5.35938H19.6055V4.81427Z",
    fill: "white"
  }))), _g418 || (_g418 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask430_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0943 5.35938C22.0943 5.35938 22.1603 4.82268 21.2725 4.83044C20.4241 4.83756 19.6055 4.81427 19.6055 4.81427C19.6055 4.81427 21.4325 4.98724 22.0943 5.35938Z",
    fill: "url(#paint263_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask431_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6211 4.81519H22.0905V5.35156H19.6211V4.81519Z",
    fill: "white"
  }))), _g419 || (_g419 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask431_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0896 5.35156C22.0896 5.35156 22.1471 4.82522 21.2661 4.83298C20.4048 4.83977 19.6211 4.81519 19.6211 4.81519C19.6211 4.81519 21.4507 4.97911 22.0896 5.35156Z",
    fill: "url(#paint264_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask432_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6328 4.8161H22.0816V5.34375H19.6328V4.8161Z",
    fill: "white"
  }))), _g420 || (_g420 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask432_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0809 5.34375C22.0809 5.34375 22.1294 4.82774 21.2552 4.8355C20.3816 4.84261 19.6328 4.8161 19.6328 4.8161C19.6328 4.8161 21.4647 4.97097 22.0809 5.34375Z",
    fill: "url(#paint265_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask433_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6445 4.81767H22.0726V5.33594H19.6445V4.81767Z",
    fill: "white"
  }))), _g421 || (_g421 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask433_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0723 5.33594C22.0723 5.33594 22.1117 4.8306 21.2443 4.83836C20.3584 4.84548 19.6445 4.81767 19.6445 4.81767C19.6445 4.81767 21.4787 4.96284 22.0723 5.33594Z",
    fill: "url(#paint266_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask434_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 4.81858H22.0639V5.32812H19.6562V4.81858Z",
    fill: "white"
  }))), _g422 || (_g422 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask434_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0639 5.32812C22.0639 5.32812 22.0947 4.83313 21.234 4.84056C20.3355 4.848 19.6562 4.81858 19.6562 4.81858C19.6562 4.81858 21.493 4.9547 22.0639 5.32812Z",
    fill: "url(#paint267_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask435_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6719 4.81983H22.0592V5.32031H19.6719V4.81983Z",
    fill: "white"
  }))), _g423 || (_g423 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask435_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0592 5.32031C22.0592 5.32031 22.0809 4.83599 21.227 4.84343C20.3162 4.85086 19.6719 4.81983 19.6719 4.81983C19.6719 4.81983 21.5112 4.94689 22.0592 5.32031Z",
    fill: "url(#paint268_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask436_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6836 4.82074H22.0509V5.3125H19.6836V4.82074Z",
    fill: "white"
  }))), _g424 || (_g424 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask436_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0509 5.3125C22.0509 5.3125 22.0635 4.83853 21.2164 4.84564C20.7053 4.85163 20.1942 4.84332 19.6836 4.82074C19.6836 4.82074 21.5255 4.93875 22.0509 5.3125Z",
    fill: "url(#paint269_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask437_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6953 4.82231H22.0422V5.30469H19.6953V4.82231Z",
    fill: "white"
  }))), _g425 || (_g425 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask437_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0422 5.30469C22.0422 5.30469 22.0461 4.84138 21.2058 4.84849C20.2698 4.85625 19.6953 4.82231 19.6953 4.82231C19.6953 4.82231 21.5395 4.93094 22.0422 5.30469Z",
    fill: "url(#paint270_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask438_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7109 4.82323H22.0375V5.29688H19.7109V4.82323Z",
    fill: "white"
  }))), _g426 || (_g426 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask438_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0375 5.29688C22.0375 5.29688 22.0326 4.84392 21.1991 4.85103C20.2509 4.85879 19.7109 4.82323 19.7109 4.82323C19.7109 4.82323 21.5577 4.92248 22.0375 5.29688Z",
    fill: "url(#paint271_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask439_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7227 4.82414H22.0292V5.28906H19.7227V4.82414Z",
    fill: "white"
  }))), _g427 || (_g427 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask439_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0292 5.28906C22.0292 5.28906 22.0149 4.84645 21.1885 4.85356C20.2277 4.86132 19.7227 4.82414 19.7227 4.82414C19.7227 4.82414 21.5717 4.91435 22.0292 5.28906Z",
    fill: "url(#paint272_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask440_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7383 4.82506H22.0247V5.28125H19.7383V4.82506Z",
    fill: "white"
  }))), _g428 || (_g428 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask440_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0247 5.28125C22.0247 5.28125 22.0015 4.84898 21.1819 4.8561C20.2087 4.86386 19.7383 4.82506 19.7383 4.82506C19.7383 4.82506 21.5902 4.90621 22.0247 5.28125Z",
    fill: "url(#paint273_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask441_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 4.8263H22.0158V5.27344H19.75V4.8263Z",
    fill: "white"
  }))), _g429 || (_g429 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask441_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0158 5.27344C22.0158 5.27344 21.9841 4.85183 21.1709 4.85862C20.1855 4.86671 19.75 4.8263 19.75 4.8263C19.75 4.8263 21.6042 4.8984 22.0158 5.27344Z",
    fill: "url(#paint274_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask442_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7617 4.82754H22.0074V5.26562H19.7617V4.82754Z",
    fill: "white"
  }))), _g430 || (_g430 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask442_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0074 5.26562C22.0074 5.26562 21.9667 4.85437 21.1607 4.86116C20.1626 4.86924 19.7617 4.82754 19.7617 4.82754C19.7617 4.82754 21.6185 4.89026 22.0074 5.26562Z",
    fill: "url(#paint275_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask443_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 4,
    height: 2
  }, _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7773 4.82877H22.0027V5.25781H19.7773V4.82877Z",
    fill: "white"
  }))), _g431 || (_g431 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask443_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0027 5.25781C22.0027 5.25781 21.9529 4.85722 21.1537 4.86369C20.1433 4.8721 19.7773 4.82877 19.7773 4.82877C19.7773 4.82877 21.6364 4.88245 22.0027 5.25781Z",
    fill: "url(#paint276_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask444_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 3,
    height: 2
  }, _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7891 4.83751H21.9944V5.25781H19.7891V4.83751Z",
    fill: "white"
  }))), _g432 || (_g432 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask444_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9944 5.25781C21.9944 5.25781 21.9358 4.86757 21.1431 4.87404C20.1201 4.88245 19.7891 4.83751 19.7891 4.83751C19.7891 4.83751 21.651 4.8818 21.9944 5.25781Z",
    fill: "url(#paint277_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask445_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 3,
    height: 2
  }, _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8047 4.83095H21.9896V5.24219H19.8047V4.83095Z",
    fill: "white"
  }))), _g433 || (_g433 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask445_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9896 5.24219C21.9896 5.24219 21.922 4.86262 21.1364 4.86909C20.1008 4.8775 19.8047 4.83095 19.8047 4.83095C19.8047 4.83095 21.6689 4.86618 21.9896 5.24219Z",
    fill: "url(#paint278_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask446_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 3,
    height: 2
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 4.83217H21.9774V5.23438H19.8125V4.83217Z",
    fill: "white"
  }))), _g434 || (_g434 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask446_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9774 5.23438C21.9774 5.23438 21.9008 4.86515 21.1219 4.87162C20.0741 4.88002 19.8125 4.83217 19.8125 4.83217C19.8125 4.83217 21.6793 4.85804 21.9774 5.23438Z",
    fill: "url(#paint279_linear_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask447_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 8
  }, _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6445 9.57285H24.4163V16.0391H17.6445V9.57285Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask447_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask448_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 7
  }, _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M17.707 9.6067H24.3769V15.9297H17.707V9.6067Z",
    fill: "white"
  }))), _g435 || (_g435 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask448_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2381 11.1655C18.2216 13.1002 17.6826 15.9576 17.7079 15.9295C17.7244 15.9111 18.4705 13.9689 19.8042 12.5224C21.1556 11.065 22.6642 10.2467 23.2846 10.8293C23.5646 11.0918 23.445 11.6841 23.4463 11.688C23.4463 11.688 24.7712 10.4135 24.2591 9.96311C23.7483 9.51338 22.3548 9.13414 20.2381 11.1655Z",
    fill: "url(#paint280_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask449_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 7
  }, _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7656 9.63991H24.335V15.8203H17.7656V9.63991Z",
    fill: "white"
  }))), _g436 || (_g436 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask449_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.065
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1789 11.2517C18.24 13.1331 17.7182 15.8754 17.7689 15.8195C17.8016 15.7829 18.5378 13.8828 19.8485 12.4797C21.1863 11.0468 22.671 10.2559 23.2823 10.8305C23.5552 11.0872 23.4414 11.6627 23.4443 11.6704C23.4443 11.6704 24.7321 10.4105 24.2102 9.97563C23.6897 9.54142 22.3176 9.17706 20.1789 11.2517Z",
    fill: "url(#paint281_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask450_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 7
  }, _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8242 9.6715H24.2946V15.7109H17.8242V9.6715Z",
    fill: "white"
  }))), _g437 || (_g437 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask450_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.097
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1215 11.3378C18.2592 13.1639 17.7555 15.793 17.8315 15.709C17.8806 15.6543 18.609 13.7985 19.8942 12.4361C21.2207 11.03 22.6798 10.2647 23.2818 10.8315C23.5476 11.0818 23.44 11.6411 23.4442 11.6524C23.4442 11.6524 24.695 10.4067 24.1632 9.98767C23.633 9.56898 22.2819 9.21916 20.1215 11.3378Z",
    fill: "url(#paint282_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask451_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 7
  }, _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8828 9.70994H24.2569V15.6094H17.8828V9.70994Z",
    fill: "white"
  }))), _g438 || (_g438 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask451_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.129
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0653 11.4315C18.2787 13.2016 17.794 15.7182 17.8956 15.6057C17.9612 15.533 18.6815 13.7218 19.9418 12.4001C21.2564 11.0209 22.6896 10.2815 23.2822 10.8401C23.5415 11.0839 23.4394 11.6267 23.4452 11.6419C23.4452 11.6419 24.6589 10.4108 24.1177 10.007C23.5774 9.60412 22.2476 9.26884 20.0653 11.4315Z",
    fill: "url(#paint283_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask452_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 7
  }, _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 9.7399H24.2165V15.5H17.9375V9.7399Z",
    fill: "white"
  }))), _g439 || (_g439 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask452_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.161
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0072 11.5161C18.2952 13.2296 17.8306 15.6347 17.957 15.4941C18.0392 15.4033 18.7521 13.6364 19.9868 12.3554C21.2901 11.003 22.6971 10.2891 23.2803 10.8401C23.5329 11.0777 23.4368 11.6037 23.4439 11.6228C23.4439 11.6228 24.6208 10.4062 24.0696 10.0179C23.5196 9.63055 22.2115 9.3095 20.0072 11.5161Z",
    fill: "url(#paint284_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask453_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 9,
    width: 8,
    height: 7
  }, _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9922 9.76825H24.1781V15.3906H17.9922V9.76825Z",
    fill: "white"
  }))), _g440 || (_g440 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask453_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.194
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.95 11.6004C18.3121 13.2557 17.8682 15.5506 18.0201 15.3818C18.1184 15.2729 18.8235 13.5506 20.033 12.3101C21.3253 10.9848 22.7058 10.2962 23.28 10.8393C23.5254 11.0705 23.4352 11.5803 23.444 11.6027C23.444 11.6027 24.5836 10.4006 24.0227 10.0281C23.4631 9.65632 22.1769 9.34917 19.95 11.6004Z",
    fill: "url(#paint285_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask454_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 7
  }, _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0469 9.80281H24.1416V15.2891H18.0469V9.80281Z",
    fill: "white"
  }))), _g441 || (_g441 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask454_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.226
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8944 11.6915C18.3296 13.2883 17.9074 15.4732 18.0846 15.2767C18.1993 15.1493 18.8974 13.472 20.0807 12.2722C21.3619 10.9734 22.7166 10.3103 23.2811 10.8454C23.5197 11.0707 23.4357 11.5638 23.4457 11.5903C23.4457 11.5903 24.5485 10.4025 23.9775 10.0455C23.4082 9.68923 22.1437 9.39599 19.8944 11.6915Z",
    fill: "url(#paint286_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask455_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 7
  }, _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0977 9.83639H24.1035V15.1875H18.0977V9.83639Z",
    fill: "white"
  }))), _g442 || (_g442 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask455_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.258
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8363 11.7821C18.3439 13.3191 17.944 15.3954 18.1467 15.1707C18.2779 15.0249 18.9682 13.3925 20.126 12.2331C21.3963 10.9615 22.7244 10.3236 23.2799 10.8513C23.5114 11.0698 23.4331 11.5464 23.4448 11.5765C23.4448 11.5765 24.5107 10.4032 23.9301 10.0621C23.3504 9.72162 22.1085 9.44195 19.8363 11.7821Z",
    fill: "url(#paint287_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask456_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 7
  }, _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1484 9.86835H24.067V15.0859H18.1484V9.86835Z",
    fill: "white"
  }))), _g443 || (_g443 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask456_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7799 11.8718C18.3589 13.3483 17.9823 15.3167 18.2102 15.0638C18.358 14.8999 19.0411 13.3125 20.173 12.1932C21.4323 10.9484 22.734 10.3364 23.28 10.8556C23.5051 11.068 23.4326 11.5284 23.4456 11.5624C23.4456 11.5624 24.4747 10.4033 23.884 10.0777C23.2949 9.75248 22.0747 9.48704 19.7799 11.8718Z",
    fill: "url(#paint288_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask457_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 6
  }, _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1953 9.89934H24.0285V14.9844H18.1953V9.89934Z",
    fill: "white"
  }))), _g444 || (_g444 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask457_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.323
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7209 11.9604C18.3708 13.3759 18.0181 15.2372 18.2715 14.9559C18.4355 14.7742 19.1122 13.2314 20.2176 12.1528C21.4659 10.9349 22.74 10.3494 23.2777 10.8596C23.4956 11.0661 23.4296 11.5094 23.4439 11.5469C23.4439 11.5469 24.4358 10.4027 23.8354 10.0927C23.2363 9.78326 22.0388 9.53075 19.7209 11.9604Z",
    fill: "url(#paint289_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask458_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 6,
    height: 6
  }, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2461 9.92776H23.9965V14.8828H18.2461V9.92776Z",
    fill: "white"
  }))), _g445 || (_g445 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask458_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.668 12.048C18.3877 13.4014 18.0596 15.1563 18.3383 14.8469C18.519 14.6468 19.1886 13.1492 20.2678 12.1107C21.5054 10.92 22.7527 10.3597 23.2814 10.8621C23.4922 11.0626 23.432 11.489 23.4479 11.5304C23.4479 11.5304 24.4029 10.4004 23.7928 10.1062C23.184 9.81201 22.0088 9.5734 19.668 12.048Z",
    fill: "url(#paint290_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask459_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 6,
    height: 6
  }, _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 9.95487H23.9586V14.7812H18.2891V9.95487Z",
    fill: "white"
  }))), _g446 || (_g446 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask459_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.387
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6085 12.1341C18.3973 13.4251 18.0951 15.074 18.399 14.7368C18.5959 14.5185 19.2587 13.0662 20.3117 12.0675C21.5386 10.9039 22.7591 10.3692 23.2784 10.8635C23.4824 11.0575 23.4284 11.4674 23.4455 11.513C23.4455 11.513 24.3634 10.3973 23.7436 10.1186C23.1248 9.84022 21.9722 9.61454 19.6085 12.1341Z",
    fill: "url(#paint291_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask460_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 6,
    height: 6
  }, _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 9.97972H23.9234V14.6797H18.332V9.97972Z",
    fill: "white"
  }))), _g447 || (_g447 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask460_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.419
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.551 12.219C18.4084 13.4463 18.1323 14.9905 18.4614 14.6251C18.6748 14.3885 19.3311 12.9817 20.3576 12.0231C21.5743 10.8867 22.7676 10.3768 23.2778 10.8634C23.4747 11.0513 23.4265 11.4444 23.4453 11.4935C23.4453 11.4935 24.3263 10.3927 23.6968 10.1295C23.068 9.86665 21.938 9.6539 19.551 12.219Z",
    fill: "url(#paint292_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask461_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.0104H23.8907V14.5859H18.375V10.0104Z",
    fill: "white"
  }))), _g448 || (_g448 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask461_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.452
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4952 12.3099C18.4209 13.4735 18.1713 14.9132 18.526 14.5197C18.7558 14.2649 19.4057 12.9035 20.4054 11.9846C21.612 10.8754 22.7778 10.3907 23.2786 10.8692C23.469 11.0509 23.4267 11.4279 23.4467 11.4809C23.4467 11.4809 24.2906 10.3939 23.6514 10.1466C23.0129 9.89928 21.9058 9.69948 19.4952 12.3099Z",
    fill: "url(#paint293_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask462_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 10.0392H23.8567V14.4922H18.4141V10.0392Z",
    fill: "white"
  }))), _g449 || (_g449 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask462_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.484
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4377 12.3992C18.4306 13.4979 18.2085 14.8341 18.5887 14.4125C18.8347 14.1393 19.4788 12.8238 20.4513 11.9443C21.6475 10.8629 22.7862 10.4031 23.278 10.8735C23.461 11.0491 23.4251 11.4093 23.4464 11.4658C23.4464 11.4658 24.2534 10.3938 23.6042 10.1619C22.956 9.93013 21.8719 9.74325 19.4377 12.3992Z",
    fill: "url(#paint294_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask463_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4492 10.0651H23.822V14.3984H18.4492V10.0651Z",
    fill: "white"
  }))), _g450 || (_g450 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask463_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.516
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3785 12.4862C18.4383 13.5198 18.244 14.7529 18.6495 14.3032C18.912 14.0119 19.5502 12.7419 20.4956 11.902C21.6818 10.8483 22.793 10.4135 23.2754 10.8758C23.4519 11.0449 23.4215 11.3886 23.4445 11.449C23.4445 11.449 24.2146 10.3915 23.5557 10.1752C22.8974 9.95889 21.8363 9.78463 19.3785 12.4862Z",
    fill: "url(#paint295_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask464_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4844 10.0881H23.7902V14.3047H18.4844V10.0881Z",
    fill: "white"
  }))), _g451 || (_g451 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask464_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3218 12.5714C18.4475 13.5394 18.282 14.6694 18.7126 14.1915C18.9913 13.8821 19.6237 12.6584 20.5419 11.8578C21.7185 10.8317 22.8019 10.4214 23.2752 10.876C23.4446 11.0386 23.42 11.3658 23.4446 11.4301C23.4446 11.4301 24.1779 10.3871 23.509 10.186C22.841 9.98556 21.8032 9.8239 19.3218 12.5714Z",
    fill: "url(#paint296_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask465_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5156 10.1153H23.7581V14.2188H18.5156V10.1153Z",
    fill: "white"
  }))), _g452 || (_g452 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask465_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.581
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2636 12.6611C18.455 13.5628 18.3185 14.5909 18.7744 14.0849C19.0699 13.7574 19.6968 12.5799 20.5872 11.8182C21.7543 10.8201 22.8096 10.4341 23.2736 10.8809C23.4362 11.0374 23.4178 11.3481 23.4436 11.416C23.4436 11.416 24.1397 10.3872 23.4611 10.202C22.7834 10.017 21.7689 9.86798 19.2636 12.6611Z",
    fill: "url(#paint297_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask466_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5469 10.139H23.7299V14.1328H18.5469V10.139Z",
    fill: "white"
  }))), _g453 || (_g453 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask466_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2081 12.7479C18.4645 13.5823 18.3578 14.5093 18.8389 13.9752C19.1509 13.6292 19.7723 12.4983 20.6352 11.7753C21.793 10.8054 22.8202 10.4436 23.2751 10.8824C23.4309 11.0327 23.418 11.3269 23.4454 11.3987C23.4454 11.3987 24.1047 10.3845 23.4163 10.2147C22.7287 10.0453 21.7374 9.90887 19.2081 12.7479Z",
    fill: "url(#paint298_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask467_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 5
  }, _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5742 10.1584H23.7013V14.0469H18.5742V10.1584Z",
    fill: "white"
  }))), _g454 || (_g454 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask467_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.645
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1517 12.8309C18.4727 13.5981 18.3961 14.4238 18.9027 13.8616C19.2309 13.4976 19.8474 12.4132 20.6822 11.729C21.8306 10.7872 22.8297 10.4497 23.2752 10.8804C23.4242 11.0242 23.4174 11.302 23.4462 11.3776C23.4462 11.3776 24.0683 10.3776 23.3702 10.2237C22.6725 10.0701 21.7045 9.94566 19.1517 12.8309Z",
    fill: "url(#paint299_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask468_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5977 10.1883H23.6736V13.9766H18.5977V10.1883Z",
    fill: "white"
  }))), _g455 || (_g455 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask468_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0945 12.9248C18.4796 13.6245 18.434 14.3497 18.9658 13.7593C19.3102 13.3768 19.9219 12.3396 20.7285 11.6937C21.8685 10.7806 22.8388 10.4667 23.2749 10.8896C23.4169 11.0273 23.4162 11.2886 23.4463 11.3678C23.4463 11.3678 24.0315 10.3823 23.3237 10.2439C22.6163 10.1059 21.6716 9.99369 19.0945 12.9248Z",
    fill: "url(#paint300_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask469_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6172 10.2046H23.6466V13.8984H18.6172V10.2046Z",
    fill: "white"
  }))), _g456 || (_g456 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask469_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0373 13.0063C18.4858 13.6377 18.4715 14.2623 19.0286 13.6438C19.3897 13.2436 19.9966 12.2533 20.7748 11.6455C21.9061 10.7618 22.8472 10.4712 23.2743 10.886C23.4095 11.0173 23.4146 11.262 23.4463 11.3451C23.4463 11.3451 23.9943 10.3742 23.2769 10.2513C22.5595 10.1288 21.6387 10.0286 19.0373 13.0063Z",
    fill: "url(#paint301_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask470_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 10.2301H23.6166V13.8359H18.6289V10.2301Z",
    fill: "white"
  }))), _g457 || (_g457 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask470_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.742
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9763 13.0964C18.4877 13.6593 18.5052 14.1843 19.0878 13.538C19.4651 13.1194 20.0674 12.1766 20.8172 11.6063C21.9404 10.7521 22.8524 10.4844 23.2698 10.8914C23.3985 11.0165 23.4095 11.2445 23.4425 11.3314C23.4425 11.3314 23.9536 10.3748 23.2262 10.2677C22.4991 10.1607 21.6019 10.0728 18.9763 13.0964Z",
    fill: "url(#paint302_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask471_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6406 10.2546H23.5934V13.7812H18.6406V10.2546Z",
    fill: "white"
  }))), _g458 || (_g458 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask471_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.774
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9198 13.1872C18.4937 13.6809 18.5435 14.1067 19.1513 13.432C19.5451 12.9952 20.1432 12.1002 20.8642 11.5678C21.9796 10.7433 22.8619 10.4979 23.2703 10.8972C23.3918 11.0159 23.409 11.2276 23.4432 11.3182C23.4432 11.3182 23.9175 10.376 23.1801 10.2845C22.4432 10.193 21.57 10.1174 18.9198 13.1872Z",
    fill: "url(#paint303_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask472_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 10.2694H23.5721V13.7266H18.6484V10.2694Z",
    fill: "white"
  }))), _g459 || (_g459 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask472_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.806
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8644 13.2686C18.5004 13.6928 18.5828 14.0197 19.2162 13.3168C19.6262 12.8616 20.2204 12.0148 20.912 11.5195C22.0203 10.7258 22.8725 10.5024 23.2715 10.8936C23.3863 11.0058 23.4092 11.201 23.4451 11.2955C23.4451 11.2955 23.8822 10.3679 23.1354 10.2919C22.3885 10.2159 21.5389 10.1522 18.8644 13.2686Z",
    fill: "url(#paint304_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask473_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 10.2951H23.5505V13.6953H18.6484V10.2951Z",
    fill: "white"
  }))), _g460 || (_g460 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask473_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.839
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8071 13.3618C18.5048 13.7161 18.6199 13.9447 19.2785 13.2137C19.7052 12.7404 20.2956 11.9421 20.9581 11.4834C22.0589 10.721 22.8811 10.5183 23.2707 10.9017C23.3784 11.0081 23.4072 11.1866 23.4447 11.2848C23.4447 11.2848 23.8449 10.3715 23.088 10.3114C22.3315 10.2509 21.5058 10.1988 18.8071 13.3618Z",
    fill: "url(#paint305_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask474_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6406 10.314H23.5294V13.6719H18.6406V10.314Z",
    fill: "white"
  }))), _g461 || (_g461 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask474_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.871
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7486 13.4488C18.5074 13.733 18.6561 13.863 19.3402 13.1042C19.7831 12.6127 20.37 11.863 21.003 11.4407C22.0974 10.7107 22.8889 10.528 23.2687 10.9037C23.3699 11.0036 23.4045 11.1659 23.4433 11.2678C23.4433 11.2678 23.8064 10.369 23.0398 10.3244C22.2736 10.2794 21.4721 10.2393 18.7486 13.4488Z",
    fill: "url(#paint306_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask475_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 10.3294H23.5135V13.6641H18.6289V10.3294Z",
    fill: "white"
  }))), _g462 || (_g462 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask475_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.903
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6936 13.5336C18.5136 13.7473 18.6962 13.7796 19.4052 12.9923C19.8647 12.4828 20.4479 11.7828 21.0515 11.3965C22.1401 10.6994 22.8996 10.5362 23.2704 10.9038C23.3648 10.9972 23.4052 11.143 23.4457 11.2487C23.4457 11.2487 23.7719 10.3641 22.9956 10.3351C22.2193 10.306 21.4411 10.2772 18.6936 13.5336Z",
    fill: "url(#paint307_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask476_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6055 10.3535H23.4978V13.6875H18.6055V10.3535Z",
    fill: "white"
  }))), _g463 || (_g463 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask476_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.935
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6364 13.6278C18.5168 13.7707 18.7337 13.7054 19.4683 12.89C19.9439 12.3623 20.5242 11.7118 21.0974 11.3611C22.1809 10.6983 22.9086 10.5528 23.2701 10.9129C23.3574 10.9999 23.4039 11.1292 23.4456 11.2388C23.4456 11.2388 23.735 10.3688 22.9487 10.3552C22.1627 10.342 21.4085 10.3245 18.6364 13.6278Z",
    fill: "url(#paint308_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask477_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5703 10.3651H23.4833V13.7266H18.5703V10.3651Z",
    fill: "white"
  }))), _g464 || (_g464 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask477_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.968
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5787 13.7115C18.5192 13.783 18.7707 13.6204 19.5308 12.7772C20.0229 12.2314 20.5997 11.6313 21.1432 11.3155C22.2217 10.6886 22.9172 10.5592 23.2693 10.9117C23.3501 10.9925 23.4021 11.105 23.4451 11.2185C23.4451 11.2185 23.6973 10.363 22.9013 10.3649C22.1057 10.3669 21.3756 10.3614 18.5787 13.7115Z",
    fill: "url(#paint309_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask478_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 10,
    width: 6,
    height: 4
  }, _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 10.3763H23.4733V13.7969H18.5234V10.3763Z",
    fill: "white"
  }))), _g465 || (_g465 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask478_10834_56546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 13.7969C18.5234 13.7969 18.8102 13.5376 19.5955 12.6663C20.1041 12.1021 20.678 11.5534 21.1914 11.2715C22.2664 10.6831 22.9295 10.566 23.2706 10.912C23.345 10.9863 23.4025 11.083 23.4471 11.2001C23.4471 11.2001 23.6625 10.3588 22.8568 10.3766C22.0511 10.3944 20.923 10.0898 18.5234 13.7969Z",
    fill: "url(#paint310_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask479_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2188 8.84553H25.2255V13.3438H18.2188V8.84553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask479_10834_56546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask480_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2539 8.92922H25.2041V13.2891H18.2539V8.92922Z",
    fill: "white"
  }))), _g466 || (_g466 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask480_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.011
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7723 9.07391C24.7723 9.07391 23.7677 8.67235 21.9404 9.48904C21.0927 9.86828 20.7137 10.1799 20.2663 10.4767C19.7493 10.8198 21.308 7.06291 19.3668 10.1664C19.2566 10.3423 17.1577 14.7661 19.0238 12.7752C19.566 12.1974 21.5641 10.4186 22.5902 10.0839C23.1282 9.90675 24.2424 9.64002 24.7671 9.67332C25.478 9.71923 25.2042 9.16055 24.7723 9.07391Z",
    fill: "url(#paint311_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask481_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2891 8.97863H25.183V13.2344H18.2891V8.97863Z",
    fill: "white"
  }))), _g467 || (_g467 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask481_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.021
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7556 9.073C24.7556 9.073 23.7494 8.68211 21.9392 9.49168C21.0954 9.86898 20.7055 10.1907 20.2573 10.4884C19.7433 10.8292 21.2415 7.20781 19.3653 10.2104C19.2561 10.385 17.2237 14.6695 19.042 12.7329C19.581 12.1616 21.5616 10.4096 22.5761 10.0727C23.1219 9.89129 24.225 9.63006 24.7452 9.66336C25.4494 9.70862 25.1914 9.15868 24.7556 9.073Z",
    fill: "url(#paint312_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask482_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3203 8.98344H25.1596V13.1797H18.3203V8.98344Z",
    fill: "white"
  }))), _g468 || (_g468 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask482_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.032
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7367 9.07347C24.7367 9.07347 23.7293 8.69325 21.9356 9.49571C21.0963 9.87107 20.6954 10.2031 20.2463 10.5012C19.7351 10.8397 21.1735 7.35442 19.3617 10.2558C19.2534 10.4288 17.2835 14.571 19.0584 12.6916C19.5925 12.1262 21.5566 10.401 22.5602 10.0628C23.1131 9.87657 24.2055 9.62148 24.7209 9.65445C25.4186 9.69939 25.1768 9.15785 24.7367 9.07347Z",
    fill: "url(#paint313_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask483_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3555 8.98727H25.1392V13.125H18.3555V8.98727Z",
    fill: "white"
  }))), _g469 || (_g469 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask483_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.043
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7204 9.07291C24.7204 9.07291 23.7117 8.70369 21.9351 9.49871C21.1 9.87213 20.6877 10.2145 20.238 10.5129C19.7298 10.8498 21.1032 7.49677 19.3606 10.3002C19.2532 10.4715 17.3489 14.4738 19.0773 12.6497C19.6076 12.09 21.5539 10.391 22.5468 10.0519C23.1068 9.86049 24.1889 9.61219 24.6994 9.64484C25.3906 9.68914 25.1646 9.15633 24.7204 9.07291Z",
    fill: "url(#paint314_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask484_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 8.9911H25.1187V13.0703H18.3906V8.9911Z",
    fill: "white"
  }))), _g470 || (_g470 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask484_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.053
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7045 9.07262C24.7045 9.07262 23.6945 8.71406 21.9347 9.50165C21.1035 9.87378 20.6803 10.2259 20.2299 10.5249C19.7249 10.8599 21.0391 7.64326 19.3595 10.3448C19.2535 10.5149 17.4142 14.3765 19.0964 12.6077C19.6227 12.0545 21.5516 10.3811 22.5335 10.0413C23.1009 9.84468 24.1727 9.60284 24.6783 9.63517C25.3628 9.67914 25.1526 9.15474 24.7045 9.07262Z",
    fill: "url(#paint315_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask485_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 8,
    height: 6
  }, _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4258 8.99494H25.0983V13.0156H18.4258V8.99494Z",
    fill: "white"
  }))), _g471 || (_g471 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask485_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.064
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.688 9.0721C24.688 9.0721 23.6767 8.72421 21.9338 9.50468C21.1071 9.87487 20.6722 10.2373 20.2215 10.5367C19.7194 10.8697 20.9748 7.7892 19.3586 10.3893C19.2535 10.5577 17.4795 14.2797 19.1155 12.5655C19.6376 12.0184 21.549 10.3705 22.5199 10.0301C23.0945 9.82864 24.1559 9.59359 24.6567 9.6256C25.3347 9.66892 25.1404 9.15325 24.688 9.0721Z",
    fill: "url(#paint316_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask486_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 8,
    height: 4
  }, _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M18.457 8.99877H25.0742V12.9609H18.457V8.99877Z",
    fill: "white"
  }))), _g472 || (_g472 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask486_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.075
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6678 9.07165C24.6678 9.07165 23.6555 8.73476 21.9294 9.5078C21.1069 9.87605 20.661 10.2488 20.2094 10.5485C19.7102 10.8796 20.9068 7.93553 19.3539 10.4338C19.2498 10.6009 17.5411 14.1825 19.1305 12.5233C19.6488 11.9827 21.5427 10.3604 22.5029 10.0193C23.0846 9.813 24.1353 9.5841 24.6313 9.61578C25.3031 9.6591 25.1243 9.15183 24.6678 9.07165Z",
    fill: "url(#paint317_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask487_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 8,
    height: 4
  }, _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4922 9.00227H25.0544V12.9062H18.4922V9.00227Z",
    fill: "white"
  }))), _g473 || (_g473 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask487_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.085
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6519 9.07104C24.6519 9.07104 23.6383 8.74482 21.929 9.51074C21.1107 9.87737 20.6535 10.2599 20.2012 10.5605C19.7049 10.8893 20.8426 8.08171 19.3528 10.4784C19.25 10.6436 17.6066 14.0853 19.1495 12.4813C19.6638 11.9469 21.54 10.3501 22.4896 10.0086C23.0786 9.79655 24.1191 9.57443 24.6102 9.6058C25.2752 9.6488 25.1123 9.14993 24.6519 9.07104Z",
    fill: "url(#paint318_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask488_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 8,
    height: 4
  }, _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5234 9.00546H25.0301V12.8516H18.5234V9.00546Z",
    fill: "white"
  }))), _g474 || (_g474 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask488_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.096
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6314 9.07045C24.6314 9.07045 23.6169 8.7549 21.924 9.51371C21.1102 9.87841 20.6418 10.2712 20.1888 10.5722C19.6954 10.8991 20.7743 8.22758 19.3479 10.5228C19.2464 10.6867 17.6683 13.9883 19.1646 12.439C19.6747 11.9107 21.5338 10.3391 22.4723 9.99738C23.0682 9.78044 24.0983 9.56511 24.5845 9.59615C25.2431 9.6385 25.096 9.14837 24.6314 9.07045Z",
    fill: "url(#paint319_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask489_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 8,
    height: 4
  }, _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5586 9.01647H25.0099V12.8047H18.5586V9.01647Z",
    fill: "white"
  }))), _g475 || (_g475 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask489_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.106
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6155 9.0775C24.6155 9.0775 23.5994 8.77261 21.9237 9.52398C21.1138 9.88706 20.6343 10.2902 20.1807 10.5916C19.6906 10.9168 20.71 8.3814 19.3469 10.5747C19.2467 10.737 17.7339 13.899 19.1836 12.4047C19.6899 11.8825 21.5312 10.3361 22.4591 9.99408C23.062 9.77197 24.0818 9.5631 24.5632 9.59382C25.2153 9.63585 25.084 9.15412 24.6155 9.0775Z",
    fill: "url(#paint320_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask490_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5938 9.01965H24.9898V12.75H18.5938V9.01965Z",
    fill: "white"
  }))), _g476 || (_g476 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask490_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.117
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.599 9.07685C24.599 9.07685 23.5819 8.78264 21.9227 9.5269C21.1173 9.88804 20.6265 10.3015 20.1723 10.6032C19.685 10.9265 20.6456 8.52722 19.3459 10.619C19.2466 10.78 17.7998 13.802 19.2026 12.3623C19.7051 11.8466 21.5282 10.3251 22.4454 9.98308C23.0558 9.75547 24.0649 9.55373 24.5418 9.5838C25.1871 9.62551 25.0717 9.1525 24.599 9.07685Z",
    fill: "url(#paint321_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask491_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6289 9.02283H24.97V12.6953H18.6289V9.02283Z",
    fill: "white"
  }))), _g477 || (_g477 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask491_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.128
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5831 9.07608C24.5831 9.07608 23.5644 8.79286 21.9223 9.52968C21.1211 9.8892 20.619 10.3124 20.1641 10.6147C19.6798 10.9361 20.5818 8.67324 19.3448 10.6632C19.2469 10.8226 17.8657 13.7052 19.2217 12.3199C19.7202 11.8106 21.5256 10.314 22.4321 9.97197C23.0496 9.73887 24.0483 9.54391 24.5204 9.57397C25.1592 9.61503 25.0597 9.15077 24.5831 9.07608Z",
    fill: "url(#paint322_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask492_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6641 9.02537H24.9502V12.6406H18.6641V9.02537Z",
    fill: "white"
  }))), _g478 || (_g478 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask492_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.138
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5669 9.07528C24.5669 9.07528 23.5471 8.80273 21.9219 9.53244C21.1246 9.89002 20.6115 10.3236 20.1559 10.6262C19.6745 10.9456 20.5135 8.81663 19.3441 10.7074C19.2468 10.8651 17.9319 13.6084 19.2406 12.2773C19.7353 11.7746 21.5232 10.3029 22.4191 9.96082C23.0437 9.72222 24.0321 9.53405 24.499 9.5638C25.1314 9.60453 25.0479 9.14867 24.5669 9.07528Z",
    fill: "url(#paint323_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask493_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6953 9.02823H24.9268V12.5859H18.6953V9.02823Z",
    fill: "white"
  }))), _g479 || (_g479 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask493_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.149
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.547 9.07432C24.547 9.07432 23.5257 8.81275 21.9172 9.5347C21.1244 9.89067 20.6003 10.3346 20.1438 10.6378C19.6653 10.955 20.4448 8.9618 19.3394 10.7516C19.2428 10.9075 17.9941 13.5117 19.256 12.2347C19.7465 11.7384 21.5166 10.2913 22.4018 9.94952C23.0336 9.70542 24.0116 9.52436 24.4739 9.55379C25.0995 9.5942 25.032 9.14674 24.547 9.07432Z",
    fill: "url(#paint324_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask494_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7305 9.03044H24.907V12.5312H18.7305V9.03044Z",
    fill: "white"
  }))), _g480 || (_g480 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask494_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5307 9.07326C24.5307 9.07326 23.5084 8.82237 21.9167 9.53721C21.1282 9.89156 20.5928 10.3452 20.1356 10.6491C19.66 10.9643 20.3804 9.10753 19.3383 10.7955C19.243 10.9498 18.0606 13.4147 19.275 12.1922C19.7619 11.7021 21.5139 10.2795 22.3884 9.93779C23.0276 9.68852 23.995 9.51425 24.4524 9.54335C25.0716 9.58344 25.0199 9.14439 24.5307 9.07326Z",
    fill: "url(#paint325_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask495_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7656 9.03298H24.8878V12.4766H18.7656V9.03298Z",
    fill: "white"
  }))), _g481 || (_g481 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask495_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5143 9.07206C24.5143 9.07206 23.491 8.83183 21.9162 9.53956C21.1318 9.89197 20.5848 10.3559 20.127 10.6602C19.6546 10.9734 20.3151 9.25214 19.3375 10.8393C19.2434 10.9922 18.127 13.3181 19.2941 12.1493C19.7772 11.6656 21.5111 10.2677 22.3753 9.92624C23.0209 9.67115 23.9786 9.50432 24.4309 9.53277C25.0436 9.57222 25.0077 9.14222 24.5143 9.07206Z",
    fill: "url(#paint326_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask496_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 9.04268H24.8644V12.4297H18.7969V9.04268Z",
    fill: "white"
  }))), _g482 || (_g482 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask496_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.181
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4945 9.07846C24.4945 9.07846 23.47 8.84891 21.9119 9.54952C21.1318 9.89999 20.5738 10.3743 20.1153 10.6788C19.6455 10.9905 20.2472 9.40532 19.3326 10.8909C19.2395 11.0419 18.19 13.2291 19.3093 12.1143C19.7888 11.6368 21.5042 10.2634 22.3581 9.92229C23.0109 9.66138 23.9582 9.50167 24.406 9.53012C25.0122 9.56924 24.9918 9.14764 24.4945 9.07846Z",
    fill: "url(#paint327_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask497_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M18.832 9.04458H24.845V12.375H18.832V9.04458Z",
    fill: "white"
  }))), _g483 || (_g483 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask497_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.192
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4783 9.07723C24.4783 9.07723 23.4524 8.85834 21.9112 9.55152C21.1353 9.90037 20.5663 10.385 20.1068 10.6902C19.6403 10.9996 20.1828 9.55023 19.3319 10.9346C19.2397 11.0843 18.2568 13.1322 19.3286 12.0714C19.8042 11.6003 21.5016 10.2512 22.3448 9.91072C23.0047 9.64432 23.9416 9.49138 24.3845 9.51951C24.9843 9.55831 24.9798 9.14545 24.4783 9.07723Z",
    fill: "url(#paint328_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask498_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8633 9.04583H24.8222V12.3203H18.8633V9.04583Z",
    fill: "white"
  }))), _g484 || (_g484 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask498_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.202
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4586 9.07569C24.4586 9.07569 23.4314 8.8678 21.907 9.55354C21.1353 9.90078 20.5549 10.3951 20.0952 10.701C19.6316 11.0084 20.1149 9.6958 19.3273 10.9781C19.2361 11.1261 18.3202 13.0356 19.3438 12.0282C19.8159 11.5639 21.4951 10.239 22.328 9.89884C22.9946 9.62661 23.9212 9.48112 24.3593 9.5086C24.9526 9.54708 24.9639 9.14262 24.4586 9.07569Z",
    fill: "url(#paint329_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask499_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8984 9.0474H24.8034V12.2656H18.8984V9.0474Z",
    fill: "white"
  }))), _g485 || (_g485 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask499_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.213
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4428 9.07388C24.4428 9.07388 23.4143 8.87666 21.907 9.55529C21.1395 9.90058 20.5479 10.4053 20.0871 10.7115C19.6267 11.017 20.0513 9.84045 19.3267 11.0212C19.2368 11.1676 18.3875 12.9387 19.3632 11.985C19.8317 11.5272 21.4926 10.2262 22.3151 9.88668C22.9889 9.60831 23.9051 9.47027 24.3387 9.49775C24.9252 9.53557 24.9523 9.13984 24.4428 9.07388Z",
    fill: "url(#paint330_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask500_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9336 9.04832H24.7845V12.2109H18.9336V9.04832Z",
    fill: "white"
  }))), _g486 || (_g486 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask500_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.224
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4273 9.07207C24.4273 9.07207 23.3975 8.88552 21.9067 9.55703C21.1434 9.90071 20.5407 10.4151 20.0794 10.7219C19.6219 11.0255 19.9876 9.98542 19.3264 11.0643C19.2375 11.2095 18.4551 12.8419 19.383 11.9414C19.8476 11.4901 21.4903 10.2134 22.3021 9.87452C22.983 9.59033 23.8893 9.45939 24.3177 9.48655C24.8977 9.52437 24.9407 9.13673 24.4273 9.07207Z",
    fill: "url(#paint331_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask501_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 7,
    height: 4
  }, _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9648 9.05673H24.7621V12.1641H18.9648V9.05673Z",
    fill: "white"
  }))), _g487 || (_g487 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask501_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.234
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4077 9.0778C24.4077 9.0778 23.3766 8.90224 21.903 9.56599C21.1438 9.90773 20.5299 10.4331 20.0679 10.7403C19.6133 11.0416 19.9201 10.1376 19.322 11.115C19.234 11.2585 18.5195 12.7529 19.3986 11.9055C19.86 11.4609 21.484 10.2078 22.2854 9.86959C22.9731 9.57958 23.8693 9.4564 24.2929 9.48323C24.8664 9.52009 24.9253 9.14149 24.4077 9.0778Z",
    fill: "url(#paint332_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask502_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 4
  }, _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.057H24.7439V12.1094H19V9.057Z",
    fill: "white"
  }))), _g488 || (_g488 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask502_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.245
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3922 9.0755C24.3922 9.0755 23.3602 8.91061 21.9034 9.56725C21.1484 9.90738 20.5232 10.4425 20.0605 10.7502C19.6089 11.05 19.8568 10.2821 19.3221 11.1579C19.2354 11.2995 18.5878 12.6558 19.4184 11.8615C19.8762 11.4237 21.4821 10.1945 22.2733 9.85694C22.9677 9.56111 23.8536 9.44504 24.2726 9.47155C24.8394 9.50808 24.914 9.1379 24.3922 9.0755Z",
    fill: "url(#paint333_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask503_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 4
  }, _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 9.05695H24.7225V12.0547H19.0312V9.05695Z",
    fill: "white"
  }))), _g489 || (_g489 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask503_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.255
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3735 9.07261C24.3735 9.07261 23.3402 8.91838 21.8998 9.56791C21.1494 9.9061 20.5131 10.4515 20.0495 10.7596C19.6011 11.0571 19.7902 10.426 19.3182 11.2C19.2328 11.3403 18.6528 12.5585 19.4349 11.8172C19.8895 11.3862 21.4763 10.1803 22.2571 9.8437C22.9587 9.5414 23.8345 9.43309 24.2484 9.45928C24.8087 9.49582 24.8992 9.13404 24.3735 9.07261Z",
    fill: "url(#paint334_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask504_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0664 9.05593H24.7053V12H19.0664V9.05593Z",
    fill: "white"
  }))), _g490 || (_g490 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask504_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.266
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3552 9.06952C24.3552 9.06952 23.3209 8.92597 21.8974 9.56839C21.1512 9.90496 20.5036 10.4601 20.0393 10.7688C19.5938 11.0647 19.7247 10.57 19.3154 11.2418C19.2307 11.3805 18.7183 12.461 19.4519 11.7724C19.9032 11.3485 21.4713 10.1659 22.242 9.83027C22.9501 9.52183 23.8159 9.42128 24.2249 9.44715C24.7787 9.48304 24.8851 9.12998 24.3552 9.06952Z",
    fill: "url(#paint335_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask505_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0977 9.06176H24.6845V11.9531H19.0977V9.06176Z",
    fill: "white"
  }))), _g491 || (_g491 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask505_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.277
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3412 9.07342C24.3412 9.07342 23.3054 8.94053 21.8986 9.57584C21.1566 9.91046 20.4977 10.4759 20.0331 10.7853C19.5905 11.0789 19.6629 10.721 19.3167 11.2907C19.2329 11.4281 18.7887 12.3709 19.4728 11.7349C19.9213 11.3178 21.4702 10.1584 22.2307 9.82381C22.9455 9.50891 23.8013 9.41612 24.2058 9.44166C24.7531 9.47722 24.875 9.13258 24.3412 9.07342Z",
    fill: "url(#paint336_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask506_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1289 9.06694H24.6649V11.9062H19.1289V9.06694Z",
    fill: "white"
  }))), _g492 || (_g492 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask506_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.287
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.324 9.07678C24.324 9.07678 23.2872 8.95489 21.8972 9.58276C21.1594 9.91544 20.4895 10.4913 20.024 10.801C19.5843 11.0926 19.5985 10.8711 19.3146 11.339C19.2322 11.4748 18.8559 12.2801 19.4912 11.6966C19.9364 11.2869 21.4663 10.1505 22.2163 9.81683C22.938 9.49579 23.7838 9.41043 24.1834 9.43565C24.7243 9.47089 24.862 9.13497 24.324 9.07678Z",
    fill: "url(#paint337_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask507_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1562 9.06301H24.6425V11.8516H19.1562V9.06301Z",
    fill: "white"
  }))), _g493 || (_g493 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask507_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.298
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3043 9.07098C24.3043 9.07098 23.2658 8.95975 21.893 9.58019C21.1594 9.91126 20.4782 10.4974 20.012 10.8075C19.5752 11.0972 19.5312 11.0125 19.3098 11.3781C19.2286 11.5123 18.9205 12.1809 19.5063 11.6491C19.9489 11.2472 21.4591 10.1334 22.1992 9.80036C22.9276 9.47317 23.7634 9.39591 24.1581 9.4208C24.6922 9.45539 24.8461 9.12788 24.3043 9.07098Z",
    fill: "url(#paint338_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask508_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1836 9.07277H24.6214V11.8125H19.1836V9.07277Z",
    fill: "white"
  }))), _g494 || (_g494 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask508_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.309
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2857 9.07909C24.2857 9.07909 23.2463 8.97886 21.89 9.59186C21.1606 9.92131 20.4684 10.5172 20.0015 10.8279C19.5677 11.1156 19.4658 11.168 19.3067 11.4312C19.2266 11.5641 18.9867 12.0956 19.523 11.6155C19.9634 11.2217 21.4538 10.1302 22.1839 9.79845C22.9188 9.46447 23.7448 9.39496 24.1344 9.41953C24.6624 9.4538 24.8321 9.13502 24.2857 9.07909Z",
    fill: "url(#paint339_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask509_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2109 9.0718H24.6028V11.7656H19.2109V9.0718Z",
    fill: "white"
  }))), _g495 || (_g495 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask509_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.319
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2693 9.0764C24.2693 9.0764 23.2283 8.98683 21.8891 9.59272C21.1639 9.92023 20.4604 10.5264 19.9929 10.8375C19.5623 11.1233 19.4022 11.3124 19.3055 11.4737C19.2267 11.605 19.0553 11.9998 19.5419 11.5714C19.9803 11.1857 21.4501 10.1149 22.1701 9.78509C22.9111 9.44367 23.7278 9.38354 24.1128 9.40779C24.634 9.44141 24.8196 9.13136 24.2693 9.0764Z",
    fill: "url(#paint340_radial_10834_56546)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask510_10834_56546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 9,
    width: 6,
    height: 3
  }, _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2344 9.07315H24.5832V11.7266H19.2344V9.07315Z",
    fill: "white"
  }))), _g496 || (_g496 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask510_10834_56546)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2519 9.07674C24.2519 9.07674 23.2099 8.99786 21.8876 9.59663C21.1666 9.9222 20.4517 10.5387 19.9836 10.8501C19.5558 11.134 19.3382 11.4602 19.3033 11.519C19.2267 11.6493 19.1226 11.9067 19.5597 11.53C19.9962 11.153 21.4459 10.1045 22.1559 9.7751C22.9037 9.42786 23.71 9.37484 24.0903 9.39876C24.605 9.43239 24.8064 9.13041 24.2519 9.07674Z",
    fill: "url(#paint341_radial_10834_56546)"
  }))))), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0611 5.94753L20.1367 10.4141C20.1367 10.4141 21.0711 7.63618 22.0611 5.94753Z",
    fill: "#0066B3"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9258 18.3359H17.6086C17.6086 18.3359 16.9287 17.9784 17.3225 17.0647C17.3225 17.0647 16.8569 17.8707 17.3225 18.2108C17.3225 18.2108 16.2662 18.2816 15.9258 18.3359ZM22.7302 18.3359H24.4127C24.4127 18.3359 23.7328 17.9784 24.1265 17.0647C24.1265 17.0647 23.6613 17.8707 24.1265 18.2108C24.1265 18.2108 23.0706 18.2816 22.7302 18.3359Z",
    fill: "#0082C9"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8203 15.7969C17.8203 15.7969 19.0618 13.299 20.2969 12.1528C21.5138 11.0242 22.787 10.4283 23.2862 11.0843C23.6632 11.5793 23.1617 13.138 23.1617 13.138C23.1617 13.138 23.7598 11.3588 23.3053 10.9353C22.786 10.4522 21.1918 10.6465 19.5264 12.6514C17.8614 14.6579 17.8203 15.7969 17.8203 15.7969Z",
    fill: "#0066B3"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4078 4.79086C19.4078 4.79086 20.0243 5.18692 19.6128 6.20793C19.2002 7.2283 16.5859 13.1016 16.5859 13.1016C16.5859 13.1016 18.7709 8.53544 19.7026 6.26225C20.0761 5.34793 19.508 4.84356 19.4081 4.79119M20.1369 10.4119C20.1369 10.4119 21.7793 9.27001 23.4443 8.94735C23.4443 8.94735 21.3768 9.58362 20.1369 10.4119Z",
    fill: "#00ABED"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3398 16.4531C24.3398 16.4531 25.6292 12.8896 25.8976 11.4751C25.8976 11.4751 24.4113 16.2921 24.3398 16.4531Z",
    fill: "#0066B3"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M23.053 13.4968C23.053 13.4968 22.0737 15.9992 21.8622 16.467C21.6514 16.9345 21.3951 17.5524 21.6964 17.9297C21.6964 17.9297 21.5008 17.6122 21.6673 17.1754C21.8322 16.738 22.9638 14.0846 23.053 13.4968Z",
    fill: "#00ABED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10834_56546",
    x1: 14.7676,
    y1: 14.5311,
    x2: 11.4377,
    y2: 10.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007CC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9402 5.51245) scale(3.82548 3.82548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9376 5.51899) scale(3.82516 3.82515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9393 5.5173) scale(3.8249 3.8249)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9407 5.52385) scale(3.82435 3.82435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9382 5.52197) scale(3.82381 3.82381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9398 5.51924) scale(3.82339 3.82339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9374 5.52467) scale(3.82257 3.82256)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9392 5.52995) scale(3.82177 3.82177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9367 5.52693) scale(3.82079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9385 5.53169) scale(3.81991 3.81991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9363 5.53632) scale(3.81887)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9381 5.53257) scale(3.81773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.936 5.53628) scale(3.81663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9387 5.53208) scale(3.81542 3.81542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9368 5.53517) scale(3.81453 3.81453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9388 5.53797) scale(3.81336 3.81335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9373 5.54057) scale(3.81222 3.81222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9398 5.54263) scale(3.81106 3.81106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9384 5.53622) scale(3.80988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9407 5.53734) scale(3.8089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9397 5.53793) scale(3.80795 3.80795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9382 5.53741) scale(3.80726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9372 5.54423) scale(3.80655 3.80655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9403 5.53458) scale(3.80608 3.80607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9391 5.54) scale(3.8058 3.8058)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.942 5.5442) scale(3.80605 3.80606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9377 5.53915) scale(3.80647 3.80647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9406 5.54102) scale(3.80728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9397 5.54117) scale(3.80856 3.80857)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.943 5.54042) scale(3.80996 3.80996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9388 5.54569) scale(3.81227)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10834_56546",
    x1: 13.1531,
    y1: 5.94602,
    x2: 15.3734,
    y2: 8.80851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10834_56546",
    x1: 13.1607,
    y1: 5.93601,
    x2: 15.3814,
    y2: 8.79907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10834_56546",
    x1: 13.1688,
    y1: 5.93636,
    x2: 15.3905,
    y2: 8.80058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10834_56546",
    x1: 13.1725,
    y1: 5.92398,
    x2: 15.395,
    y2: 8.78927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10834_56546",
    x1: 13.1761,
    y1: 5.91594,
    x2: 15.3991,
    y2: 8.78196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10834_56546",
    x1: 13.1867,
    y1: 5.91381,
    x2: 15.4101,
    y2: 8.78022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10834_56546",
    x1: 13.1911,
    y1: 5.90172,
    x2: 15.4146,
    y2: 8.76843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10834_56546",
    x1: 13.196,
    y1: 5.90163,
    x2: 15.4195,
    y2: 8.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10834_56546",
    x1: 13.2039,
    y1: 5.89325,
    x2: 15.4272,
    y2: 8.75956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10834_56546",
    x1: 13.2114,
    y1: 5.88621,
    x2: 15.4345,
    y2: 8.75232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10834_56546",
    x1: 13.2171,
    y1: 5.88162,
    x2: 15.4396,
    y2: 8.74697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10834_56546",
    x1: 13.2249,
    y1: 5.87404,
    x2: 15.4465,
    y2: 8.73827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10834_56546",
    x1: 13.2302,
    y1: 5.86544,
    x2: 15.451,
    y2: 8.7285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_10834_56546",
    x1: 13.2362,
    y1: 5.86243,
    x2: 15.456,
    y2: 8.72425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_10834_56546",
    x1: 13.2464,
    y1: 5.85481,
    x2: 15.4647,
    y2: 8.71481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_10834_56546",
    x1: 13.2507,
    y1: 5.84644,
    x2: 15.4678,
    y2: 8.70481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_10834_56546",
    x1: 13.257,
    y1: 5.84641,
    x2: 15.4726,
    y2: 8.70285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_10834_56546",
    x1: 13.2631,
    y1: 5.83924,
    x2: 15.4774,
    y2: 8.69394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_10834_56546",
    x1: 13.2731,
    y1: 5.83127,
    x2: 15.4858,
    y2: 8.68393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_10834_56546",
    x1: 13.2762,
    y1: 5.83072,
    x2: 15.4874,
    y2: 8.68157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_10834_56546",
    x1: 13.2823,
    y1: 5.8222,
    x2: 15.4919,
    y2: 8.67093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_10834_56546",
    x1: 13.2897,
    y1: 5.81457,
    x2: 15.498,
    y2: 8.6617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_10834_56546",
    x1: 13.2944,
    y1: 5.81447,
    x2: 15.5017,
    y2: 8.66026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_10834_56546",
    x1: 13.3061,
    y1: 5.81105,
    x2: 15.5128,
    y2: 8.65604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_10834_56546",
    x1: 13.3111,
    y1: 5.80195,
    x2: 15.5177,
    y2: 8.6467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_10834_56546",
    x1: 13.3158,
    y1: 5.80516,
    x2: 15.5235,
    y2: 8.65139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_10834_56546",
    x1: 13.3226,
    y1: 5.79927,
    x2: 15.5325,
    y2: 8.64842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_10834_56546",
    x1: 13.3296,
    y1: 5.79317,
    x2: 15.5428,
    y2: 8.64644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_10834_56546",
    x1: 13.3362,
    y1: 5.79428,
    x2: 15.5542,
    y2: 8.65376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_10834_56546",
    x1: 13.3424,
    y1: 5.78674,
    x2: 15.5666,
    y2: 8.65428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_10834_56546",
    x1: 13.3496,
    y1: 5.78429,
    x2: 15.5818,
    y2: 8.66207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_10834_56546",
    x1: 12.8022,
    y1: 10.4973,
    x2: 15.2122,
    y2: 13.3557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_10834_56546",
    x1: 12.8048,
    y1: 10.4979,
    x2: 15.21,
    y2: 13.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_10834_56546",
    x1: 12.8129,
    y1: 10.502,
    x2: 15.2132,
    y2: 13.3488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_10834_56546",
    x1: 12.8228,
    y1: 10.5011,
    x2: 15.218,
    y2: 13.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_10834_56546",
    x1: 12.8289,
    y1: 10.4989,
    x2: 15.2188,
    y2: 13.3336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_10834_56546",
    x1: 12.8343,
    y1: 10.4984,
    x2: 15.219,
    y2: 13.3268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_10834_56546",
    x1: 12.8383,
    y1: 10.5024,
    x2: 15.2178,
    y2: 13.3246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_10834_56546",
    x1: 12.8479,
    y1: 10.5024,
    x2: 15.2222,
    y2: 13.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_10834_56546",
    x1: 12.8508,
    y1: 10.5023,
    x2: 15.2198,
    y2: 13.3122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_10834_56546",
    x1: 12.8606,
    y1: 10.5021,
    x2: 15.2243,
    y2: 13.3056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_10834_56546",
    x1: 12.8637,
    y1: 10.5075,
    x2: 15.222,
    y2: 13.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_10834_56546",
    x1: 12.8748,
    y1: 10.5042,
    x2: 15.2276,
    y2: 13.2947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_10834_56546",
    x1: 12.8825,
    y1: 10.5058,
    x2: 15.2301,
    y2: 13.2901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_10834_56546",
    x1: 12.8863,
    y1: 10.5119,
    x2: 15.2284,
    y2: 13.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_10834_56546",
    x1: 12.8945,
    y1: 10.5108,
    x2: 15.2312,
    y2: 13.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_10834_56546",
    x1: 12.9029,
    y1: 10.5101,
    x2: 15.2341,
    y2: 13.2751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_10834_56546",
    x1: 12.9097,
    y1: 10.5166,
    x2: 15.2357,
    y2: 13.2753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_10834_56546",
    x1: 12.9168,
    y1: 10.5152,
    x2: 15.2375,
    y2: 13.2676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_10834_56546",
    x1: 12.9244,
    y1: 10.5179,
    x2: 15.2395,
    y2: 13.2638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_10834_56546",
    x1: 12.9286,
    y1: 10.5229,
    x2: 15.2384,
    y2: 13.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_10834_56546",
    x1: 12.9391,
    y1: 10.5163,
    x2: 15.2436,
    y2: 13.2495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_10834_56546",
    x1: 12.9487,
    y1: 10.5255,
    x2: 15.2482,
    y2: 13.2528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_10834_56546",
    x1: 12.9547,
    y1: 10.5256,
    x2: 15.2491,
    y2: 13.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_10834_56546",
    x1: 12.9642,
    y1: 10.5249,
    x2: 15.2534,
    y2: 13.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_10834_56546",
    x1: 12.9727,
    y1: 10.531,
    x2: 15.2568,
    y2: 13.2402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_10834_56546",
    x1: 12.9832,
    y1: 10.5288,
    x2: 15.2625,
    y2: 13.2323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_10834_56546",
    x1: 12.9904,
    y1: 10.5393,
    x2: 15.2648,
    y2: 13.2369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_10834_56546",
    x1: 12.9951,
    y1: 10.539,
    x2: 15.2649,
    y2: 13.2312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_10834_56546",
    x1: 13.0012,
    y1: 10.5402,
    x2: 15.2662,
    y2: 13.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_10834_56546",
    x1: 13.0116,
    y1: 10.5483,
    x2: 15.2717,
    y2: 13.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_10834_56546",
    x1: 13.0189,
    y1: 10.5481,
    x2: 15.2746,
    y2: 13.2235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#4DC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0084CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_10834_56546",
    x1: 10.918,
    y1: 10.0142,
    x2: 14.5916,
    y2: 14.4191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_10834_56546",
    x1: 10.9215,
    y1: 10.0294,
    x2: 14.5909,
    y2: 14.4183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_10834_56546",
    x1: 10.9241,
    y1: 10.0444,
    x2: 14.5893,
    y2: 14.4172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_10834_56546",
    x1: 10.931,
    y1: 10.0596,
    x2: 14.5914,
    y2: 14.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_10834_56546",
    x1: 10.9347,
    y1: 10.0753,
    x2: 14.5901,
    y2: 14.4142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_10834_56546",
    x1: 10.9422,
    y1: 10.0905,
    x2: 14.5922,
    y2: 14.4118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_10834_56546",
    x1: 10.9464,
    y1: 10.1071,
    x2: 14.5905,
    y2: 14.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_10834_56546",
    x1: 10.9512,
    y1: 10.1231,
    x2: 14.589,
    y2: 14.4078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_10834_56546",
    x1: 10.9563,
    y1: 10.1395,
    x2: 14.5876,
    y2: 14.4054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_10834_56546",
    x1: 10.9615,
    y1: 10.1641,
    x2: 14.5862,
    y2: 14.4109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_10834_56546",
    x1: 10.9712,
    y1: 10.1806,
    x2: 14.5886,
    y2: 14.4077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_10834_56546",
    x1: 10.9773,
    y1: 10.1977,
    x2: 14.5869,
    y2: 14.4046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_10834_56546",
    x1: 10.9837,
    y1: 10.215,
    x2: 14.5855,
    y2: 14.4014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_10834_56546",
    x1: 10.9908,
    y1: 10.2326,
    x2: 14.5841,
    y2: 14.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_10834_56546",
    x1: 10.997,
    y1: 10.2501,
    x2: 14.5819,
    y2: 14.3943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_10834_56546",
    x1: 11.0048,
    y1: 10.268,
    x2: 14.5808,
    y2: 14.3908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_10834_56546",
    x1: 11.0126,
    y1: 10.2858,
    x2: 14.5793,
    y2: 14.3866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_10834_56546",
    x1: 11.0205,
    y1: 10.3034,
    x2: 14.5777,
    y2: 14.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_10834_56546",
    x1: 11.0292,
    y1: 10.322,
    x2: 14.5766,
    y2: 14.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_10834_56546",
    x1: 11.0377,
    y1: 10.3402,
    x2: 14.5752,
    y2: 14.3737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_10834_56546",
    x1: 11.047,
    y1: 10.3579,
    x2: 14.5743,
    y2: 14.3685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_10834_56546",
    x1: 11.0562,
    y1: 10.3764,
    x2: 14.5731,
    y2: 14.3638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_10834_56546",
    x1: 11.0658,
    y1: 10.4026,
    x2: 14.5722,
    y2: 14.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_10834_56546",
    x1: 11.076,
    y1: 10.4209,
    x2: 14.5716,
    y2: 14.3615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_10834_56546",
    x1: 11.0822,
    y1: 10.4392,
    x2: 14.5668,
    y2: 14.3562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_10834_56546",
    x1: 11.0964,
    y1: 10.4569,
    x2: 14.5701,
    y2: 14.3503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_10834_56546",
    x1: 11.1025,
    y1: 10.4668,
    x2: 14.5653,
    y2: 14.3368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_10834_56546",
    x1: 11.1134,
    y1: 10.4839,
    x2: 14.5655,
    y2: 14.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_10834_56546",
    x1: 11.1198,
    y1: 10.5013,
    x2: 14.5612,
    y2: 14.3248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_10834_56546",
    x1: 11.1343,
    y1: 10.5184,
    x2: 14.5653,
    y2: 14.3188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_10834_56546",
    x1: 11.141,
    y1: 10.542,
    x2: 14.5616,
    y2: 14.3197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_10834_56546",
    x1: 6.53438,
    y1: 13.7987,
    x2: 7.2772,
    y2: 14.6916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_10834_56546",
    x1: 6.54014,
    y1: 13.7964,
    x2: 7.27475,
    y2: 14.6795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_10834_56546",
    x1: 6.54199,
    y1: 13.8035,
    x2: 7.26853,
    y2: 14.6768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_10834_56546",
    x1: 6.54875,
    y1: 13.8083,
    x2: 7.26707,
    y2: 14.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_10834_56546",
    x1: 6.55433,
    y1: 13.8077,
    x2: 7.26444,
    y2: 14.6613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_10834_56546",
    x1: 6.56103,
    y1: 13.8138,
    x2: 7.26292,
    y2: 14.6575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_10834_56546",
    x1: 6.563,
    y1: 13.8119,
    x2: 7.25682,
    y2: 14.6459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_10834_56546",
    x1: 6.5695,
    y1: 13.8179,
    x2: 7.2551,
    y2: 14.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_10834_56546",
    x1: 6.57523,
    y1: 13.8167,
    x2: 7.25276,
    y2: 14.6311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_10834_56546",
    x1: 6.58141,
    y1: 13.8222,
    x2: 7.25073,
    y2: 14.6267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_10834_56546",
    x1: 6.58415,
    y1: 13.8196,
    x2: 7.24525,
    y2: 14.6143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_10834_56546",
    x1: 6.58985,
    y1: 13.8186,
    x2: 7.24274,
    y2: 14.6034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_10834_56546",
    x1: 6.5963,
    y1: 13.8246,
    x2: 7.24112,
    y2: 14.5997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_10834_56546",
    x1: 6.60231,
    y1: 13.8227,
    x2: 7.23891,
    y2: 14.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_10834_56546",
    x1: 6.60885,
    y1: 13.8285,
    x2: 7.23724,
    y2: 14.5839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_10834_56546",
    x1: 6.61063,
    y1: 13.8267,
    x2: 7.23095,
    y2: 14.5724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_10834_56546",
    x1: 6.61619,
    y1: 13.8326,
    x2: 7.22829,
    y2: 14.5684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_10834_56546",
    x1: 6.62269,
    y1: 13.8306,
    x2: 7.22672,
    y2: 14.5567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_10834_56546",
    x1: 6.62903,
    y1: 13.8369,
    x2: 7.22499,
    y2: 14.5533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_10834_56546",
    x1: 6.63457,
    y1: 13.8434,
    x2: 7.22232,
    y2: 14.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_10834_56546",
    x1: 6.63752,
    y1: 13.8415,
    x2: 7.21705,
    y2: 14.5381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_10834_56546",
    x1: 6.64338,
    y1: 13.8475,
    x2: 7.21484,
    y2: 14.5344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_10834_56546",
    x1: 6.65007,
    y1: 13.8455,
    x2: 7.21331,
    y2: 14.5226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_10834_56546",
    x1: 6.65528,
    y1: 13.8437,
    x2: 7.21031,
    y2: 14.5108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_10834_56546",
    x1: 6.65798,
    y1: 13.8419,
    x2: 7.20494,
    y2: 14.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_10834_56546",
    x1: 6.66352,
    y1: 13.8481,
    x2: 7.20227,
    y2: 14.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_10834_56546",
    x1: 6.66997,
    y1: 13.8463,
    x2: 7.20065,
    y2: 14.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_10834_56546",
    x1: 6.67646,
    y1: 13.8517,
    x2: 7.19892,
    y2: 14.4797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_10834_56546",
    x1: 6.67856,
    y1: 13.8584,
    x2: 7.1928,
    y2: 14.4766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_10834_56546",
    x1: 6.68519,
    y1: 13.8565,
    x2: 7.19122,
    y2: 14.4647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_10834_56546",
    x1: 6.69125,
    y1: 13.8624,
    x2: 7.1892,
    y2: 14.4609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_10834_56546",
    x1: 16.6994,
    y1: 9.24412,
    x2: 20.4908,
    y2: 9.24412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_10834_56546",
    x1: 16.711,
    y1: 9.25002,
    x2: 20.4814,
    y2: 9.25002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_10834_56546",
    x1: 16.7148,
    y1: 9.24037,
    x2: 20.464,
    y2: 9.24037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_10834_56546",
    x1: 16.7228,
    y1: 9.23863,
    x2: 20.451,
    y2: 9.23863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_10834_56546",
    x1: 16.7264,
    y1: 9.23662,
    x2: 20.4336,
    y2: 9.23662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_10834_56546",
    x1: 16.7305,
    y1: 9.23485,
    x2: 20.4166,
    y2: 9.23485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_10834_56546",
    x1: 16.7424,
    y1: 9.23237,
    x2: 20.4076,
    y2: 9.23237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_10834_56546",
    x1: 16.746,
    y1: 9.23022,
    x2: 20.3902,
    y2: 9.23022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_10834_56546",
    x1: 16.754,
    y1: 9.22812,
    x2: 20.3772,
    y2: 9.22812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_10834_56546",
    x1: 16.7576,
    y1: 9.22532,
    x2: 20.3599,
    y2: 9.22532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_10834_56546",
    x1: 16.7656,
    y1: 9.22252,
    x2: 20.3471,
    y2: 9.22252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_10834_56546",
    x1: 16.7734,
    y1: 9.21945,
    x2: 20.3342,
    y2: 9.21945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_10834_56546",
    x1: 16.7769,
    y1: 9.21632,
    x2: 20.3169,
    y2: 9.21632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_10834_56546",
    x1: 16.785,
    y1: 9.21366,
    x2: 20.304,
    y2: 9.21366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_10834_56546",
    x1: 16.7891,
    y1: 9.21078,
    x2: 20.2876,
    y2: 9.21078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_10834_56546",
    x1: 16.797,
    y1: 9.19951,
    x2: 20.2749,
    y2: 9.19951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_10834_56546",
    x1: 16.8048,
    y1: 9.20467,
    x2: 20.2619,
    y2: 9.20467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_10834_56546",
    x1: 16.8087,
    y1: 9.20155,
    x2: 20.2453,
    y2: 9.20155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_10834_56546",
    x1: 16.8165,
    y1: 9.19848,
    x2: 20.2326,
    y2: 9.19848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_10834_56546",
    x1: 16.8205,
    y1: 9.18754,
    x2: 20.2162,
    y2: 9.18754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_10834_56546",
    x1: 16.828,
    y1: 9.18442,
    x2: 20.2034,
    y2: 9.18442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_10834_56546",
    x1: 16.8359,
    y1: 9.18129,
    x2: 20.191,
    y2: 9.18129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_10834_56546",
    x1: 16.8396,
    y1: 9.17863,
    x2: 20.1747,
    y2: 9.17863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_10834_56546",
    x1: 16.8475,
    y1: 9.17556,
    x2: 20.1627,
    y2: 9.17556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_10834_56546",
    x1: 16.8516,
    y1: 9.17211,
    x2: 20.1471,
    y2: 9.17211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_10834_56546",
    x1: 16.859,
    y1: 9.16931,
    x2: 20.1351,
    y2: 9.16931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_10834_56546",
    x1: 16.8636,
    y1: 9.16656,
    x2: 20.1205,
    y2: 9.16656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_10834_56546",
    x1: 16.8714,
    y1: 9.16343,
    x2: 20.11,
    y2: 9.16343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_10834_56546",
    x1: 16.8751,
    y1: 9.16044,
    x2: 20.0956,
    y2: 9.16044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_10834_56546",
    x1: 16.8789,
    y1: 9.15731,
    x2: 20.082,
    y2: 9.15731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_10834_56546",
    x1: 16.8864,
    y1: 9.15409,
    x2: 20.0728,
    y2: 9.15409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#007BC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_10834_56546",
    x1: 18.4725,
    y1: 9.16715,
    x2: 22.0995,
    y2: 9.16715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_10834_56546",
    x1: 18.4805,
    y1: 9.1637,
    x2: 22.092,
    y2: 9.1637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_10834_56546",
    x1: 18.4885,
    y1: 9.16104,
    x2: 22.0847,
    y2: 9.16104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_10834_56546",
    x1: 18.4923,
    y1: 9.15792,
    x2: 22.073,
    y2: 9.15792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_10834_56546",
    x1: 18.5,
    y1: 9.15471,
    x2: 22.0653,
    y2: 9.15471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_10834_56546",
    x1: 18.504,
    y1: 9.15205,
    x2: 22.0539,
    y2: 9.15205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_10834_56546",
    x1: 18.5116,
    y1: 9.14902,
    x2: 22.0462,
    y2: 9.14902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_10834_56546",
    x1: 18.5196,
    y1: 9.14595,
    x2: 22.0388,
    y2: 9.14595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_10834_56546",
    x1: 18.5235,
    y1: 9.13501,
    x2: 22.0274,
    y2: 9.13501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_10834_56546",
    x1: 18.5312,
    y1: 9.1397,
    x2: 22.0199,
    y2: 9.1397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_10834_56546",
    x1: 18.5391,
    y1: 9.13695,
    x2: 22.0123,
    y2: 9.13695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_10834_56546",
    x1: 18.5468,
    y1: 9.12602,
    x2: 22.0049,
    y2: 9.12602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_10834_56546",
    x1: 18.5509,
    y1: 9.12303,
    x2: 21.9936,
    y2: 9.12303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_10834_56546",
    x1: 18.5545,
    y1: 9.11992,
    x2: 21.9821,
    y2: 9.11992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_10834_56546",
    x1: 18.5623,
    y1: 9.12493,
    x2: 21.9747,
    y2: 9.12493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_10834_56546",
    x1: 18.5664,
    y1: 9.11414,
    x2: 21.9637,
    y2: 9.11414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_10834_56546",
    x1: 18.5779,
    y1: 9.11092,
    x2: 21.9602,
    y2: 9.11092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_10834_56546",
    x1: 18.5821,
    y1: 9.1078,
    x2: 21.9494,
    y2: 9.1078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_10834_56546",
    x1: 18.5857,
    y1: 9.10514,
    x2: 21.938,
    y2: 9.10514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_10834_56546",
    x1: 18.5939,
    y1: 9.10193,
    x2: 21.9315,
    y2: 9.10193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_10834_56546",
    x1: 18.5978,
    y1: 9.09904,
    x2: 21.9206,
    y2: 9.09904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_10834_56546",
    x1: 18.6096,
    y1: 9.09581,
    x2: 21.9179,
    y2: 9.09581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_10834_56546",
    x1: 18.6134,
    y1: 9.0926,
    x2: 21.9071,
    y2: 9.0926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_10834_56546",
    x1: 18.621,
    y1: 9.08971,
    x2: 21.9003,
    y2: 9.08971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_10834_56546",
    x1: 18.6247,
    y1: 9.07877,
    x2: 21.8899,
    y2: 9.07877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_10834_56546",
    x1: 18.6289,
    y1: 9.07602,
    x2: 21.88,
    y2: 9.07602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_10834_56546",
    x1: 18.6367,
    y1: 9.08071,
    x2: 21.874,
    y2: 9.08071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_10834_56546",
    x1: 18.6406,
    y1: 9.07758,
    x2: 21.8646,
    y2: 9.07758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_10834_56546",
    x1: 18.6486,
    y1: 9.06669,
    x2: 21.8597,
    y2: 9.06669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_10834_56546",
    x1: 18.6524,
    y1: 9.06342,
    x2: 21.851,
    y2: 9.06342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_10834_56546",
    x1: 18.6602,
    y1: 9.06099,
    x2: 21.847,
    y2: 9.06099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_10834_56546",
    x1: 22.5207,
    y1: 12.766,
    x2: 26.0838,
    y2: 12.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_10834_56546",
    x1: 22.5405,
    y1: 12.7658,
    x2: 26.0778,
    y2: 12.5315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_10834_56546",
    x1: 22.5643,
    y1: 12.7822,
    x2: 26.0758,
    y2: 12.5497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_10834_56546",
    x1: 22.5844,
    y1: 12.7897,
    x2: 26.0697,
    y2: 12.5589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_10834_56546",
    x1: 22.6082,
    y1: 12.7899,
    x2: 26.0676,
    y2: 12.5608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_10834_56546",
    x1: 22.6284,
    y1: 12.8056,
    x2: 26.0619,
    y2: 12.5782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_10834_56546",
    x1: 22.6518,
    y1: 12.8137,
    x2: 26.0596,
    y2: 12.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_10834_56546",
    x1: 22.6717,
    y1: 12.8219,
    x2: 26.0537,
    y2: 12.5979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_10834_56546",
    x1: 22.6954,
    y1: 12.8216,
    x2: 26.0516,
    y2: 12.5994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_10834_56546",
    x1: 22.7159,
    y1: 12.8379,
    x2: 26.0464,
    y2: 12.6173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_10834_56546",
    x1: 22.7394,
    y1: 12.8454,
    x2: 26.0442,
    y2: 12.6265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_10834_56546",
    x1: 22.7592,
    y1: 12.8531,
    x2: 26.0385,
    y2: 12.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_10834_56546",
    x1: 22.783,
    y1: 12.8612,
    x2: 26.0367,
    y2: 12.6458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_10834_56546",
    x1: 22.8032,
    y1: 12.8692,
    x2: 26.0311,
    y2: 12.6555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_10834_56546",
    x1: 22.8266,
    y1: 12.8768,
    x2: 26.0291,
    y2: 12.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_10834_56546",
    x1: 22.8468,
    y1: 12.8852,
    x2: 26.0236,
    y2: 12.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_10834_56546",
    x1: 22.8705,
    y1: 12.8925,
    x2: 26.0219,
    y2: 12.6838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_10834_56546",
    x1: 22.8907,
    y1: 12.9007,
    x2: 26.0166,
    y2: 12.6937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_10834_56546",
    x1: 22.9106,
    y1: 12.9088,
    x2: 26.0112,
    y2: 12.7035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_10834_56546",
    x1: 22.934,
    y1: 12.9169,
    x2: 26.009,
    y2: 12.7133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_10834_56546",
    x1: 22.9581,
    y1: 12.9248,
    x2: 26.0079,
    y2: 12.7229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_10834_56546",
    x1: 22.978,
    y1: 12.9325,
    x2: 26.0023,
    y2: 12.7322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_10834_56546",
    x1: 22.9978,
    y1: 12.9408,
    x2: 25.9969,
    y2: 12.7422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_10834_56546",
    x1: 23.0216,
    y1: 12.9482,
    x2: 25.9954,
    y2: 12.7513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_10834_56546",
    x1: 23.0421,
    y1: 12.9563,
    x2: 25.9906,
    y2: 12.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_10834_56546",
    x1: 23.0655,
    y1: 12.9641,
    x2: 25.9888,
    y2: 12.7705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_10834_56546",
    x1: 23.0854,
    y1: 12.9723,
    x2: 25.9836,
    y2: 12.7803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_10834_56546",
    x1: 23.1091,
    y1: 12.9804,
    x2: 25.9821,
    y2: 12.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_10834_56546",
    x1: 23.1293,
    y1: 12.9883,
    x2: 25.9766,
    y2: 12.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_10834_56546",
    x1: 23.1531,
    y1: 12.9957,
    x2: 25.9755,
    y2: 12.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_10834_56546",
    x1: 23.1729,
    y1: 13.0035,
    x2: 25.9705,
    y2: 12.8182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_10834_56546",
    x1: 21.001,
    y1: 4.71759,
    x2: 20.6973,
    y2: 5.37116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_10834_56546",
    x1: 20.9994,
    y1: 4.71404,
    x2: 20.6991,
    y2: 5.36019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_10834_56546",
    x1: 21.0018,
    y1: 4.72474,
    x2: 20.7046,
    y2: 5.36411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_10834_56546",
    x1: 20.9996,
    y1: 4.72918,
    x2: 20.7058,
    y2: 5.36135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_10834_56546",
    x1: 20.9984,
    y1: 4.72424,
    x2: 20.7078,
    y2: 5.34942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_10834_56546",
    x1: 21.0002,
    y1: 4.73636,
    x2: 20.7129,
    y2: 5.35455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_10834_56546",
    x1: 20.9991,
    y1: 4.73868,
    x2: 20.7151,
    y2: 5.34966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_10834_56546",
    x1: 21.0009,
    y1: 4.73603,
    x2: 20.7201,
    y2: 5.34023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_10834_56546",
    x1: 20.9995,
    y1: 4.74721,
    x2: 20.7219,
    y2: 5.34442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_10834_56546",
    x1: 20.9985,
    y1: 4.74922,
    x2: 20.7241,
    y2: 5.33967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_10834_56546",
    x1: 21.0005,
    y1: 4.74571,
    x2: 20.7294,
    y2: 5.32894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_10834_56546",
    x1: 20.9987,
    y1: 4.75817,
    x2: 20.7306,
    y2: 5.33484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_10834_56546",
    x1: 20.997,
    y1: 4.75986,
    x2: 20.7324,
    y2: 5.32932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_10834_56546",
    x1: 20.9961,
    y1: 4.76357,
    x2: 20.7345,
    y2: 5.32646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_10834_56546",
    x1: 20.9975,
    y1: 4.76779,
    x2: 20.7391,
    y2: 5.32369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_10834_56546",
    x1: 21,
    y1: 4.77122,
    x2: 20.7448,
    y2: 5.32034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_10834_56546",
    x1: 20.9989,
    y1: 4.77447,
    x2: 20.7469,
    y2: 5.31661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_10834_56546",
    x1: 20.9971,
    y1: 4.77784,
    x2: 20.7481,
    y2: 5.31361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_10834_56546",
    x1: 20.9954,
    y1: 4.78334,
    x2: 20.7496,
    y2: 5.31213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_10834_56546",
    x1: 20.9978,
    y1: 4.78393,
    x2: 20.7552,
    y2: 5.30594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_10834_56546",
    x1: 20.9968,
    y1: 4.7881,
    x2: 20.7571,
    y2: 5.30376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_10834_56546",
    x1: 20.9947,
    y1: 4.79124,
    x2: 20.758,
    y2: 5.30032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_10834_56546",
    x1: 20.9974,
    y1: 4.79688,
    x2: 20.7639,
    y2: 5.29918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_10834_56546",
    x1: 20.9963,
    y1: 4.79685,
    x2: 20.7659,
    y2: 5.2926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_10834_56546",
    x1: 20.9982,
    y1: 4.80075,
    x2: 20.7708,
    y2: 5.29013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_10834_56546",
    x1: 20.9971,
    y1: 4.80339,
    x2: 20.7727,
    y2: 5.2862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_10834_56546",
    x1: 20.9959,
    y1: 4.80915,
    x2: 20.7744,
    y2: 5.28582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_10834_56546",
    x1: 20.998,
    y1: 4.80996,
    x2: 20.7795,
    y2: 5.28006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_10834_56546",
    x1: 20.9974,
    y1: 4.82035,
    x2: 20.7818,
    y2: 5.28431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_10834_56546",
    x1: 20.9998,
    y1: 4.81546,
    x2: 20.787,
    y2: 5.27327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_10834_56546",
    x1: 20.9948,
    y1: 4.81859,
    x2: 20.7848,
    y2: 5.27048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#008FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095DA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7939 10.6285) scale(4.10599 4.10598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8032 10.6261) scale(4.0854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8137 10.6233) scale(4.06302)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8248 10.628) scale(4.03855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8329 10.6244) scale(4.0122 4.01219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8416 10.6201) scale(3.98403 3.98403)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0065B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8514 10.6233) scale(3.95419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.858 10.6259) scale(3.9226)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8656 10.6277) scale(3.8895 3.88951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.87 10.629) scale(3.85469 3.85469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8795 10.629) scale(3.81896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8823 10.6281) scale(3.78198 3.78198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8866 10.6258) scale(3.74391 3.74392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0067B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8919 10.6306) scale(3.70505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8952 10.6336) scale(3.66533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8958 10.6346) scale(3.62542 3.62542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8979 10.6341) scale(3.58571 3.58571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8985 10.6387) scale(3.5464 3.5464)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0068B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint298_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9013 10.6399) scale(3.50785 3.50785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint299_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9024 10.6385) scale(3.47065 3.47066)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9021 10.6481) scale(3.43572 3.43573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0069B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.9012 10.6461) scale(3.40317 3.40318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint302_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8954 10.6531) scale(3.37513 3.37514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8933 10.6618) scale(3.3518 3.3518)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8919 10.6614) scale(3.33563 3.33563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.887 10.6741) scale(3.32823 3.32823)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8798 10.6813) scale(3.33245 3.33245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8747 10.6878) scale(3.35191 3.3519)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8656 10.7051) scale(3.39055 3.39054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8535 10.7125) scale(3.4537 3.45369)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8406 10.7232) scale(3.54562 3.54561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint311_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7422 9.56889) scale(5.3699 5.372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7433 9.60161) scale(5.29791 5.30204)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7409 9.59658) scale(5.26377 5.26993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7421 9.59085) scale(5.22891 5.23708)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint315_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7439 9.58539) scale(5.19372 5.20387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint316_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7449 9.57937) scale(5.15795 5.17007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint317_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7419 9.57343) scale(5.12166 5.13569)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint318_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7434 9.56765) scale(5.08484 5.10077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint319_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7404 9.56188) scale(5.04688 5.06467)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint320_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7416 9.56343) scale(5.00897 5.0286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint321_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7426 9.55729) scale(4.97038 4.99181)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint322_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7438 9.5507) scale(4.93112 4.95433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7456 9.5444) scale(4.89153 4.91647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint324_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7429 9.53826) scale(4.85106 4.87771)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint325_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7441 9.53139) scale(4.81059 4.83892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint326_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7458 9.52469) scale(4.76934 4.79931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7428 9.52527) scale(4.72782 4.7594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7444 9.51822) scale(4.68558 4.71873)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7421 9.51087) scale(4.64316 4.67785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint330_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7438 9.50356) scale(4.60023 4.63643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint331_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7454 9.49593) scale(4.55714 4.59481)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7433 9.49584) scale(4.51408 4.55318)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7456 9.4874) scale(4.47061 4.51111)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint334_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.744 9.47868) scale(4.42684 4.46869)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint335_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7428 9.46946) scale(4.38369 4.42687)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.746 9.46753) scale(4.34036 4.38486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint337_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7453 9.46475) scale(4.29799 4.34377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint338_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.742 9.45281) scale(4.25644 4.30347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint339_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.739 9.4551) scale(4.21671 4.26498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint340_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7378 9.44691) scale(4.17977 4.22928)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint341_radial_10834_56546",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7353 9.44208) scale(4.14796 4.19876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81D4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSh);
export default __webpack_public_path__ + "static/media/BankSh.31343b1b98520af093626ad37e5d7469.svg";
export { ForwardRef as ReactComponent };